import React, { useEffect } from 'react';
import 'moment/locale/es';
import Pagination from '@material-ui/lab/Pagination';
import Switch from '@material-ui/core/Switch';
import navOptionArrow from '../../../images/navOptionArrow.svg';
import editLogo from '../../../images/edit.svg';
import searchLogo from '../../../images/search.svg';
import trash from '../../../images/trash.svg';
import view from '../../../images/view.svg';
import cancel from '../../../images/cancel.svg';
import cancelWhite from '../../../images/cancel2.svg';
import add from '../../../images/add.svg';
import eye from '../../../images/eye.svg';
import darkArrow from '../../../images/darkArrow.svg';
import eyeOff from '../../../images/eye-off-outline.svg';
import offLogo from '../../../images/off.svg';
import onLogo from '../../../images/on.svg';
import renewLogo from '../../../images/renewLogo.svg';
import addToCart from '../../../images/addToCart.svg';
import removeFromCart from '../../../images/removeFromCart.svg';
import checkStatus from '../../../images/checkStatus.svg';
import copyLogo from '../../../images/copyImage.svg';
import close from '../../../images/close.svg';
import calendarGray from '../../../images/calendarGray.svg';
import authService from '../../../services/authService';
import grayCheckboxSelected from '../../../images/grayCheckboxSelected.svg';
import grayCheckboxUnselected from '../../../images/grayCheckboxUnselected.svg';
import { ActionButton, TableActionButton, AltButton, DisabledButton, DeleteButton } from '../Buttons/Buttons';
import { SelectPerPage } from '../Forms/Input/Input';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
  capitalize,
  exists,
  checkMissingVehicleFields,
  getMonthInSpanish,
  NaNtoNumber,
  sumTotal,
  disableCopyAndContextMenu,
  handleContextMenu,
  disableJustCopy,
  copyClipboard,
  filterOptionById,
  filterVehicleUse,
  validateRCVData,
  generateRandomKey,
  amountValdiationMessage,
  validateIfCanEditPayment,
  displayMembershipCode,
} from '../../../assets/helpers/funciones';
import {
  exportablesTypes,
  planStatus,
  fleetLoadPaymentStatus,
  paymentType,
  userType,
  MAX_PAYMENT_METHODS,
  paymentChancesEnum,
  membershipCodes,
  paymentMethods,
  rcvEnum,
  monthsComissionsOptions,
  campaignContact,
  banksOptions,
  situationOptions,
  getKmServiceOptions,
  planAllowsUnlimitedTow,
  isNewPlanRulesActive,
} from '../../../assets/helpers/options';
import { salesRoles, transcriptRoles } from '../../../assets/helpers/roles';
import moment from 'moment';
import { TableLoadSpinner } from '../../common/LoadSpinner/LoadSpinner';
import { serviceName, reasignTime } from '../../../assets/helpers/funciones';
import './Tables.scss';
import {
  TableCellActiveStatus,
  TableCellChildRecordsBadge,
  TableCellVehicularClassBadge,
  formatBelongsToHierarchy,
  TableSalesChannelLinksClassBadge,
  TableCellStatusIcon,
  TableCellActiveStatusDiscount,
  TableCellActiveStatusCampaign,
} from './TableCells/TableCells.jsx';
import {
  InputTable,
  EditAndSaveInput,
  ChangeAdvisorInput,
  ChangeCampaingActionsInput,
  ChangeSituationInput,
  TableFilter,
  TableTextFilter,
  TableDateFilter,
  Input,
  CheckboxTable,
  SelectTable,
} from '../Forms/Input/Input';
import { SiblingMembershipsLink } from '../../views/AffiliationsDB/Order/PaymentsCard';
import {
  DuepaymentsSection,
  FirstQuota,
  PendingQuotas,
  Duepayments,
  SalesTablePayment,
  PaymentChangesSection,
  PaymentChangesSectionMem,
  PaymentChangesSectionInitial,
  PaymentChangesSectionFirstQuota,
} from './TablesSections/TableSections';
const editURL = `/afiliations/edit-order`;

let cuentasPorCobrar = (d) => {
  if ([paymentType?.DIFERIDO, paymentType?.PENDING].includes(d?.paymentType)) {
    return `${d?.priceInfo?.finalPrice?.toFixed(2)} `;
  }
  if (d?.paymentType === paymentType?.FINANCIADO) {
    return `${d?.paymentDues[1]?.amount?.toFixed(2)} `;
  }

  if (d?.paymentType === paymentType?.CASHEA) {
    let amount = 0;

    for (let i = 0; i < d?.paymentDues?.length; i++) {
      if (!d?.paymentDues[i]?.paymentDate) {
        amount = amount + d?.paymentDues[i]?.amount;
      }
    }
    return `${amount?.toFixed(2)} `;
  } else return null;
};

let statusCuentasPorCobrar = (d) => {
  if (
    [
      paymentType?.PENDING,
      paymentType?.DIFERIDO,
      paymentType?.FINANCIADO,
      paymentType?.CASHEA,
    ].includes(d?.paymentType)
  ) {
    return `${d?.paymentStatus} `;
  } else return null;
};

export const Tables = (props) => {
  const { header, dataTable, handlePageChange, edit } = props;

  return (
    <>
      <div className="table-container">
        <table className="table">
          <tr>
            {header.map((h) => (
              <th key={h?.value}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: 'pointer' }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>

          {dataTable?.data.length > 0 &&
            !dataTable?.isLoading &&
            dataTable?.data.map((d) => (
              <tr key={d?._id}>
                <td>{capitalize(d?.invoiceName || d?.companyName)}</td>
                <td>{capitalize(d?.contactName)}</td>
                <td>{exists(d?.phonePrefix) + '-' + exists(d?.phoneNumber)}</td>
                <td>
                  {exists(d?.identificationType) +
                    ': ' +
                    exists(d?.identification)}
                </td>
                <td>{capitalize(d?.state)}</td>
                <td>{exists(d?.isActive)}</td>
                <td>
                  <div className="table-buttons-conatiner">
                    {/* <TableActionButton src={view} /> */}
                    <TableActionButton src={editLogo} action={() => edit(d)} />
                  </div>
                </td>
              </tr>
            ))}
        </table>
      </div>
      {dataTable?.isLoading && <TableLoadSpinner show={dataTable?.isLoading} />}
      {dataTable?.data.length <= 0 && !dataTable?.isLoading && (
        <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(dataTable?.count / dataTable?.limit)}
          variant="outlined"
          shape="rounded"
          page={dataTable?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const FleetsLoadTable = (props) => {
  const { header, data, showDetail } = props;
  return (
    <>
      <div className="table-container">
        <table className="table">
          <tr>
            {header.map((h) => (
              <th key={h?.value}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: 'pointer' }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>
          {data.map((d) => (
            <tr key={d?._id}>
              <td>{d?.id}</td>
              <td>{d?.name}</td>
              <td>{d?.code}</td>
              <td>
                <img src={checkStatus} alt="checkStatus" />
              </td>
              <td>{d?.load}</td>
              <td>{d?.modified}</td>
              <td>{d?.actions}</td>
              <td>
                <div className="table-buttons-conatiner">
                  <TableActionButton src={view} action={() => showDetail(d)} />
                  <TableActionButton src={editLogo} />
                </div>
              </td>
            </tr>
          ))}
        </table>
      </div>
      <div className="pagination-container">
        <Pagination
          count={5}
          variant="outlined"
          shape="rounded"
          page={1}
        //   onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const LoadTable = (props) => {
  const { header, data, openModal, showDetail } = props;
  return (
    <>
      <div className="table-container">
        <table className="table">
          <tr>
            {header.map((h) => (
              <th key={h?.value}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: 'pointer' }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>
          {data.map((d) => (
            <tr key={d?._id}>
              <td>{d?.name1}</td>
              <td>{d?.name2}</td>
              <td>{d?.name3}</td>
              <td>{d?.name4}</td>
              <td>
                <span
                  style={{
                    color: 'blue',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                  }}
                  onClick={() => openModal()}
                >
                  {d?.name5}
                </span>
              </td>
              <td>{d?.name6}</td>
              <td>{d?.name7}</td>
              <td>{d?.name8}</td>
              <td>{d?.name9}</td>
              <td>{d?.name10}</td>
              <td>
                {' '}
                <span
                  style={{
                    fontWeight: 'bold',
                    color: 'black',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                  }}
                  onClick={() => showDetail()}
                >
                  {' '}
                  Ver detalle
                </span>
              </td>
            </tr>
          ))}
        </table>
      </div>
      <div className="pagination-container">
        <Pagination
          count={5}
          variant="outlined"
          shape="rounded"
          page={1}
        //   onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const LoadDetailTable = (props) => {
  const { header, data, openModal, showDetail } = props;
  return (
    <>
      <div className="table-container">
        <table className="table">
          <tr>
            {header.map((h) => (
              <th key={h?.value}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: 'pointer' }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>
          {data.map((d) => (
            <tr key={d?._id}>
              <td>{d?.name1}</td>
              <td>{d?.name2}</td>
              <td>{d?.name3}</td>
              <td>{d?.name4}</td>
              <td>{d?.name5}</td>
              <td>{d?.name6}</td>
              <td>{d?.name7}</td>
              <td>{d?.name8}</td>
              <td>{d?.name9}</td>
              <td>{d?.name10}</td>
              <td>{d?.name11}</td>
            </tr>
          ))}
        </table>
      </div>
      <div className="pagination-container">
        <Pagination
          count={5}
          variant="outlined"
          shape="rounded"
          page={1}
        //   onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const HistoryPaymentTable = (props) => {
  const { header, data } = props;
  return (
    <>
      <div className="table-container">
        <table className="table">
          <tr>
            {header.map((h) => (
              <th key={h?.value}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: 'pointer' }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>
          {data.map((d) => (
            <tr key={d?._id}>
              <td>{d?.name1}</td>
              <td>{d?.name2}</td>
              <td>{d?.name3}</td>
              <td>{d?.name4}</td>
            </tr>
          ))}
        </table>
      </div>
      {/* <div className="pagination-container">
        <Pagination
          count={5}
          variant="outlined"
          shape="rounded"
          page={1}
          //   onChange={handlePageChange}
        />
      </div> */}
    </>
  );
};

export const UsersTable = (props) => {
  const { header, data } = props;
  return (
    <>
      <div className="table-container">
        <table className="table">
          <tr>
            {header.map((h) => (
              <th key={h?.value}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: 'pointer' }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>
          {data.map((d) => (
            <tr key={d?._id}>
              <td>{d?.name}</td>
              <td>{d?.email}</td>
              <td>{d?.profile}</td>
              <td>{d?.status}</td>
              <td>{d?.createdAt}</td>
              <td>{d?.editedAt}</td>
              <td>
                <div className="table-buttons-conatiner">
                  <TableActionButton src={view} />
                  <TableActionButton src={editLogo} />
                </div>
              </td>
            </tr>
          ))}
        </table>
      </div>
      <div className="pagination-container">
        <Pagination
          count={5}
          variant="outlined"
          shape="rounded"
          page={1}
        //   onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const FleetsTable = (props) => {
  const { header, data } = props;
  return (
    <>
      <div className="table-container">
        <table className="table">
          <tr>
            {header.map((h) => (
              <th key={h?.value}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: 'pointer' }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>
          {data.map((d) => (
            <tr key={d?._id}>
              <td>{d?.transport}</td>
              <td>{d?.model}</td>
              <td>{d?.brand}</td>
              <td>{d?.plate}</td>
              <td>{d?.year}</td>
              <td>{d?.purchaseDate}</td>
              <td>
                <div className="table-buttons-conatiner">
                  <TableActionButton src={view} />
                  <TableActionButton src={editLogo} />
                </div>
              </td>
            </tr>
          ))}
        </table>
      </div>
      <div className="pagination-container">
        <Pagination
          count={5}
          variant="outlined"
          shape="rounded"
          page={1}
        //   onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const ExportablesDBTable = (props) => {
  const { header, data, handlePageChange, type } = props;

  let displayPayment = '';
  return (
    <>
      <div className="table-container">
        <table className="table exportable-table">
          <tr
            style={{
              backgroundColor: '#fff',
            }}
          >
            {header?.map((h, i) => (
              <th key={h?.name + i} style={{ display: h?.hide ? 'none' : '' }}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: 'pointer' }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>
          {!type &&
            data?.data.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d, i) => (
              <tr key={d?.caseId}>
                <td>
                  {d?.user?.firstName} {d?.user?.lastName}
                </td>
                <td>{d?.caseId}</td>
                <td>{moment(d?.createdAt).format('DD/MM/YYYY')}</td>
                <td>{moment(d?.createdAt).format('LTS')}</td>
                <td>{d?.status}</td>
                <td>
                  {capitalize(d?.particularCustomer?.firstName) ||
                    capitalize(d?.membership?.customer?.firstName)}
                </td>
                <td>
                  {capitalize(d?.particularCustomer?.lastName) ||
                    capitalize(d?.membership?.customer?.lastName)}
                </td>{' '}
                <td>
                  {exists(d?.particularCustomer?.vehiclePlate) ||
                    exists(d?.membership?.vehicle?.plate)}
                </td>
                <td>
                  {capitalize(d?.particularCustomer?.vehicleBrand?.brand) ||
                    capitalize(d?.membership?.vehicle?.brand)}
                </td>{' '}
                <td>
                  {capitalize(d?.particularCustomer?.vehicleModel?.model) ||
                    capitalize(d?.membership?.vehicle?.model)}
                </td>{' '}
                <td>
                  {exists(d?.particularCustomer?.vehicleYear) ||
                    exists(d?.membership?.vehicle?.year)}
                </td>{' '}
                <td>{capitalize(d?.membership?.code)}</td>
                <td>{capitalize(d?.membership?.status)}</td>
                <td>{capitalize(d?.caseType)}</td>
                <td>{capitalize(d?.fault)}</td>
                <td>{capitalize(d?.realFault)}</td>
                <td>{capitalize(d?.originState)}</td>
                <td>{capitalize(d?.originCity)}</td>
                <td>{capitalize(d?.destinyState)}</td>
                <td>{capitalize(d?.destinyCity)}</td>
                {d?.services?.map((service, j) => {
                  return (
                    <>
                      <td style={{ display: displayPayment }}>
                        {serviceName(service?.productCode)}
                      </td>
                      <td style={{ display: displayPayment }}>
                        {service?.code}
                      </td>
                      <td style={{ display: displayPayment }}>
                        {service?.provider?.isInternal === true && 'Propia'}
                        {service?.provider?.isInternal === false && 'Externa'}
                      </td>
                      <td style={{ display: displayPayment }}>
                        {service?.provider?.contactName}
                      </td>{' '}
                      <td style={{ display: displayPayment }}>
                        {service?.shift}
                      </td>
                      <td style={{ display: displayPayment }}>
                        {service?.price ? service?.price + '$' : ''}{' '}
                      </td>
                      <td style={{ display: displayPayment }}>
                        {service?.pvp ? service?.pvp + '$' : ''}{' '}
                      </td>
                      <td style={{ display: displayPayment }}>
                        {service?.paymentStatus}
                      </td>
                      {service?.payments?.map((payment, k) => {
                        return (
                          <>
                            <td style={{ display: displayPayment }}>
                              {capitalize(payment?.method)}
                            </td>
                            <td style={{ display: displayPayment }}>
                              {payment?.totalAmount
                                ? payment?.totalAmount + '$'
                                : ''}
                            </td>
                            <td style={{ display: displayPayment }}>
                              {payment?.reference}
                            </td>
                            <td style={{ display: displayPayment }}>
                              {payment?.referenceImg && (
                                <a
                                  target="_blank"
                                  href={payment?.referenceImg}
                                  rel="noreferrer"
                                >
                                  Comprobante de pago
                                </a>
                              )}
                            </td>
                          </>
                        );
                      })}
                    </>
                  );
                })}
                {d?.newStages?.map((stage, i) => {
                  return <td>{reasignTime(d, i)}</td>;
                })}
                <td>
                  {d?.services?.map((service, j) => {
                    if (service?.avImage) {
                      return (
                        <a
                          target="_blank"
                          href={service?.avImage}
                          rel="noreferrer"
                        >
                          Imagen AV
                        </a>
                      );
                    }
                  })}
                </td>
                <td>
                  {d?.services?.map((service, j) => {
                    if (service?.towImages?.towAtOrigin) {
                      return (
                        <a
                          target="_blank"
                          href={service?.towImages?.towAtOrigin}
                          rel="noreferrer"
                        >
                          Gruero en origen
                        </a>
                      );
                    }
                  })}
                </td>
                <td>
                  {d?.services?.map((service, j) => {
                    if (service?.towImages?.vehicleOnTow) {
                      return (
                        <a
                          target="_blank"
                          href={service?.towImages?.vehicleOnTow}
                          rel="noreferrer"
                        >
                          Vehículo en grúa
                        </a>
                      );
                    }
                  })}
                </td>
                <td>
                  {d?.services?.map((service, j) => {
                    if (service?.towImages?.vehicleOnRoad) {
                      return (
                        <a
                          target="_blank"
                          href={service?.towImages?.vehicleOnRoad}
                          rel="noreferrer"
                        >
                          Vehículo en destino
                        </a>
                      );
                    }
                  })}
                </td>
              </tr>
            ))}
        </table>

        <PrintBDTable
          data={data}
          header={header}
          displayPayment={''}
          type={type}
        />
      </div>
      {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      {data?.data.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const PaymentType = (props) => {
  const { payment, membership } = props;

  let quotaCounter = 0;
  let paymentCounter = 0;

  // Return Quota and Payment Number if Financed payment
  for (let i = 0; i < membership?.paymentDues?.length; i++) {
    if (membership?.paymentDues[i]) {
      quotaCounter = quotaCounter + 1;

      for (let j = 0; j < membership?.paymentDues[i]?.payment?.length; j++) {
        paymentCounter = paymentCounter + 1;

        if (payment?._id === membership?.paymentDues[i]?.payment[j]) {
          if (i === 0) {
            return `Cuota Inicial - Pago ${j + 1} `;
          }
          return `Cuota ${i} - Pago ${j + 1} `;
        }
      }
    }
  }
  // Pago upgrade
  if (payment?.upgrade) {
    return `Pago Upgrade`;
  }
  // Membership payment
  for (let k = 0; k < membership?.payments.length; k++) {
    if (payment?._id === membership?.payments[k]?._id) {
      return `Pago ${k + 1} `;
    }
  }
};

export const CashTable = (props) => {
  const { membership, header, data, handleEditChangeModal } = props;

  const calculateTotal = (payment, type) => {
    let total = 0;

    for (let i = 0; i < payment?.length; i++) {
      total = total + payment[i][type];
    }
    return total?.toFixed(2);
  };

  if (membership?.payments?.length === 0) {
    return null;
  } else {
    return (
      <>
        <h6 style={{ marginTop: '12px' }}>Vueltos Realizados</h6>
        <div className="table-container">
          <table className="table payments-table">
            <tr>
              {header?.map((h, i) => (
                <th
                  key={h?.name + i}
                  style={{ display: h?.hide ? 'none' : '' }}
                >
                  {h?.name}
                </th>
              ))}
            </tr>
            {membership?.paymentChanges?.length > 0 &&
              !data?.isLoading &&
              membership?.paymentChanges?.map((d, i) => (
                <tr key={d?.caseId}>
                  <td>{`Vuelto ${i + 1}`}</td>
                  <td>{d?.amount}</td>
                  <td>{d?.amountBs}</td>
                  <td>{capitalize(d?.methodDesc)}</td>
                  <td>{d?.ref}</td>
                  <td>
                    {d?.bank ? (
                      <div>
                        <h6 style={{ fontSize: '12px' }}>
                          <b>Banco:</b>{' '}
                          {
                            banksOptions?.find(
                              (option) => option._id === d?.bank
                            )?.name
                          }
                        </h6>
                        <h6 style={{ fontSize: '12px' }}>
                          <b>Telefono:</b> {d?.phone}
                        </h6>
                        <h6 style={{ fontSize: '12px' }}>
                          <b>CI/RIF:</b>{' '}
                          {d?.identificationType + '-' + d?.identification}
                        </h6>
                      </div>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {d?.referenceImg && (
                      <a
                        style={{ padding: '0px' }}
                        target="_blank"
                        href={d?.referenceImg}
                        rel="noreferrer"
                      >
                        Ver Comprobante
                      </a>
                    )}
                  </td>
                  <td>{d?.date ? moment(d?.date).format('DD/MM/YYYY') : ''}</td>
                  <td>{d?.observation}</td>
                  <td>
                    {[
                      salesRoles?.SALES_ADMIN,
                      salesRoles?.SALES_ADMIN_AUX,
                      salesRoles?.SALES_HUNTER,
                      salesRoles?.SALES_FARMER,
                      salesRoles?.SALES_KEY_ACCOUNTS,
                    ]?.includes(authService?.getUserType()) && (
                        <ActionButton
                          label={'Editar'}
                          action={() => handleEditChangeModal(d, membership)}
                        />
                      )}
                  </td>
                </tr>
              ))}
            <tr>
              <td>
                <b style={{ fontSize: '14px' }}>Total</b>
              </td>
              <td>
                <b style={{ fontSize: '14px' }}>
                  {calculateTotal(membership?.paymentChanges, 'amount')}
                </b>
              </td>
              <td>
                <b style={{ fontSize: '14px' }}>
                  {calculateTotal(membership?.paymentChanges, 'amountBs')}
                </b>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </table>
        </div>
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </>
    );
  }
};

export const PaymentsTable = (props) => {
  const { role, membership, header, data, handleEditPaymentModal } = props;

  const validatePaymentButton = (
    role,
    handleEditPaymentModal,
    d,
    membership
  ) => {
    if (d?.createdAt) {
      if (validateIfCanEditPayment(membership, d, role)) {
        return (
          <ActionButton
            label="Editar"
            action={() => handleEditPaymentModal(d)}
          />
        );
      }
    }
  };

  const calculateTotal = (payment, type) => {
    let total = 0;

    for (let i = 0; i < payment?.length; i++) {
      total = total + payment[i][type];
      if (payment[i]?.igtf && type !== 'totalAmountInBsS') {
        total = total + payment[i]?.igtfAmount;
      }
    }
    return total?.toFixed(2);
  };

  const findReferenceCashea = (payments) => {
    if (!payments || !Array.isArray(payments)) {
      return '';
    }

    const foundPayment = payments.find(
      (payment) =>
        payment.referenceCashea !== undefined &&
        (payment.upgrade === false || payment.reason !== 'rcv')
    );

    return foundPayment ? foundPayment.referenceCashea : '';
  };

  if (membership?.payments?.length === 0) {
    return null;
  } else {
    return (
      <>
        <h6 style={{ marginTop: '12px' }}>Pagos Realizados</h6>
        <div className="table-container">
          <table className="table payments-table">
            <tr>
              {header?.map((h, i) => (
                <th
                  key={h?.name + i}
                  style={{ display: h?.hide ? 'none' : '' }}
                >
                  {h?.name}
                </th>
              ))}
            </tr>
            {membership?.payments.length > 0 &&
              !data?.isLoading &&
              membership?.payments?.map((d, i) => (
                <tr key={d?.caseId}>
                  <td>
                    <PaymentType payment={d} membership={membership} />
                    {/* Pago {i + 1} */}
                  </td>
                  <td>
                    {(d?.totalAmount + NaNtoNumber(d?.igtfAmount))?.toFixed(2)}
                  </td>
                  <td>{d?.totalAmountInBsS?.toFixed(2)}</td>
                  <td>{capitalize(d?.method)}</td>
                  <td>
                    {d?.status}
                    {d?.statusDetail ? ` - ${d?.statusDetail}` : ''}
                  </td>
                  <td>{d?.paymentType}</td>
                  <td>{d?.reference}</td>
                  <td>{d?.transactionBatch || ''}</td>
                  <td>
                    {d?.accHolder && d?.accHolder !== 'undefined'
                      ? d?.accHolder
                      : ''}
                  </td>
                  <td>{d?.cashReceiver || ''}</td>
                  {[paymentType.CASHEA, paymentType.CASHEA_LINK].includes(
                    membership?.paymentType
                  ) && (
                      <td>
                        {d.upgrade === true || d.reason === 'rcv'
                          ? ''
                          : findReferenceCashea(membership?.payments)}
                      </td>
                    )}
                  <td>
                    {d?.referenceImg && (
                      <a
                        style={{ padding: '0px' }}
                        target="_blank"
                        href={d?.referenceImg}
                        rel="noreferrer"
                      >
                        Ver Comprobante
                      </a>
                    )}
                  </td>
                  <td>
                    {d?.createdAt
                      ? moment(d?.createdAt).format('DD/MM/YYYY')
                      : ''}
                  </td>
                  <td>
                    {membership.siblingMemberships.map((m, i) => (
                      <SiblingMembershipsLink
                        membership={m}
                        last={i === membership.siblingMemberships.length - 1}
                      />
                    ))}
                  </td>
                  <td>{d?.observation}</td>
                  <td>
                    {validatePaymentButton(
                      role,
                      handleEditPaymentModal,
                      d,
                      membership
                    )}
                  </td>
                </tr>
              ))}
            <tr>
              <td>
                <b style={{ fontSize: '14px' }}>Total</b>
              </td>
              <td>
                <b style={{ fontSize: '14px' }}>
                  {calculateTotal(membership?.payments, 'totalAmount')}
                </b>
              </td>
              <td>
                <b style={{ fontSize: '14px' }}>
                  {calculateTotal(membership?.payments, 'totalAmountInBsS')}
                </b>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </table>
        </div>
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </>
    );
  }
};

export const PendingPaymentsTable = (props) => {
  const {
    membership,
    header,
    data,
    dollarRate,
    openMembershipPendingPaymentModal,
    handleOpenEditPaymentDueModal,
  } = props;

  const checkIfPending = (pending) => {
    let paid = 0;
    for (let i = 0; i < pending.length; i++) {
      if (pending[i]?.paymentDate) {
        paid = paid + 1;
      }
    }
    if (paid === pending.length) {
      return true;
    } else return false;
  };

  if (
    [paymentType?.DIFERIDO, paymentType?.PENDING].includes(
      membership?.paymentType
    ) &&
    membership?.paymentStatus !== fleetLoadPaymentStatus?.PAID
  ) {
    return (
      <div className="table-container">
        <table className="table payments-table">
          <tr>
            {header?.map((h, i) => (
              <th key={h?.name + i} style={{ display: h?.hide ? 'none' : '' }}>
                {h?.name}
              </th>
            ))}
          </tr>
          <tr>
            <td>Diferido (Excepción)</td>
            <td>{membership?.priceInfo?.finalPrice}</td>
            <td>{membership?.priceInfo?.finalPriceInBsS}</td>
            <td>{membership?.paymentStatus}</td>
            <td></td>
            <td>
              {membership.siblingMemberships.map((m, i) => (
                <SiblingMembershipsLink
                  membership={m}
                  last={i === membership.siblingMemberships.length - 1}
                />
              ))}
            </td>
            <td>
              <ActionButton
                label="Realizar pago pendiente"
                action={() => openMembershipPendingPaymentModal()}
              />
            </td>
          </tr>
        </table>
      </div>
    );
  }

  if (
    [paymentType?.CASHEA, paymentType?.CASHEA_LINK, paymentType?.VENFLOW].includes(
      membership?.paymentType
    ) &&
    !membership?.mainMembership
  ) {
    const isCasheaWithRef =
      [paymentType?.CASHEA, paymentType?.CASHEA_LINK].includes(
        membership?.paymentType
      ) && membership?.casheaRef;
    return (
      <>
        <div
          style={{ display: 'flex', marginTop: '12px', marginBottom: '12px' }}
        >
          <h6 style={{ marginRight: '12px', marginTop: '8px' }}>
            Pagos Pendientes
          </h6>
        </div>
        <div className="table-container">
          <table className="table payments-table">
            <tr>
              {header?.map((h, i) => (
                <th
                  key={h?.name + i}
                  style={{
                    display: h?.hide || (h?.isOnlyCashea && !isCasheaWithRef) ? 'none' : '',
                  }}
                >
                  {h?.name}
                </th>
              ))}
            </tr>
            <tr key={'pending-cashea'}>
              <td>{membership?.paymentType === paymentType?.VENFLOW ? 'Deuda Venflow' : 'Deuda Cashea'}</td>
              <td>{membership?.pendingToPay}</td>
              <td>{(membership?.pendingToPay * dollarRate)?.toFixed(2)}</td>
              <td>Cuenta por cobrar</td>
              <td>
                {membership?.duesLastDate
                  ? moment(membership?.duesLastDate).format('DD/MM/YYYY')
                  : ''}
              </td>
              {isCasheaWithRef && <td>{membership?.casheaRef}</td>}
              <td>
                {membership.siblingMemberships.map((m, i) => (
                  <SiblingMembershipsLink
                    membership={m}
                    last={i === membership.siblingMemberships.length - 1}
                  />
                ))}
              </td>
              <td>
                <ActionButton
                  label="Realizar pago pendiente"
                  action={() => openMembershipPendingPaymentModal()}
                />
              </td>
            </tr>
          </table>
        </div>
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </>
    );
  }

  if (
    membership?.paymentDues?.length === 0 ||
    checkIfPending(membership?.paymentDues)
  ) {
    return null;
  } else {
    return (
      <>
        <div
          style={{ display: 'flex', marginTop: '12px', marginBottom: '12px' }}
        >
          <h6 style={{ marginRight: '12px', marginTop: '8px' }}>
            Pagos Pendientes
          </h6>
          {[paymentType.CASHEA, paymentType.CASHEA_LINK].includes(
            membership.paymentType
          ) &&
            authService.getUser()?.type !== userType.EXTERNO && (
              <ActionButton
                label="Editar cuotas"
                action={handleOpenEditPaymentDueModal}
              />
            )}
        </div>
        <div className="table-container">
          <table className="table payments-table">
            <tr>
              {header?.map((h, i) => (
                <th
                  key={h?.name + i}
                  style={{ display: h?.hide ? 'none' : '' }}
                >
                  {h?.name}
                </th>
              ))}
            </tr>
            {membership?.paymentDues?.length > 0 &&
              !data?.isLoading &&
              membership?.paymentDues?.map((d, i) => {
                if (!d?.paymentDate)
                  return (
                    <tr key={d?.caseId}>
                      <td>{i === 0 ? 'Cuota Inicial' : `Cuota ${i}`}</td>
                      <td>{d?.amount?.toFixed(2)}</td>
                      <td>{(d?.amount * dollarRate)?.toFixed(2)}</td>
                      <td>Cuenta por cobrar</td>
                      <td>
                        {d?.dueDate
                          ? moment(d?.dueDate).format('DD/MM/YYYY')
                          : ''}
                      </td>
                      <td>
                        {membership.siblingMemberships.map((m, i) => (
                          <SiblingMembershipsLink
                            membership={m}
                            last={
                              i === membership.siblingMemberships.length - 1
                            }
                          />
                        ))}
                      </td>
                      <td>
                        <ActionButton
                          label="Realizar pago pendiente"
                          action={() => openMembershipPendingPaymentModal(i)}
                        />
                      </td>
                    </tr>
                  );
              })}
          </table>
        </div>
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </>
    );
  }
};

export const PrintBDTable = (props) => {
  const { data, header, displayPayment, type } = props;

  let newHeader = header?.filter((h) => !h?.hidePrint);

  return (
    <table style={{ display: 'none' }} className="table exportable-table">
      <tr>
        {newHeader?.map((h, i) => (
          <th key={h?.name + i} style={{ display: h?.hide ? 'none' : '' }}>
            {h?.name}
            {h?.sortable && (
              <img
                style={{ cursor: 'pointer' }}
                src={navOptionArrow}
                alt="immage"
              ></img>
            )}
          </th>
        ))}
      </tr>
      {!type &&
        data?.data.length > 0 &&
        !data?.isLoading &&
        data?.data?.map((d, i) => (
          <tr key={d?.caseId}>
            <td>
              {d?.user?.firstName} {d?.user?.lastName}
            </td>
            <td>{d?.caseId}</td>
            <td>{moment(d?.createdAt).format('DD/MM/YYYY')}</td>
            <td>{moment(d?.createdAt).format('LTS')}</td>
            <td>{d?.status}</td>
            <td>
              {capitalize(d?.particularCustomer?.firstName) ||
                capitalize(d?.membership?.customer?.firstName)}
            </td>
            <td>
              {capitalize(d?.particularCustomer?.lastName) ||
                capitalize(d?.membership?.customer?.lastName)}
            </td>{' '}
            <td>
              {exists(d?.particularCustomer?.vehiclePlate) ||
                exists(d?.membership?.vehicle?.plate)}
            </td>
            <td>
              {capitalize(d?.particularCustomer?.vehicleBrand?.brand) ||
                capitalize(d?.membership?.vehicle?.brand)}
            </td>{' '}
            <td>
              {capitalize(d?.particularCustomer?.vehicleModel?.model) ||
                capitalize(d?.membership?.vehicle?.model)}
            </td>{' '}
            <td>
              {exists(d?.particularCustomer?.vehicleYear) ||
                exists(d?.membership?.vehicle?.year)}
            </td>{' '}
            <td>{capitalize(d?.membership?.code)}</td>
            <td>{capitalize(d?.membership?.status)}</td>
            <td>{capitalize(d?.caseType)}</td>
            <td>{capitalize(d?.fault)}</td>
            <td>{capitalize(d?.realFault)}</td>
            <td>{capitalize(d?.originState)}</td>
            <td>{capitalize(d?.originCity)}</td>
            <td>{capitalize(d?.destinyState)}</td>
            <td>{capitalize(d?.destinyCity)}</td>
            {d?.services?.map((service, j) => {
              return (
                <>
                  <td style={{ display: displayPayment }}>
                    {serviceName(service?.productCode)}
                  </td>
                  <td style={{ display: displayPayment }}>{service?.code}</td>
                  <td style={{ display: displayPayment }}>
                    {service?.provider?.isInternal === true && 'Propia'}
                    {service?.provider?.isInternal === false && 'Externa'}
                  </td>
                  <td style={{ display: displayPayment }}>
                    {service?.provider?.contactName}
                  </td>
                  <td style={{ display: displayPayment }}>{service?.shift}</td>
                  <td style={{ display: displayPayment }}>
                    {service?.price ? service?.price + '$' : ''}{' '}
                  </td>
                  <td style={{ display: displayPayment }}>
                    {service?.pvp ? service?.pvp + '$' : ''}{' '}
                  </td>
                  <td style={{ display: displayPayment }}>
                    {service?.paymentStatus}
                  </td>
                  {service?.payments?.map((payment, k) => {
                    return (
                      <>
                        <td style={{ display: displayPayment }}>
                          {capitalize(payment?.method)}
                        </td>
                        <td style={{ display: displayPayment }}>
                          {payment?.totalAmount
                            ? payment?.totalAmount + '$'
                            : ''}
                        </td>
                        <td style={{ display: displayPayment }}>
                          {payment?.reference}
                        </td>
                      </>
                    );
                  })}
                </>
              );
            })}
            {d?.newStages?.map((stage, i) => {
              return <td>{reasignTime(d, i)}</td>;
            })}
          </tr>
        ))}
    </table>
  );
};

export const ExportablesPaymentTable = (props) => {
  const { header, data, handlePageChange, type } = props;
  return (
    <>
      <div className="table-container">
        <table className="table exportable-table">
          <tr>
            {header?.map((h) => (
              <th key={h?.name}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: 'pointer' }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>
          {[
            exportablesTypes?.PAYMENT_AV,
            exportablesTypes?.PAYMETN_INTERNAL_TOW,
            exportablesTypes?.PAYMENT_EXTERNAL_TOW,
          ].includes(type) &&
            data?.data.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => (
              <tr key={d?._id}>
                <td>{capitalize(d?.providerName)}</td>
                <td>{moment(d?.createdAt).format('DD/MM/YYYY')}</td>
                <td>{capitalize(d?.product)}</td>
                <td>{capitalize(d?.caseType)}</td>
                <td>{exists(d?.code)}</td>
                <td>{exists(d?.plate)}</td>
                <td>{capitalize(d?.vehicleBrand)}</td>
                <td>{capitalize(d?.originState)}</td>
                <td>{capitalize(d?.originCity)}</td>
                <td>{exists(d?.price?.toFixed(2))}$</td>
                <td>{exists(d?.providerPay?.toFixed(2))}$</td>
              </tr>
            ))}
        </table>
      </div>
      {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      {data?.data.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const ProvidersTable = (props) => {
  const {
    externalHeader,
    internalHeader,
    data,
    assignTow,
    handlePageChange,
    internal,
  } = props;

  return (
    <>
      <div className="table-container">
        <table className="table">
          <tr>
            {internal ? (
              <>
                {internalHeader.map((h) => (
                  <th key={h?.value}>
                    {h?.name}
                    {h?.sortable && (
                      <img
                        style={{ cursor: 'pointer' }}
                        src={navOptionArrow}
                      ></img>
                    )}
                  </th>
                ))}
              </>
            ) : (
              <>
                {externalHeader.map((h) => (
                  <th key={h?.value}>
                    {h?.name}
                    {h?.sortable && (
                      <img
                        style={{ cursor: 'pointer' }}
                        src={navOptionArrow}
                        alt="immage"
                      ></img>
                    )}
                  </th>
                ))}
              </>
            )}
          </tr>
          {data?.data?.map((d) => (
            <tr key={d?._id}>
              <td>
                <img
                  onClick={() => assignTow(d)}
                  style={{ cursor: 'pointer' }}
                  src={add}
                  alt="add"
                />
              </td>
              {!internal && <td>{capitalize(d?.companyName)}</td>}
              <td>{capitalize(d?.contactName)}</td>
              <td>{exists(d?.phonePrefix) + '-' + exists(d?.phoneNumber)}</td>
              <td>
                {exists(d?.identificationType) +
                  ': ' +
                  exists(d?.identification)}
              </td>

              <td>{capitalize(d?.state)}</td>
              <td>{d?.isActive}</td>
            </tr>
          ))}
        </table>
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const InternalProviderTable = (props) => {
  const { header, dataTable, handlePageChange, edit } = props;
  return (
    <>
      <div className="table-container">
        <table className="table">
          <tr>
            {header.map((h) => (
              <th key={h?.value}>
                {h?.name}
                {h?.sortable && (
                  <img
                    style={{ cursor: 'pointer' }}
                    src={navOptionArrow}
                    alt="immage"
                  ></img>
                )}
              </th>
            ))}
          </tr>
          {dataTable?.data.length > 0 &&
            !dataTable?.isLoading &&
            dataTable?.data.map((d) => (
              <tr key={d?._id}>
                <td>{capitalize(d?.contactName)}</td>
                <td>{capitalize(d?.type)}</td>
                <td>{exists(d?.phonePrefix) + '-' + exists(d?.phoneNumber)}</td>
                <td>
                  {exists(d?.identificationType) +
                    ': ' +
                    exists(d?.identification)}
                </td>
                <td>{capitalize(d?.state)}</td>
                <td>{exists(d?.isActive)}</td>
                <td>
                  <div className="table-buttons-conatiner">
                    {/* <TableActionButton src={view} /> */}
                    <TableActionButton src={editLogo} action={() => edit(d)} />
                  </div>
                </td>
              </tr>
            ))}
        </table>
      </div>
      {dataTable?.isLoading && <TableLoadSpinner show={dataTable?.isLoading} />}
      {dataTable?.data.length <= 0 && !dataTable?.isLoading && (
        <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(dataTable?.count / dataTable?.limit)}
          variant="outlined"
          shape="rounded"
          page={dataTable?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const VehicularAssetsTable = (props) => {
  const { header, dataTable, handlePageChange, edit } = props;
  return (
    <>
      <div className="table-container">
        <table className="table">
          <tr>
            {header.map((h) => (
              <th key={h?.value}>
                {h?.name}
                {h?.sortable && (
                  <img
                    style={{ cursor: 'pointer' }}
                    src={navOptionArrow}
                    alt="immage"
                  ></img>
                )}
              </th>
            ))}
          </tr>
          {dataTable?.data.length > 0 &&
            !dataTable?.isLoading &&
            dataTable?.data.map((d) => (
              <tr key={d?._id}>
                <td>{capitalize(d?.class)}</td>
                <td>{capitalize(d?.brand)}</td>
                <td>{capitalize(d?.model)}</td>
                <td>{capitalize(d?.color)}</td>
                <td>{exists(d?.plate)}</td>
                <td>{exists(d?.year)}</td>
                <td>
                  {d?.purchaseDate
                    ? moment(d?.purchaseDate).format('DD/MM/YYYY')
                    : ''}
                </td>
                <td>{exists(d?.description)}</td>
                <td>
                  <div className="table-buttons-conatiner">
                    {/* <TableActionButton src={view} /> */}
                    <TableActionButton src={editLogo} action={() => edit(d)} />
                  </div>
                </td>
              </tr>
            ))}
        </table>
      </div>
      {dataTable?.isLoading && <TableLoadSpinner show={dataTable?.isLoading} />}
      {dataTable?.data.length <= 0 && !dataTable?.isLoading && (
        <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(dataTable?.count / dataTable?.limit)}
          variant="outlined"
          shape="rounded"
          page={dataTable?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const IncidenceTable = (props) => {
  const { header, data, title } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="incidence-table table">
          <tr>
            {header.map((h) => (
              <th key={h?.value}>{h?.name}</th>
            ))}
          </tr>
          {data?.map((d) => (
            <tr key={d?._id}>
              <td>
                {d?.createdAt ? moment(d?.createdAt).format('DD/MM/YYYY') : ''}
              </td>
              <td>{capitalize(d?.fault)}</td>
              <td>{capitalize(d?.service)}</td>
              <td>{d?.serviceKm ? d?.serviceKm + ' Km' : 'N/A'}</td>
            </tr>
          ))}
        </table>
        {data?.length <= 0 && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
    </>
  );
};

export const FollowingTable = (props) => {
  const { header, data, title } = props;

  return (
    <div className="incidence-table-section-container">
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="incidence-table table">
          <tr>
            {header.map((h) => (
              <th key={h?.value}>{h?.name}</th>
            ))}
          </tr>
          {data?.map((d) => (
            <tr key={d?._id}>
              <td>{moment(d?.createdAt).format('DD/MM/YYYY')}</td>
              <td>{moment(d?.createdAt).format('LTS')}</td>
              <td>{exists(d?.stage)}</td>
              <td>{d?.type}</td>
              <td>{exists(d?.message)}</td>
              <td>{exists(d?.note)}</td>
            </tr>
          ))}
        </table>
        {data?.length <= 0 && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
    </div>
  );
};

export const OperationsUserTable = (props) => {
  const { header, data, title, handlePageChange, handleEditFleetForm } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="table">
          <tr>
            {header?.map((h) => (
              <th key={h?.name}>{h?.name}</th>
            ))}
          </tr>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => {
              return (
                <tr key={d?._id}>
                  <td>
                    {d?.firstName} {d?.lastName}
                  </td>
                  <td>{d?.email}</td>
                  <td>{transcriptRoles(d?.role)}</td>
                  <td>{d?.status}</td>
                  <td>{moment(d?.createdAt).format('DD/MM/YYYY')}</td>
                  <td>{moment(d?.updatedAt).format('DD/MM/YYYY')}</td>

                  <td>
                    <div className="table-buttons-conatiner">
                      <TableActionButton
                        src={editLogo}
                        action={() => handleEditFleetForm(d)}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
        </table>
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

// export const SalesUserTable = (props) => {
//   const {
//     header,
//     data,
//     title,
//     handlePageChange,
//     openDetail,
//
//     handleEditFleetForm,
//   } = props;

//   return (
//     <>
//       <div className="filter-button-container"></div>
//       <div className="title-center-component">
//         <h5>{title}</h5>
//       </div>
//       <div className="table-container">
//         <table  className="table">
//           <tr>
//             {header?.map((h) => (
//               <th key={h?.name}>{h?.name}</th>
//             ))}
//           </tr>
//           {data?.data?.length > 0 &&
//             !data?.isLoading &&
//             data?.data?.map((d) => {
//               return (
//                 <tr key={d?._id}>
//                   <td>
//                     {d?.firstName} {d?.lastName}
//                   </td>
//                   <td>{d?.email}</td>
//                   <td>{transcriptRoles(d?.role)}</td>
//                   <td>{d?.status}</td>
//                   <td>{moment(d?.createdAt).format('DD/MM/YYYY')}</td>
//                   <td>{moment(d?.updatedAt).format('DD/MM/YYYY')}</td>

//                   <td>
//                     <div className="table-buttons-conatiner">
//                       <TableActionButton
//                         src={editLogo}
//                         action={() => handleEditFleetForm(d)}
//                       />
//                     </div>
//                   </td>
//                 </tr>
//               );
//             })}
//         </table>
//         {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
//         {data?.data.length <= 0 && !data?.isLoading && (
//           <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
//         )}
//       </div>
//       <div className="pagination-container">
//         <Pagination
//           count={Math.ceil(data?.count / data?.limit)}
//           variant="outlined"
//           shape="rounded"
//           page={data?.page}
//           onChange={handlePageChange}
//         />
//       </div>
//     </>
//   );
// };

export const TrazeTable = (props) => {
  const { header, data, title } = props;

  return (
    <div className="incidence-table-section-container">
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="incidence-table table">
          <tr>
            {header.map((h) => (
              <th key={h?.value}>{h?.name}</th>
            ))}
          </tr>
          {data?.map((d) => (
            <tr key={d?._id}>
              <td>{moment(d?.createdAt).format('DD/MM/YYYY')}</td>
              <td>{moment(d?.createdAt).format('LTS')}</td>
              <td>{d?.stage?.stage}</td>
              <td>{d?.estimatedTime}</td>
            </tr>
          ))}
        </table>
        {data?.length <= 0 && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
    </div>
  );
};

export const PotentialClientsDataTable = (props) => {
  const { data, updateFromGrid } = props;

  return (
    <>
      {data?.data?.length > 0 &&
        !data?.isLoading &&
        data?.data?.map((d) => {
          return (
            <tr key={d?._id}>
              <td>{capitalize(d?.fullName)}</td>
              {data?.type !== 'Particular' && <td>{d?.identification}</td>}
              <td>{d?.phoneNumber}</td>
              <td>
                {d?.eventDate ? moment(d?.eventDate).format('DD/MM/YYYY') : ''}
              </td>
              {data?.type !== 'Incompleta' && <td>{capitalize(d?.city)}</td>}
              <td>
                {data?.type === 'Incompleta'
                  ? capitalize(d?.salesChannel?.name) || 'Página web'
                  : capitalize(d?.salesChannel?.name)}
              </td>
              {data?.type === 'Particular' && (
                <td>{capitalize(d?.serviceType)}</td>
              )}
              {['Particular', 'Free'].includes(data?.type) && (
                <td>{d?.plate}</td>
              )}
              <td>{d?.isAffiliated ? 'Sí' : 'No'}</td>
              <td>{d?.isAffiliated ? d?.membershipId : ''}</td>
              <td>
                {d?.isAffiliated && d?.createdAt
                  ? moment(d?.createdAt).format('DD/MM/YYYY')
                  : ''}
              </td>
              <td>
                {d?.isAffiliated ? capitalize(d?.status?.description) : ''}
              </td>
              <td>
                {d?.isAffiliated
                  ? capitalize(d?.saleChannel?.description)
                  : ''}
              </td>
              <td>
                {d?.isAffiliated ? capitalize(d?.seller?.description) : ''}
              </td>
              <td>
                {d?.isAffiliated ? capitalize(d?.plan?.description) : ''}
              </td>
              <td>
                {d?.isAffiliated && d?.finalPrice ? `$${d?.finalPrice}` : ''}
              </td>
              {data?.type !== 'Pap' && (
                <td>
                  <ChangeCampaingActionsInput
                    list={campaignContact}
                    initialValue={d?.campaignAction}
                    placeholder={d?.campaignAction}
                    saveAction={updateFromGrid}
                    id={d?._id}
                  />
                </td>
              )}
              {data?.type !== 'Incompleta' && (
                <td>
                  <ChangeSituationInput
                    list={situationOptions}
                    initialValue={d?.situation}
                    placeholder={d?.situation}
                    saveAction={updateFromGrid}
                    id={d?._id}
                  />
                </td>
              )}
            </tr>
          );
        })}
    </>
  );
};

export const SalesMembershipContentTable = (props) => {
  const { data, redirectToOrderDetail, print } = props;

  const PaymentColumnsRCV = (props) => {
    const { payment, index } = props;

    let payments = [];

    Array.from({ length: 2 }).forEach((_, index) =>
      payments.push({
        totalAmount: payment[`payRcv${index + 1}Amount`] || '',
        totalAmountInBsS: payment[`payRcv${index + 1}AmountBs`] || '',
        method: payment[`payRcv${index + 1}Method`] || '',
        reference: payment[`payRcv${index + 1}Ref`] || '',
        accHolder: payment[`payRcv${index + 1}AccHolder`] || '',
        createdAt: payment[`payRcv${index + 1}Date`] || '',
      })
    );

    return (
      <>
        <td>{!payments[index]?.upgrade ? payments[index]?.totalAmount : ''}</td>
        <td>
          {!payments[index]?.upgrade ? payments[index]?.totalAmountInBsS : ''}
        </td>
        <td>
          {!payments[index]?.upgrade ? capitalize(payments[index]?.method) : ''}
        </td>
        <td>{!payments[index]?.upgrade ? payments[index]?.reference : ''}</td>
        <td>{!payments[index]?.upgrade ? payments[index]?.accHolder : ''}</td>
        <td>
          {!payments[index]?.upgrade && payments[index]?.createdAt
            ? moment(payments[index]?.createdAt).format('DD/MM/YYYY')
            : ''}
        </td>
      </>
    );
  };

  return (
    <>
      {data?.data?.length > 0 &&
        !data?.isLoading &&
        data?.data?.map((d) => {
          return (
            <tr
              key={d?._id}
              className={`${d?.membershipCode?.includes('f2') ||
                d?.membershipCode?.includes('f4')
                ? 'missing-properties'
                : ''
                }`}
            >
              {!print ? (
                <td data-column="action">
                  <div className="table-buttons-conatiner">
                    <TableActionButton
                      src={searchLogo}
                      action={() => redirectToOrderDetail(d)}
                    />
                    <a href={`${editURL}/${d?._id}`}>
                      <div className="table-action-button">
                        <img target="_blank" src={editLogo} alt="editLogo" />
                      </div>
                    </a>
                  </div>
                </td>
              ) : null}
              <td>{d?.membershipId}</td>
              <td>{d?.associatedMemberships}</td>
              <td>{d?.createdAt}</td>
              <td>{capitalize(d?.seller)}</td>
              <td>{d?.saleChannel}</td>
              <td>{d?.event}</td>
              <td>{capitalize(displayMembershipCode(d?.membershipCode))}</td>
              <td>{capitalize(d?.membershipStatus)}</td>
              <td>{capitalize(d?.affiliationType)}</td>
              <td>
                {capitalize(displayMembershipCode(d?.previousMembership))}
              </td>
              <td>{d?.endDateFromLastMembership}</td>
              <td>{capitalize(d?.saleChannelFromLastMembership)}</td>
              <td>{capitalize(d?.customerFullName)}</td>
              <td>{d?.customerIdentification}</td>
              <td>{d?.customerGender}</td>
              <td>{d?.customerPhoneNumber}</td>
              <td style={{ minWidth: '150px' }}>
                {d?.customer?.optionalPhonePrefix
                  ? `${d?.customer?.optionalPhonePrefix}-${d?.customer?.optionalPhoneNumber}`
                  : ''}
              </td>
              <td>{d?.vehiclePlate}</td>
              <td>{capitalize(d?.vehicleClass)}</td>
              <td>{d?.vehicleYear}</td>
              <td>{d?.discountCode ? d?.discountCode : d?.giftcardCode}</td>
              <td>{d?.paymentType}</td>
              <td>{d?.paymentStrategy}</td>
              <td>{d?.rcv}</td>
              <td>{d?.discountByRenewal}</td>
              <td>{d?.discountByRenewalPercent}%</td>
              <td>{d?.planBill}</td>
              <td>{d?.rcvBill}</td>
              <td>{d?.hasRcvCard}</td>
              <td>{d?.priceInfo?.medCertSurcharge}</td>
              <td>{d?.totalPaid}</td>
              <td>{d?.totalPaidBs}</td>
              {/* Payment Section  Pago Decontado */}
              <SalesTablePayment data={d} />
              <PaymentChangesSectionMem
                data={d}
                payment={paymentChancesEnum.DE_CONTADO}
              />
              {/* Initial */}
              <DuepaymentsSection data={d} index={data.paymentsQty} />
              <PaymentChangesSectionInitial
                data={d}
                payment={paymentChancesEnum.INICIAL}
              />
              {/* Pago Inicial */}
              <td>
                {d['paymentDues0Date']
                  ? moment(d['paymentDues0Date'])
                    .add(14, 'days')
                    .format('DD/MM/YYYY')
                  : ''}
              </td>
              <td>
                {d['paymentDues1PaymentDate1']
                  ? moment(d['paymentDues1PaymentDate1']).format('DD/MM/YYYY') // Added .format()
                  : ''}
              </td>
              {/* Primera Cuota */}
              <FirstQuota payment={d} />
              <PaymentChangesSectionFirstQuota
                data={d}
                payment={paymentChancesEnum.FIRST_QUOTA}
              />
              <td>{d.refCashea}</td>
              {/* Cuotas pentientes */}
              <PendingQuotas payment={d} index={data.paymentsQty} />
              <td>{d?.receivable ? d?.receivable.toFixed(2) : ''}</td>
              <td>{d?.paymentStatus}</td>
              <td>
                {d?.pendingToPayAdjustment ? d?.pendingToPayAdjustment : ''}
              </td>
              <td>
                {d?.pendingToPayAdjustmentReason
                  ? d?.pendingToPayAdjustmentReason
                  : ''}
              </td>
              <td>{capitalize(d?.state)}</td>
              <td>{capitalize(d?.city)}</td>
              <td>{d?.contractType}</td>
              <td>{d?.customerEmail?.toLowerCase() || ''}</td>
              <td>{d?.customerBirthday}</td>
              <td>{capitalize(d?.vehicleBrand)}</td>
              <td>{capitalize(d?.vehicleModel)}</td>
              <td>{d?.assignedAdvisor}</td>
              <td>{d?.renewalsCount}</td>
              <td>{d?.rcvBeginDate}</td>
              <td>{d?.rcvEndDate}</td>
              <td>{d?.beginDate}</td>
              <td>{d?.endDate}</td>
              <td>{capitalize(d?.accidentRate)}</td>
              <td>{extraKmLabel(d?.km, d?.createdAt)}</td>
              <td>{d?.hasExtendedTow}</td>
              <td>{d?.upgrade}</td>
              <td>{d?.upgradeUsd}</td>
              <td>{d?.upgradeBs}</td>
              <PaymentColumnsRCV payment={d} index={0} />
              <PaymentColumnsRCV payment={d} index={1} />
              <td>{d?.fleetName}</td>
              <td>{d?.contactIncampaign}</td>
            </tr>
          );
        })}
    </>
  );
};

export const NoAvailableResults = (props) => {
  const { data, dateFrom, dateTo } = props;

  if (data?.data.length > 0) {
    return null;
  }

  if (
    (!data?.searchParam && !dateFrom && !dateTo) ||
    (!data?.data && !data?.isLoading)
  ) {
    return (
      <h6 style={{ textAlign: 'center' }}>
        Puedes hacer la búsqueda de la membresia por: nombre. apellido.
        identificación. placa o código de afiliación.
      </h6>
    );
  }
  if (
    (!data?.isLoading && data?.searchParam) ||
    ((dateFrom || dateTo) && data?.data.length <= 0)
  ) {
    return (
      <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
    );
  } else return null;
};

export const SalesMembershipTable = (props) => {
  const {
    header,
    data,
    title,
    handlePageChange,
    redirectToOrderDetail,
    dateFrom,
    dateTo,
  } = props;

  useEffect(() => {
    const cleanup = disableCopyAndContextMenu();
    return () => cleanup && cleanup();
  }, []);

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div
        className="table-container"
        style={{ paddingBottom: data?.data?.length < 5 ? '220px' : '0' }}
      >
        <table
          className="sales-afiliation-table table"
          onContextMenu={(e) => handleContextMenu(e, ['action'])}
        >
          <tr
            style={{
              backgroundColor: '#fff',
            }}
          >
            {header?.map((h, i) => (
              <th
                // generate unique key for each header
                key={`${h?.name}-${i}`}
                style={{
                  padding: '2px 4px',
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignItems: 'center',
                  alignContent: 'center',
                  fontSize: '13px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignContent: 'center',
                  }}
                >
                  {h?.name}
                  {h?.sortable && (
                    <>
                      <TableFilter
                        label={h.name}
                        options={h.filterOptions}
                        onSearch={h.filterSearch}
                      />
                    </>
                  )}
                </div>
              </th>
            ))}
          </tr>
          <SalesMembershipContentTable
            data={data}
            redirectToOrderDetail={redirectToOrderDetail}
            cuentasPorCobrar={cuentasPorCobrar}
            statusCuentasPorCobrar={statusCuentasPorCobrar}
          />
          {/* </tbody> */}
        </table>
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
        <NoAvailableResults data={data} dateFrom={dateFrom} dateTo={dateTo} />
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>

      {/* Table for printing */}
      <div style={{ display: 'none' }} className="table-container">
        <table className="sales-afiliation-table table">
          <tr>
            {header?.map((h) => {
              if (h?.hidePrint) {
                return null;
              } else {
                return <th key={h?.name}>{h?.name}</th>;
              }
            })}
          </tr>
          <tbody>
            <SalesMembershipContentTable
              data={data}
              print={true}
              redirectToOrderDetail={redirectToOrderDetail}
              cuentasPorCobrar={cuentasPorCobrar}
              statusCuentasPorCobrar={statusCuentasPorCobrar}
            />
          </tbody>
        </table>
      </div>
    </>
  );
};

export const PrimaryAsistancePlanTable = (props) => {
  const {
    header,
    data,
    title,
    handlePageChange,
    dateFrom,
    dateTo,
    redirectToPAPDetail,
  } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table
          className="sales-afiliation-table table"
          onContextMenu={(e) => handleContextMenu(e, ['action'])}
        >
          <tr
            style={{
              backgroundColor: '#fff',
            }}
          >
            {header?.map((h, i) => (
              <th
                // generate unique key for each header
                key={`${h?.name}-${i}`}
                style={{
                  padding: '2px 4px',
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignItems: 'center',
                  alignContent: 'center',
                  fontSize: '13px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignContent: 'center',
                  }}
                >
                  {h?.name}
                  {h?.sortable && (
                    <>
                      <TableFilter
                        label={h.name}
                        options={h.filterOptions}
                        onSearch={h.filterSearch}
                      />
                    </>
                  )}
                </div>
              </th>
            ))}
          </tr>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => {
              return (
                <tr key={d?._id}>
                  <td data-column="action">
                    <div className="table-buttons-conatiner">
                      <TableActionButton
                        src={searchLogo}
                        action={() => redirectToPAPDetail(d)}
                      />
                      <a href={`/afiliations/edit-pap-order/${d?._id}`}>
                        <div className="table-action-button">
                          <img target="_blank" src={editLogo} alt="editLogo" />
                        </div>
                      </a>
                    </div>
                  </td>
                  <td>{d?.code}</td>
                  <td>{d?.payAmount}</td>
                  <td>{d?.payAmountBs}</td>
                  <td>{d?.saleChannel?.channel}</td>
                  <td>
                    {d?.createdAt
                      ? moment(d?.createdAt).format('DD/MM/YYYY')
                      : ''}
                  </td>
                  <td>{capitalize(d?.clientId?.firstName)}</td>
                  <td>{capitalize(d?.clientId?.lastName)}</td>
                  <td>{d?.clientId?.identification}</td>
                  <td>{d?.clientId?.phonePrefix + d?.clientId?.phoneNumber}</td>
                  <td>{d?.clientId?.email}</td>
                  <td>
                    {d?.startDate
                      ? moment(d?.startDate).format('DD/MM/YYYY')
                      : ''}
                  </td>
                  <td>
                    {d?.endDate ? moment(d?.endDate).format('DD/MM/YYYY') : ''}
                  </td>
                  <td>{d?.status}</td>
                  <td>{d?.planType === 'Anual' ? 'Sí' : 'No'}</td>
                  <td>{d?.numServices}</td>
                </tr>
              );
            })}
          {/* </tbody> */}
        </table>
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
        <NoAvailableResults data={data} dateFrom={dateFrom} dateTo={dateTo} />
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>

      {/* Table for printing */}
    </>
  );
};

export const PotentialClientsTable = (props) => {
  const {
    header,
    data,
    title,
    handlePageChange,
    redirectToOrderDetail,
    updateClientFromGrid,
    dateFrom,
    dateTo,
  } = props;

  useEffect(() => {
    const cleanup = disableCopyAndContextMenu();
    return () => cleanup && cleanup();
  }, []);

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div
        className="table-container"
        style={{ paddingBottom: data?.data?.length < 5 ? '220px' : '0' }}
      >
        <table
          className="sales-afiliation-table table"
          onContextMenu={(e) => handleContextMenu(e, ['action'])}
        >
          <tr
            style={{
              backgroundColor: '#fff',
            }}
          >
            {header?.map((h, i) => (
              <th
                // generate unique key for each header
                key={`${h?.name}-${i}`}
                style={{
                  padding: '2px 4px',
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignItems: 'center',
                  alignContent: 'center',
                  fontSize: '13px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignContent: 'center',
                  }}
                >
                  {h?.name}
                  {h?.sortable && (
                    <>
                      <TableFilter
                        label={h.name}
                        options={h.filterOptions}
                        onSearch={h.filterSearch}
                      />
                    </>
                  )}
                </div>
              </th>
            ))}
          </tr>
          <PotentialClientsDataTable
            data={data}
            redirectToOrderDetail={redirectToOrderDetail}
            updateFromGrid={updateClientFromGrid}
            cuentasPorCobrar={cuentasPorCobrar}
            statusCuentasPorCobrar={statusCuentasPorCobrar}
          />
          {/* </tbody> */}
        </table>
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
        <NoAvailableResults data={data} dateFrom={dateFrom} dateTo={dateTo} />
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const CasheaTable = (props) => {
  const { header, data, title, handlePageChange } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="sales-afiliation-table table">
          <tr
            style={{
              backgroundColor: '#fff',
            }}
          >
            {header?.map((h) => (
              <th style={{ fontSize: '13px' }} key={h?.name}>
                {h?.name}
              </th>
            ))}
          </tr>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => {
              return (
                <tr key={d?._id}>
                  <td>{d?.membershipId}</td>
                  <td>{d?.casheaRef}</td>
                  <td>
                    {d?.createdAt
                      ? moment(d?.createdAt).format('DD/MM/YYYY')
                      : ''}
                  </td>
                  <td>{d?.seller}</td>
                  <td>{d?.saleChannel}</td>
                  <td>{capitalize(displayMembershipCode(d?.code))}</td>

                  <td>{capitalize(d?.customer)}</td>
                  <td>{d?.finalPrice}</td>
                  <td>{d?.paymentsAmount?.toFixed(2)}</td>
                  <td>{d?.totalDebt}</td>
                </tr>
              );
            })}
        </table>
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const CasheaPaymentsReportTable = (props) => {
  const { header, data, title, handlePageChange } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="sales-afiliation-table table">
          <tr
            style={{
              backgroundColor: '#fff',
            }}
          >
            {header?.map((h) => (
              <th style={{ fontSize: '13px' }} key={h?.name}>
                {h?.name}
              </th>
            ))}
          </tr>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => {
              return (
                <tr key={d?._id}>
                  <td>
                    {d?.createdAt
                      ? moment(d?.createdAt).format('DD/MM/YYYY')
                      : ''}
                  </td>
                  <td>{d?.description}</td>
                  <td>
                    <a href={d?.file} target="_blank" rel="noopener noreferrer">
                      noprocesados.xlsx
                    </a>
                  </td>
                </tr>
              );
            })}
        </table>
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const RCVsTable = (props) => {
  const { header, data, title, handlePageChange } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="sales-afiliation-table table">
          <tr
            style={{
              backgroundColor: '#fff',
            }}
          >
            {header?.map((h) => (
              <th style={{ fontSize: '13px' }} key={h?.name}>
                {h?.name}
              </th>
            ))}
          </tr>
          <tbody>
            {data?.data?.length > 0 &&
              !data?.isLoading &&
              data?.data?.map((d) => {
                return (
                  <tr key={d?._id}>
                    <td>{d?.membershipId}</td>
                    <td>{d?.affiliationType}</td>
                    <td>{d?.totalPremium ? d?.totalPremium + '$' : ''}</td>
                    <td>
                      {d?.rcvBeginDate
                        ? moment(d?.rcvBeginDate).format('DD/MM/YYYY')
                        : ''}
                    </td>
                    <td>
                      {d?.rcvEndDate
                        ? moment(d?.rcvEndDate).format('DD/MM/YYYY')
                        : ''}
                    </td>
                    <td>
                      {capitalize(d?.customer[0]?.firstName) +
                        ' ' +
                        capitalize(d?.customer[0]?.lastName)}
                    </td>
                    <td>
                      {capitalize(d?.customer[0]?.identificationType) +
                        '-' +
                        d?.customer[0]?.identification}
                    </td>
                    <td>
                      {capitalize(d?.customer[0]?.phonePrefix) +
                        '-' +
                        capitalize(d?.customer[0]?.phoneNumber)}
                    </td>
                    <td style={{ textTransform: 'lowercase' }}>
                      {capitalize(d?.customer[0]?.email)}
                    </td>
                    <td>
                      {d?.customer[0]?.birthday
                        ? moment(d?.customer[0]?.birthday).format('DD/MM/YYYY')
                        : ''}
                    </td>
                    <td> {capitalize(d?.vehicle[0]?.state)}</td>
                    <td> {capitalize(d?.vehicle[0]?.city)}</td>
                    <td> {exists(d?.vehicle[0]?.plate)}</td>
                    <td> {capitalize(d?.vehicle[0]?.class)}</td>
                    <td> {capitalize(d?.vehicle[0]?.type)}</td>
                    <td> {capitalize(d?.vehicle[0]?.brand)}</td>
                    <td> {capitalize(d?.vehicle[0]?.model)}</td>
                    <td> {capitalize(d?.vehicle[0]?.color)}</td>
                    <td> {capitalize(d?.vehicle[0]?.year)}</td>
                    <td> {capitalize(d?.vehicle[0]?.bodySerial)}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const RCV_CSTable = (props) => {
  const { header, data, title, handlePageChange } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="sales-afiliation-table table">
          <tr
            style={{
              backgroundColor: '#fff',
            }}
          >
            {header?.map((h) => (
              <th style={{ fontSize: '13px' }} key={h?.name}>
                {h?.name}
              </th>
            ))}
          </tr>
          <tbody>
            {data?.data?.length > 0 &&
              !data?.isLoading &&
              data?.data?.map((d) => {
                return (
                  <tr key={d?._id}>
                    <td>
                      {d?.customer[0]?.identificationType
                        ? d?.customer[0]?.identificationType
                        : ''}
                    </td>
                    <td>
                      {d?.customer[0]?.identification
                        ? d?.customer[0]?.identification
                        : ''}
                    </td>
                    <td>
                      {d?.customer[0]?.firstName
                        ? d?.customer[0]?.firstName
                        : ''}
                    </td>
                    <td>
                      {d?.customer[0]?.lastName ? d?.customer[0]?.lastName : ''}
                    </td>
                    <td>
                      {d?.customer[0]?.gender ? d?.customer[0]?.gender : ''}
                    </td>
                    <td>
                      {d?.customer[0]?.maritalStatus
                        ? d?.customer[0]?.maritalStatus
                        : ''}
                    </td>
                    <td>
                      {d?.customer[0]?.birthday
                        ? moment(d?.customer[0]?.birthday)?.format('YYYY/MM/DD')
                        : ''}
                    </td>
                    <td>
                      {d?.customer[0]?.profession
                        ? capitalize(d?.customer[0]?.profession)
                        : ''}
                    </td>
                    <td>
                      {d?.customer[0]?.economicActivity
                        ? capitalize(d?.customer[0]?.economicActivity)
                        : ''}
                    </td>
                    <td>
                      {d?.customer[0]?.phoneNumber
                        ? d?.customer[0]?.phoneNumber
                        : ''}
                    </td>
                    <td>
                      {d?.vehicle[0]?.address
                        ? capitalize(d?.vehicle[0]?.address)
                        : ''}
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                      {d?.vehicle[0]?.municipality
                        ? capitalize(d?.vehicle[0]?.municipality)
                        : ''}
                    </td>
                    <td>
                      {d?.vehicle[0]?.ownerCity
                        ? capitalize(d?.vehicle[0]?.ownerCity)
                        : capitalize(d?.vehicle[0]?.city)}
                    </td>
                    <td>
                      {d?.vehicle[0]?.ownerState
                        ? capitalize(d?.vehicle[0]?.ownerState)
                        : capitalize(d?.vehicle[0]?.state)}
                    </td>
                    <td>
                      {d?.customer[0]?.email
                        ? d?.customer[0]?.email?.toLowerCase()
                        : ''}
                    </td>
                    <td>{d?.customer[0]?.identificationType}</td>
                    <td>{d?.customer[0]?.identification}</td>
                    <td>
                      {d?.customer[0]?.firstName
                        ? capitalize(d?.customer[0]?.firstName)
                        : ''}
                    </td>
                    <td>
                      {d?.customer[0]?.lastName
                        ? capitalize(d?.customer[0]?.lastName)
                        : ''}
                    </td>
                    <td>
                      {d?.vehicle[0]?.ownerIdentification
                        ? d?.vehicle[0]?.ownerIdentificationType
                        : d?.customer[0]?.identificationType}
                    </td>
                    <td>
                      {d?.vehicle[0]?.ownerIdentification
                        ? d?.vehicle[0]?.ownerIdentification
                        : d?.customer[0]?.identification}
                    </td>
                    <td>
                      {d?.vehicle[0]?.ownerFirstName
                        ? capitalize(d?.vehicle[0]?.ownerFirstName)
                        : capitalize(d?.customer[0]?.firstName)}
                    </td>
                    <td>
                      {d?.vehicle[0]?.ownerLastName
                        ? capitalize(d?.vehicle[0]?.ownerLastName)
                        : capitalize(d?.customer[0]?.lastName)}
                    </td>
                    <td>
                      {d?.vehicle[0]?.brand
                        ? capitalize(d?.vehicle[0]?.brand)
                        : ''}
                    </td>
                    <td>
                      {d?.vehicle[0]?.model
                        ? capitalize(d?.vehicle[0]?.model)
                        : ''}
                    </td>
                    <td>{d?.vehicle[0]?.year}</td>
                    <td>{d?.vehicle[0]?.plate}</td>
                    <td>{d?.vehicle[0]?.color}</td>
                    <td>{d?.vehicle[0]?.bodySerial}</td>
                    <td>{d?.vehicle[0]?.engineSerial}</td>
                    <td>
                      {d?.vehicle[0]?.type
                        ? capitalize(d?.vehicle[0]?.type)
                        : ''}
                    </td>
                    <td>{d?.vehicle[0]?.vehicleUsage}</td>
                    <td>{d?.vehicle[0]?.seats}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{d?.rcvId}</td>
                    <td>
                      {d?.rcvEmissionDate
                        ? moment(d?.rcvEmissionDate)?.format('YYYY/MM/DD')
                        : ''}
                    </td>
                    <td>
                      {d?.rcvBeginDate
                        ? moment(d?.rcvBeginDate)?.format('YYYY/MM/DD')
                        : ''}
                    </td>
                    <td>
                      {d?.rcvEndDate
                        ? moment(d?.rcvEndDate)?.format('YYYY/MM/DD')
                        : ''}
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                      {d?.totalPremium ? d?.totalPremium?.toFixed(2) : ''}
                    </td>
                    <td>{d?.rcv ? capitalize(d?.rcv) : ''}</td>
                    <td></td>
                    <td></td>
                    <td>{d?.rcvReceipt}</td>
                    <td></td>
                    <td>
                      {d?.rcvReceiptDate
                        ? moment(d?.rcvReceiptDate)?.format('YYYY/MM/DD')
                        : ''}
                    </td>
                    <td>
                      {d?.rcvBeginDate
                        ? moment(d?.rcvBeginDate)?.format('YYYY/MM/DD')
                        : ''}
                    </td>
                    <td>
                      {d?.rcvEndDate
                        ? moment(d?.rcvEndDate)?.format('YYYY/MM/DD')
                        : ''}
                    </td>
                    <td>
                      {d?.totalPremium ? d?.totalPremium?.toFixed(2) : ''}
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      {d?.priceInfo?.exchangeRate
                        ? d?.priceInfo?.exchangeRate?.toFixed(2)
                        : ''}
                    </td>
                    <td>
                      {d?.priceInfo?.exchangeRateDate
                        ? moment(d?.priceInfo?.exchangeRateDate)?.format(
                          'YYYY/MM/DD'
                        )
                        : ''}
                    </td>
                    <td>{d?.statusText}</td>
                    <td>{d?.annullationReason}</td>
                    <td>
                      {d?.customer[0]?.identityDocument ? (
                        <a
                          href={d?.customer[0]?.identityDocument}
                          target="_blank"
                          rel="noreferrer"
                        >{`Cedula`}</a>
                      ) : (
                        ''
                      )}
                    </td>
                    <td>
                      {d?.customer[0]?.licenses?.length > 0
                        ? d?.customer[0]?.licenses?.map((l, i) => (
                          <>
                            <a
                              href={l}
                              target="_blank"
                              rel="noreferrer"
                            >{`Licencia`}</a>{' '}
                            <br />
                          </>
                        ))
                        : ''}
                    </td>
                    <td>
                      {d?.vehicle[0]?.circulationCard ? (
                        <a
                          href={d?.vehicle[0]?.circulationCard}
                          target="_blank"
                          rel="noreferrer"
                        >{`Carnet Circulacion`}</a>
                      ) : (
                        ''
                      )}
                    </td>
                    <td>
                      {' '}
                      {d?.documents?.rcv ? (
                        <a
                          href={d?.documents?.rcv}
                          target="_blank"
                          rel="noreferrer"
                        >
                          RCV
                        </a>
                      ) : (
                        ''
                      )}
                    </td>
                    <td>
                      {' '}
                      {d?.documents?.rcvCard ? (
                        <a
                          href={d?.documents?.rcvCard}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Carnet RCV
                        </a>
                      ) : (
                        ''
                      )}
                    </td>
                    <td>
                      {' '}
                      {d?.documents?.rcvForm ? (
                        <a
                          href={d?.documents?.rcvForm}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Solicitud RCV
                        </a>
                      ) : (
                        ''
                      )}
                    </td>
                    <td>{d?.vehicle?.[0]?.titleNumber}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const UpgradeTable = (props) => {
  const { header, data, title, handlePageChange } = props;
  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="sales-afiliation-table table">
          <tr
            style={{
              backgroundColor: '#fff',
            }}
          >
            {header?.map((h) => (
              <th style={{ fontSize: '13px' }} key={h?.name}>
                {h?.name}
              </th>
            ))}
          </tr>

          <tbody>
            {data?.data?.length > 0 &&
              !data?.isLoading &&
              data?.data?.map((d) => {
                return (
                  <tr key={d?._id}>
                    <td>{d?.upgradeDate}</td>
                    <td>{capitalize(d?.upgradeSeller)}</td>
                    <td>{d?.membershipId}</td>
                    <td>{capitalize(d?.customerFullName)}</td>
                    <td>{d?.planChange}</td>
                    <td>{d?.kms}</td>
                    <td>{d?.extendedTowChange}</td>
                    <td>{d?.vehiclePlate}</td>
                    <td>{d?.customerIdentification}</td>
                    {Array.from({ length: MAX_PAYMENT_METHODS }).map(
                      (_, index) => (
                        <React.Fragment key={index}>
                          <td>{d[`payment${index + 1}Method`] || ''}</td>
                          <td>{d[`payment${index + 1}AmountUsd`] || ''}</td>
                          <td>{d[`payment${index + 1}AmountBs`] || ''}</td>
                          <td>{d[`payment${index + 1}Reference`] || ''}</td>
                        </React.Fragment>
                      )
                    )}
                    {/* <td>{capitalize(upgradePayment(d)?.method)}</td>
                    <td>{upgradePayment(d)?.totalAmount}</td>
                    <td>{upgradePayment(d)?.totalAmountInBsS}</td>
                    <td>{upgradePayment(d)?.reference}</td> */}
                    <td>{capitalize(d?.state)}</td>
                    <td>{capitalize(d?.city)}</td>
                    <td>{capitalize(d?.vehicleYear)}</td>
                    <td>{d?.vehicleIsArmored}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const CxCTable = (props) => {
  const { header, data, year, month, title, action } = props;
  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="sales-afiliation-table table">
          <tr
            style={{
              backgroundColor: '#fff',
            }}
          >
            {header?.map((h) => (
              <th style={{ fontSize: '13px' }} key={h?.name}>
                {h?.name}
              </th>
            ))}
          </tr>

          <tbody>
            {data?.data?.length > 0 &&
              !data?.isLoading &&
              data?.data?.map((d) => {
                return (
                  <tr key={d?._id}>
                    <td>
                      <div className="buttons-center-container">
                        <ActionButton
                          label={'Ver Detalle'}
                          action={() => action(d)}
                        />
                      </div>
                    </td>
                    <td>
                      {monthsComissionsOptions[month - 1].name + ' ' + year}
                    </td>
                    <td>{d?.channelShortName}</td>
                    <td>{d?.membershipsCount}</td>
                    <td>{d?.totalPrice}$</td>
                    <td>{d?.comission}$</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
    </>
  );
};

export const PAPAffiliationDetails = (props) => {
  const { header, data, title } = props;
  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="sales-afiliation-table table">
          <tr
            style={{
              backgroundColor: '#fff',
            }}
          >
            {header?.map((h) => (
              <th style={{ fontSize: '13px' }} key={h?.name}>
                {h?.name}
              </th>
            ))}
          </tr>

          <tbody>
            {data?.data?.length > 0 &&
              !data?.isLoading &&
              data?.data?.map((d) => {
                return (
                  <tr key={d?._id}>
                    <td>{d?.gotMembershipNumber}</td>
                    <td>{d?.gotMembershipChannelShort}</td>
                    <td>{d?.gotMembershipCreatedAtLocale}</td>
                    <td>{d?.firstName}</td>
                    <td>{d?.lastName}</td>
                    <td>{d?.identification}</td>
                    <td>{d?.gotMembershipPapCode}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
    </>
  );
};

export const PAPCommissionTable = (props) => {
  const { header, action, data, year, month, title } = props;
  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="sales-afiliation-table table">
          <tr
            style={{
              backgroundColor: '#fff',
            }}
          >
            {header?.map((h) => (
              <th style={{ fontSize: '13px' }} key={h?.name}>
                {h?.name}
              </th>
            ))}
          </tr>

          <tbody>
            {data?.data?.length > 0 &&
              !data?.isLoading &&
              data?.data?.map((d) => {
                return (
                  <tr key={d?._id}>
                    <td>
                      <div className="buttons-center-container">
                        <ActionButton
                          label={'Ver Detalle'}
                          action={() => action(d)}
                        />
                      </div>
                    </td>
                    <td>
                      {monthsComissionsOptions[month - 1].name + '  ' + year}
                    </td>
                    <td>{d?.saleChannel}</td>
                    <td>{d?.totalMonthly}</td>
                    <td>{d?.totalAnnual}</td>
                    <td>{parseFloat(d?.monthlyCharge).toFixed(2)}$</td>
                    <td>{parseFloat(d?.monthlyChargeBs).toFixed(2)}</td>
                    <td>{parseFloat(d?.monthlyComission).toFixed(2)}$</td>
                    <td>{parseFloat(d?.monthlyCommissionBs).toFixed(2)}</td>
                    <td>{parseFloat(d?.amountToCollect).toFixed(2)}$</td>
                    <td>{parseFloat(d?.amountToCollectBs).toFixed(2)}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
    </>
  );
};

export const SalesTable = (props) => {
  const { header, data, title, handlePageChange } = props;

  useEffect(() => {
    const cleanup = disableCopyAndContextMenu();

    return () => cleanup && cleanup();
  }, []);

  const PaymentColumnsRCV = (props) => {
    const { payment, index } = props;

    let payments = [];

    Array.from({ length: 2 }).forEach((_, index) =>
      payments.push({
        totalAmount: payment[`payRcv${index + 1}Amount`] || '',
        totalAmountInBsS: payment[`payRcv${index + 1}AmountBs`] || '',
        method: payment[`payRcv${index + 1}Method`] || '',
        reference: payment[`payRcv${index + 1}Ref`] || '',
        accHolder: payment[`payRcv${index + 1}AccHolder`] || '',
        createdAt: payment[`payRcv${index + 1}Date`] || '',
      })
    );

    return (
      <>
        <td>{!payments[index]?.upgrade ? payments[index]?.totalAmount : ''}</td>
        <td>
          {!payments[index]?.upgrade ? payments[index]?.totalAmountInBsS : ''}
        </td>
        <td>
          {!payments[index]?.upgrade ? capitalize(payments[index]?.method) : ''}
        </td>
        <td>{!payments[index]?.upgrade ? payments[index]?.reference : ''}</td>
        <td>
          {!payments[index]?.upgrade && payments[index]?.createdAt
            ? moment(payments[index]?.createdAt).format('DD/MM/YYYY')
            : ''}
        </td>
      </>
    );
  };

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table
          className="sales-afiliation-table table"
          onContextMenu={(e) => e.preventDefault()}
        >
          <tr
            style={{
              backgroundColor: '#fff',
            }}
          >
            {header?.map((h) => (
              <th style={{ fontSize: '13px' }} key={h?.name}>
                {h?.name}
              </th>
            ))}
          </tr>

          <tbody>
            {data?.data?.length > 0 &&
              !data?.isLoading &&
              data?.data?.map((d) => {
                return (
                  <tr key={d?._id}>
                    <td>{d?.membershipId}</td>
                    <td>{d?.createdAt}</td>

                    <td>{d?.associatedMemberships}</td>
                    <td>{capitalize(d?.seller)}</td>

                    <td>{d?.saleChannel}</td>
                    <td>{d?.event}</td>
                    <td>
                      {capitalize(displayMembershipCode(d?.membershipCode))}
                    </td>
                    <td>{d?.affiliationType}</td>
                    <td>
                      {capitalize(displayMembershipCode(d?.previousMembership))}
                    </td>
                    <td>{d?.endDateFromLastMembership}</td>
                    <td>{capitalize(d?.customerFullName)}</td>

                    <td>{d?.vehiclePlate}</td>
                    <td>{d?.vehicleYear}</td>
                    <td>
                      {d?.discountCode ? d?.discountCode : d?.giftcardCode}
                    </td>
                    <td>{d?.paymentType}</td>
                    <td>{d?.paymentStrategy}</td>
                    <td>{d?.rcv}</td>
                    <td>
                      {d?.discountByRenewal > 0 ? d?.discountByRenewal : ''}
                    </td>
                    <td>{d?.discountByRenewalPercent}%</td>
                    <td>{d?.planBill}</td>
                    <td>{d?.rcvBill > 0 ? d?.rcvBill : ''}</td>
                    <td>{d?.hasRcvCard > 0 ? d?.hasRcvCard : ''}</td>
                    <td>{d?.medCertBill > 0 ? d?.medCertBill : ''}</td>
                    {/* <td>{d?.hasRcvCard}</td> */}
                    {/* <td>{d?.planBill} BILL</td>

                    <td>{d?.totalPaidBs}</td> */}
                    {/* Payment Section */}
                    <SalesTablePayment data={d} />
                    <PaymentChangesSectionMem
                      data={d}
                      payment={paymentChancesEnum.DE_CONTADO}
                    />

                    <td>
                      {d['paymentDues0PaymentDate1']
                        ? moment(d['paymentDues0PaymentDate1']).format(
                          'DD/MM/YYYY'
                        ) // Added .format()
                        : ''}
                    </td>
                    {/* Initial */}
                    <DuepaymentsSection data={d} index={MAX_PAYMENT_METHODS} />
                    <PaymentChangesSectionInitial
                      data={d}
                      payment={paymentChancesEnum.INICIAL}
                    />
                    <td>
                      {d['paymentDues0Date']
                        ? moment(d?.['paymentDues0Date'])
                          .add(14, 'days')
                          .format('DD/MM/YYYY')
                        : ''}
                    </td>
                    <td>{d?.['paymentDues1PaymentDate1']}</td>
                    <FirstQuota payment={d} />
                    <PaymentChangesSectionFirstQuota
                      data={d}
                      payment={paymentChancesEnum.FIRST_QUOTA}
                    />
                    <td>{d['refCashea']}</td>
                    <PendingQuotas payment={d} index={data?.paymentsQty} />
                    <td>{d?.receivable ? d?.receivable.toFixed(2) : ''}</td>
                    <td>{statusCuentasPorCobrar(d)}</td>
                    <td>{capitalize(d?.state)}</td>
                    <td>{capitalize(d?.city)}</td>
                    <td>{capitalize(d?.vehicleModel)}</td>
                    <td>{d?.beginDate}</td>
                    <td>{d?.endDate}</td>
                    <td>{extraKmLabel(d?.km, d?.createdAt)}</td>
                    <td>{d?.hasExtendedTow}</td>
                    <td>{d?.rcvBeginDate}</td>
                    <td>{d?.rcvEndDate}</td>
                    <td>{capitalize(d?.membershipStatus)}</td>
                    <PaymentColumnsRCV payment={d} index={0} />
                    <PaymentColumnsRCV payment={d} index={1} />
                  </tr>
                );
              })}
          </tbody>
        </table>
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};
export const InboxTable = (props) => {
  const {
    header,
    data,
    title,
    handlePageChange,
    updateSalesNotification,
    checkReadNotification,
  } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table
          className="sales-afiliation-table table"
          onContextMenu={(e) => e.preventDefault()}
        >
          <tr
            style={{
              backgroundColor: '#fff',
            }}
          >
            {header?.map((h) => (
              <th style={{ fontSize: '13px' }} key={h?.name}>
                {h?.name}
              </th>
            ))}
          </tr>

          <tbody>
            {data?.data?.length > 0 &&
              !data?.isLoading &&
              data?.data?.map((d) => {
                return (
                  <tr key={d?._id}>
                    <td
                      style={{
                        fontWeight:
                          [
                            salesRoles.SALES_ADMIN,
                            salesRoles.SALES_DEVELOPER,
                            salesRoles.SALES_ADMIN_AUX,
                          ]?.includes(authService.getUser()?.roles[0]?.code) &&
                            !d?.readed
                            ? 'bold'
                            : 'normal',
                      }}
                    >
                      {d?.membershipId}
                    </td>
                    <td
                      style={{
                        fontWeight:
                          [
                            salesRoles.SALES_ADMIN,
                            salesRoles.SALES_DEVELOPER,
                            salesRoles.SALES_ADMIN_AUX,
                          ]?.includes(authService.getUser()?.roles[0]?.code) &&
                            !d?.readed
                            ? 'bold'
                            : 'normal',
                      }}
                    >
                      {d?.createdAt
                        ? moment(d?.createdAt)?.format('DD/MM/YYYY')
                        : ''}
                    </td>
                    <td
                      style={{
                        fontWeight:
                          [
                            salesRoles.SALES_ADMIN,
                            salesRoles.SALES_DEVELOPER,
                            salesRoles.SALES_ADMIN_AUX,
                          ]?.includes(authService.getUser()?.roles[0]?.code) &&
                            !d?.readed
                            ? 'bold'
                            : 'normal',
                      }}
                    >
                      {d?.type}
                    </td>
                    <td
                      style={{
                        fontWeight:
                          [
                            salesRoles.SALES_ADMIN,
                            salesRoles.SALES_DEVELOPER,
                            salesRoles.SALES_ADMIN_AUX,
                          ]?.includes(authService.getUser()?.roles[0]?.code) &&
                            !d?.readed
                            ? 'bold'
                            : 'normal',
                      }}
                    >
                      {capitalize(d?.seller?.firstName)}{' '}
                      {capitalize(d?.seller?.lastName)}
                    </td>
                    <td>
                      <img
                        onClick={() => checkReadNotification(d)}
                        src={darkArrow}
                        alt="image"
                        style={{
                          cursor: 'pointer',
                          height: '24px',
                          width: '24px',
                          marginRight: '10px',
                        }}
                      />
                      <img
                        onClick={() => updateSalesNotification(d?._id)}
                        src={eyeOff}
                        alt="image"
                        style={{
                          cursor: 'pointer',
                          height: '32px',
                          width: '32px',
                        }}
                      />
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

// NO ES ELIMINO NI SE REFECTORIZO ESTA TABLA POR SI QUIEREN VOLVER A UN ESTADO ANTERIOR
export const ExportableAdminTable = (props) => {
  const { header, data, title, handlePageChange } = props;

  const showCasheaReference = (data) => {
    let paymentDetails = data?.paymentDetails;

    if (!paymentDetails || !Array.isArray(paymentDetails)) {
      return '';
    }

    const foundDetail = paymentDetails.find(
      (detail) => detail.referenceCashea !== undefined
    );

    return foundDetail ? foundDetail.referenceCashea : '';
  };

  const PaymentColumnsRCV = (props) => {
    const { data, index } = props;

    let payments = [];
    data?.payments.forEach((payment, i) => {
      if (payment.reason && payment.reason === 'rcv') {
        payments.push(payment);
      }
    });

    return (
      <>
        <td>{!payments[index]?.upgrade ? payments[index]?.totalAmount : ''}</td>
        <td>
          {!payments[index]?.upgrade ? payments[index]?.totalAmountInBsS : ''}
        </td>
        <td>
          {!payments[index]?.upgrade ? capitalize(payments[index]?.method) : ''}
        </td>
        <td>{!payments[index]?.upgrade ? payments[index]?.reference : ''}</td>
        <td>
          {!payments[index]?.upgrade && payments[index]?.createdAt
            ? moment(payments[index]?.createdAt).format('DD/MM/YYYY')
            : ''}
        </td>
      </>
    );
  };

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="sales-afiliation-table table">
          <tr
            style={{
              backgroundColor: '#fff',
            }}
          >
            {header?.map((h) => (
              <th style={{ fontSize: '13px' }} key={h?.name}>
                {h?.name}
              </th>
            ))}
          </tr>

          <tbody>
            {data?.data?.length > 0 &&
              !data?.isLoading &&
              data?.data?.map((d) => {
                return (
                  <tr key={d?._id}>
                    <td>{d?.membershipId}</td>
                    <td>
                      {d?.createdAt
                        ? moment(d?.createdAt).format('DD/MM/YYYY')
                        : ''}
                    </td>
                    <td>{capitalize(d?.membershipStatus)}</td>
                    <td>{d?.saleChannel}</td>
                    <td>
                      {capitalize(displayMembershipCode(d?.membershipCode))}
                    </td>
                    <td>{d?.affiliationType}</td>
                    <td>{d?.paymentType}</td>
                    <td>{d?.paymentStrategy}</td>
                    <td>{d?.rcv}</td>
                    <td>{d?.priceInfo?.finalPrice?.toFixed(2)}</td>
                    <td>{d?.priceInfo?.finalPriceInBsS?.toFixed(2)}</td>
                    <td>{d?.priceInfo?.rcvSurcharge}</td>
                    <td>{d?.totalBill?.toFixed(2)}</td>
                    <td>{d?.totalBillBsS?.toFixed(2)}</td>
                    {/* Payment Section */}
                    <td>
                      {d?.paymentType === paymentType?.DE_CONTADO &&
                        d?.payments[0]?.reason !== 'rcv'
                        ? capitalize(d?.payments[0]?.method)
                        : ''}
                    </td>
                    <td>
                      {[
                        paymentType?.DE_CONTADO,
                        paymentType?.PENDING,
                        paymentType?.DIFERIDO,
                      ]?.includes(d?.paymentType) &&
                        d?.payments &&
                        d?.payments[0]?.reason !== 'rcv'
                        ? d?.payments[0]?.totalAmount
                        : ''}
                    </td>
                    <td>
                      {[
                        paymentType?.DE_CONTADO,
                        paymentType?.PENDING,
                        paymentType?.DIFERIDO,
                      ]?.includes(d?.paymentType) &&
                        d?.payments &&
                        d?.payments[0]?.reason !== 'rcv'
                        ? d?.payments[0]?.reference
                        : ''}
                    </td>
                    <td>
                      {[
                        paymentType?.DE_CONTADO,
                        paymentType?.PENDING,
                        paymentType?.DIFERIDO,
                      ]?.includes(d?.paymentType) &&
                        d?.paymentType === paymentType?.DE_CONTADO &&
                        d?.payments[1]?.reason !== 'rcv'
                        ? capitalize(d?.payments[1]?.method)
                        : ''}
                    </td>
                    <td>
                      {[
                        paymentType?.DE_CONTADO,
                        paymentType?.PENDING,
                        paymentType?.DIFERIDO,
                      ]?.includes(d?.paymentType) &&
                        d?.payments &&
                        d?.payments[1]?.reason !== 'rcv'
                        ? d?.payments[1]?.totalAmount
                        : ''}
                    </td>
                    <td>
                      {[
                        paymentType?.DE_CONTADO,
                        paymentType?.PENDING,
                        paymentType?.DIFERIDO,
                      ]?.includes(d?.paymentType) &&
                        d?.payments &&
                        d?.payments[1]?.reason !== 'rcv'
                        ? d?.payments[1]?.reference
                        : ''}
                    </td>
                    <td>
                      {(d?.paymentType === paymentType?.FINANCIADO ||
                        d?.paymentType === paymentType?.CASHEA) &&
                        !d?.payments[0]?.upgrade &&
                        d?.paymentDues[0]?.paymentDate
                        ? showCasheaReference(d?.paymentDues[0])
                        : ''}
                    </td>
                    <td>
                      {(d?.paymentType === paymentType?.FINANCIADO ||
                        d?.paymentType === paymentType?.CASHEA) &&
                        !d?.payments[0]?.upgrade &&
                        d?.paymentDues[0]?.paymentDate
                        ? moment(d?.paymentDues[0]?.paymentDate).format(
                          'DD/MM/YYYY'
                        )
                        : ''}
                    </td>
                    <Duepayments data={d} index={0} />
                    <td>
                      {(d?.paymentType === paymentType?.FINANCIADO ||
                        d?.paymentType === paymentType?.CASHEA) &&
                        d?.paymentDues &&
                        d?.paymentDues[1]?.dueDate
                        ? moment(d?.paymentDues[1]?.dueDate).format(
                          'DD/MM/YYYY'
                        )
                        : ''}
                    </td>
                    <td>
                      {(d?.paymentType === paymentType?.FINANCIADO ||
                        d?.paymentType === paymentType?.CASHEA) &&
                        d?.paymentDues &&
                        d?.paymentDues[1]?.paymentDate
                        ? moment(d?.paymentDues[1]?.paymentDate).format(
                          'DD/MM/YYYY'
                        )
                        : ''}
                    </td>
                    <Duepayments data={d} index={1} />
                    <td>
                      {(d?.paymentType === paymentType?.FINANCIADO ||
                        d?.paymentType === paymentType?.CASHEA) &&
                        d?.paymentDues &&
                        d?.paymentDues[2]?.dueDate
                        ? moment(d?.paymentDues[2]?.dueDate).format(
                          'DD/MM/YYYY'
                        )
                        : ''}
                    </td>
                    <td>
                      {(d?.paymentType === paymentType?.FINANCIADO ||
                        d?.paymentType === paymentType?.CASHEA) &&
                        d?.paymentDues &&
                        d?.paymentDues[2]?.paymentDate
                        ? moment(d?.paymentDues[2]?.paymentDate).format(
                          'DD/MM/YYYY'
                        )
                        : ''}
                    </td>
                    <Duepayments data={d} index={2} />
                    <td>
                      {(d?.paymentType === paymentType?.FINANCIADO ||
                        d?.paymentType === paymentType?.CASHEA) &&
                        d?.paymentDues &&
                        d?.paymentDues[3]?.dueDate
                        ? moment(d?.paymentDues[3]?.dueDate).format(
                          'DD/MM/YYYY'
                        )
                        : ''}
                    </td>
                    <td>
                      {(d?.paymentType === paymentType?.FINANCIADO ||
                        d?.paymentType === paymentType?.CASHEA) &&
                        d?.paymentDues &&
                        d?.paymentDues[3]?.paymentDate
                        ? moment(d?.paymentDues[3]?.paymentDate).format(
                          'DD/MM/YYYY'
                        )
                        : ''}
                    </td>
                    <Duepayments data={d} index={3} />
                    <td>
                      {d?.paymentStatus !== 'Pago realizado' &&
                        cuentasPorCobrar(d)}
                    </td>
                    <td>{statusCuentasPorCobrar(d)}</td>
                    <PaymentColumnsRCV data={d} index={0} />
                    <PaymentColumnsRCV data={d} index={1} />
                  </tr>
                );
              })}
          </tbody>
        </table>
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const ExportableAdminTableV2 = (props) => {
  const { header, data, title, handlePageChange } = props;

  function replaceHyphensWithSlashes(dateString) {
    return dateString.replace(/-/g, '/');
  }

  //SI NO VIENE COMO STRING SINO COMO ARRAY

  // const showLinkedMembershipsAsString = (linkedMemberships) => {
  //   if (
  //     !linkedMemberships ||
  //     linkedMemberships.length === 0 ||
  //     !Array.isArray(linkedMemberships)
  //   ) {
  //     return '';
  //   }
  //   return linkedMemberships
  //     .map((membership) => membership.membershipId)
  //     .join(', ');
  // };

  useEffect(() => {
    const cleanup = disableCopyAndContextMenu();

    return () => cleanup && cleanup();
  }, []);

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table
          className="sales-afiliation-table table"
          onContextMenu={(e) => e.preventDefault()}
          style={{ minHeight: '40vh' }}
        >
          <thead>
            <tr style={{ backgroundColor: '#fff', maxHeight: '40px' }}>
              {header?.map((h, index) => (
                <th
                  key={h?.name + index}
                  style={{
                    padding: '4px 8px 4px 8px',
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignContent: 'center',
                    minWidth: '114px',
                    backgroundColor: '#fff',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: '7px',
                      width: '100%',
                      textAlign: 'center',
                      justifyContent: 'center',
                      alignItems: 'center',
                      alignContent: 'center',
                      zIndex: 10,
                    }}
                  >
                    {h?.name}
                    {h?.sortable &&
                      (['Fecha de carga', 'Fecha de pago'].includes(h.name) ? (
                        <TableDateFilter onSearch={h.filterSearch} />
                      ) : (
                        <TableFilter
                          label={h.name}
                          options={h.filterOptions}
                          onSearch={h.filterSearch}
                        />
                      ))}
                  </div>
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data?.data?.length > 0 &&
              !data?.isLoading &&
              data?.data?.map((d) => {
                return (
                  <tr key={d?._id}>
                    <td>{d?.membershipId}</td>
                    <td>{d?.siblingMembershipsOrders}</td>
                    <td>
                      {d?.createdAtAutoLocale ? d?.createdAtAutoLocale : ''}
                    </td>
                    <td>{d?.createdAtLocale ? d?.createdAtLocale : ''}</td>
                    <td>{capitalize(d?.paymentType)}</td>
                    <td>{capitalize(d?.paymentStrategy)}</td>
                    <td>{capitalize(d?.quota)}</td>
                    <td>{d?.finalAmount ? d?.finalAmount.toFixed(2) : ''}</td>
                    <td>{d?.planAmount ? d?.planAmount.toFixed(2) : ''}</td>
                    <td>{d?.rcvAmount ? d?.rcvAmount.toFixed(2) : ''}</td>
                    <td>{d?.hasRcvCard}</td>
                    <td>
                      {d?.medCertAmount ? d?.medCertAmount.toFixed(2) : ''}
                    </td>
                    <td>
                      {d?.upgradeAmount ? d?.upgradeAmount.toFixed(2) : ''}
                    </td>
                    <td>{d?.paidAmount ? d?.paidAmount.toFixed(2) : ''}</td>
                    <td>
                      {d?.paidAmountInBsS ? d?.paidAmountInBsS.toFixed(2) : ''}
                    </td>
                    <td>{d?.methodDesc}</td>
                    <td>{d?.reference}</td>
                    <td>{d?.transactionBatch}</td>
                    <td>
                      {d?.accHolder && d?.accHolder !== 'undefined'
                        ? d?.accHolder
                        : ''}
                    </td>
                    <td>{d?.observation}</td>
                    <td>{d?.cashReceiverName}</td>
                    <td>{d?.samePaymentsMemberships}</td>
                    <td>
                      {d?.paymentDuesSum ? d?.paymentDuesSum.toFixed(2) : ''}
                    </td>
                    <td>
                      {d?.pendingToPayAdjustment
                        ? d?.pendingToPayAdjustment.toFixed(2)
                        : ''}
                    </td>
                    <td>
                      {d?.pendingToPayAdjustmentReason
                        ? d?.pendingToPayAdjustmentReason
                        : ''}
                    </td>
                    <td>{d?.referenceCashea}</td>
                    <td>
                      {d?.membershipCreatedAtLocale
                        ? replaceHyphensWithSlashes(
                          d?.membershipCreatedAtLocale
                        )
                        : ''}
                    </td>
                    <td>{d?.totalChange ? d?.totalChange.toFixed(2) : ''}</td>
                    <td>{d?.change1Usd ? d?.change1Usd.toFixed(2) : ''}</td>
                    <td>{d?.change1Bs ? d?.change1Bs.toFixed(2) : ''}</td>
                    <td>{capitalize(d?.change1Method)}</td>
                    <td>{d?.change1Ref}</td>
                    <td>{d?.change1Observation}</td>
                    <td>{d?.change2Usd ? d?.change2Usd.toFixed(2) : ''}</td>
                    <td>{d?.change2Bs ? d?.change2Bs.toFixed(2) : ''}</td>
                    <td>{capitalize(d?.change2Method)}</td>
                    <td>{d?.change2Ref}</td>
                    <td>{d?.change2Observation}</td>
                    <td>{d?.change3Usd ? d?.change3Usd.toFixed(2) : ''}</td>
                    <td>{d?.change3Bs ? d?.change3Bs.toFixed(2) : ''}</td>
                    <td>{capitalize(d?.change3Method)}</td>
                    <td>{d?.change3Ref}</td>
                    <td>{d?.change3Observation}</td>
                    <td>{d?.saleChannelDesc}</td>
                    <td>{capitalize(displayMembershipCode(d?.planDesc))}</td>

                    <td>{capitalize(d?.affiliationType)}</td>
                    <td>{d?.discountCodeDesc}</td>
                    <td>{d?.hasInvoiceNumber}</td>
                    <td>{d?.invoiceNumber}</td>
                    <td>{d?.validatedPaymentDescription}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};
export const ExportableSegCorp = (props) => {
  const { header, data, title, handlePageChange } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table
          className="sales-afiliation-table table"
          onContextMenu={(e) => e.preventDefault()}
        >
          <tr
            style={{
              backgroundColor: '#fff',
            }}
          >
            {header?.map((h, i) => (
              <th style={{ fontSize: '13px' }} key={i}>
                {h?.name}
              </th>
            ))}
          </tr>

          <tbody>
            {data?.data?.length > 0 &&
              !data?.isLoading &&
              data?.data?.map((d) => {
                return (
                  <tr key={d?._id}>
                    <td>{d?.clientIdentificationType}</td>
                    <td>{d?.clientIdentification}</td>
                    <td>{d?.clientFirstName}</td>
                    <td>{d?.clientLastName}</td>
                    <td>{d?.clientGender}</td>
                    <td>{d?.clientMaritalStatus}</td>
                    <td>{d?.clientBirthday}</td>
                    <td>{d?.clientPhone}</td>
                    <td>{d?.clientAddress}</td>
                    <td>{d?.sCorpStateCode}</td>
                    <td>{d?.clientCity}</td>
                    <td>{d?.clientEmail}</td>
                    <td>{d?.ownerIdentificationType}</td>
                    <td>{d?.ownerIdentification}</td>
                    <td>{d?.ownerFirstName}</td>
                    <td>{d?.ownerLastName}</td>
                    <td>{d?.ownerGender}</td>
                    <td>{d?.ownerMaritalStatus}</td>
                    <td>{d?.ownerBirthday}</td>
                    <td>{d?.ownerPhone}</td>
                    <td>{d?.ownerAddress}</td>
                    <td>{d?.sCorpOwnerStateCode}</td>
                    <td>{d?.ownerCity}</td>
                    <td>{d?.ownerEmail}</td>
                    <td>{d?.vehicleBrandCodMarca}</td>
                    <td>{d?.vehicleBrandDescMarca}</td>
                    <td>{d?.vehicleModelCodModelo}</td>
                    <td>{d?.vehicleModelDescModelo}</td>
                    <td>{d?.vehicleVersionCodVersion}</td>
                    <td>{d?.vehicleVersionDescVersion}</td>
                    <td>{d?.vehicleTypeTipolval}</td>
                    <td>{d?.vehicleTypeCodlval}</td>
                    <td>{d?.vehicleTypeDescrip}</td>
                    <td>{d?.sCorpVehicleDESTVEH}</td>
                    <td>{d?.sCorpVehicleDESTVEHcodlVal}</td>
                    <td>{d?.vehicleUsageScorp}</td>
                    <td>{d?.vehicleClassCodlval}</td>
                    <td>{d?.vehicleClassDescrip}</td>
                    <td>{d?.vehiclePlate}</td>
                    <td>{d?.vehicleColor}</td>
                    <td>{d?.vehicleBodySerial}</td>
                    <td>{d?.vehicleEngineSerial}</td>
                    <td>{d?.vehicleSeats}</td>
                    <td>{d?.adquisitionDate}</td>
                    <td>{d?.ofic}</td>
                    <td>{d?.sCorpCurrency}</td>
                    <td>{d?.rcvNumber}</td>
                    <td>{d?.rcvEmissionDate}</td>
                    <td>{d?.rcvBeginDate}</td>
                    <td>{d?.rcvEndDate}</td>
                    <td>{d?.ramo}</td>
                    <td>{d?.personalInjury}</td>
                    <td>{d?.propertyDamage}</td>
                    <td>{d?.primeBaseEur}</td>
                    <td>{d?.limitExcess}</td>
                    <td>{d?.primeLimitExcess}</td>
                    <td>{d?.accidentalDeath}</td>
                    <td>{d?.primeAccidentalDeath}</td>
                    <td>{d?.totalInvalidity}</td>
                    <td>{d?.primeTotalInvalidity}</td>
                    <td>{d?.price}</td>
                    <td>{d?.eurRate}</td>
                    <td>{d?.comission}</td>
                    <td>{d?.receiptNumber}</td>
                    <td>{d?.receiptEmissionDate}</td>
                    <td>{d?.receiptStartDate}</td>
                    <td>{d?.receiptEndDate}</td>
                    <td>
                      {d?.identityDocument ? (
                        <a
                          href={d?.identityDocument}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {'Cédula'}
                        </a>
                      ) : (
                        ''
                      )}
                    </td>
                    <td>
                      {d?.license ? (
                        <a
                          href={d?.license}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {'Licencia'}
                        </a>
                      ) : (
                        ''
                      )}
                    </td>
                    <td>
                      {d?.circulationCard ? (
                        <a
                          href={d?.circulationCard}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {'Carnet de circulación'}
                        </a>
                      ) : (
                        ''
                      )}
                    </td>
                    <td>
                      {d?.rcv ? (
                        <a
                          href={d?.rcv}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {'Póliza RCV'}
                        </a>
                      ) : (
                        ''
                      )}
                    </td>
                    <td>
                      {d?.rcvCard ? (
                        <a
                          href={d?.rcvCard}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {'Carnet RCV'}
                        </a>
                      ) : (
                        ''
                      )}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const DueSalesTable = (props) => {
  const { header, data, title, handlePageChange } = props;

  useEffect(() => {
    const cleanup = disableCopyAndContextMenu();

    return () => cleanup && cleanup();
  }, []);

  const dollarsPayment = (data) => {
    if (
      [paymentType?.DIFERIDO, paymentType?.PENDING].includes(data?.paymentType)
    ) {
      let ammount = 0;
      for (let i = 0; i < data?.payments?.length; i++) {
        ammount = ammount + data?.payments[i]?.totalAmount;
      }
      return ammount?.toFixed(2);
    }

    if (
      data?.paymentType === paymentType?.FINANCIADO ||
      data?.paymentType === paymentType?.CASHEA
    ) {
      return data?.paymentDue.amount;
    }
  };

  const bolivarsPayment = (data) => {
    if (
      [paymentType?.DIFERIDO, paymentType?.PENDING].includes(data?.paymentType)
    ) {
      let ammount = 0;
      for (let i = 0; i < data?.payments?.length; i++) {
        ammount = ammount + data?.payments[i]?.totalAmountInBsS;
      }
      return ammount?.toFixed(2);
    }

    if (
      data?.paymentType === paymentType?.FINANCIADO ||
      data?.paymentType === paymentType?.CASHEA
    ) {
      return data?.paymentDue.amountInBsS;
    }
  };

  const paymentDate = (data) => {
    if (
      [paymentType?.DIFERIDO, paymentType?.PENDING].includes(data?.paymentType)
    ) {
      return data?.payments[0]?.createdAt
        ? moment(data?.payments[0]?.createdAt).format('DD/MM/YYYY')
        : '';
    }

    if (
      data?.paymentType === paymentType?.FINANCIADO ||
      data?.paymentType === paymentType?.CASHEA
    ) {
      if (data?.paymentDue)
        return moment(data?.paymentDue?.paymentDate).format('DD/MM/YYYY');
    }
  };

  const paymentAmount = (data, i) => {
    if (
      [paymentType?.DIFERIDO, paymentType?.PENDING].includes(data?.paymentType)
    ) {
      return data?.payments[0]?.totalAmount
        ? data?.payments[0]?.totalAmount
        : '';
    }

    if (
      data?.paymentType === paymentType?.FINANCIADO ||
      data?.paymentType === paymentType?.CASHEA
    ) {
      if (data?.paymentDue) return data?.paymentDue?.amount;
    }
  };

  const paymentAmountBs = (data, i) => {
    if (
      data?.paymentType === paymentType?.PENDING ||
      data?.paymentType === paymentType?.DIFERIDO ||
      data?.paymentType === paymentType?.CASHEA
    ) {
      return data?.payments[0]?.totalAmountInBsS
        ? data?.payments[0]?.totalAmountInBsS
        : '';
    }

    if (data?.paymentType === paymentType?.FINANCIADO) {
      if (
        data?.paymentDues?.length > 0 &&
        data?.paymentDues[1]?.paymentDetails[i]?.totalAmountInBsS
      )
        return data?.paymentDues[1]?.paymentDetails[i]?.totalAmountInBsS;
    }
  };

  const month = (data) => {
    if (
      [paymentType?.DIFERIDO, paymentType?.PENDING].includes(data?.paymentType)
    ) {
      return getMonthInSpanish(data?.payments[0]?.createdAt);
    }

    if (
      data?.paymentType === paymentType?.FINANCIADO ||
      data?.paymentType === paymentType?.CASHEA
    ) {
      if (data?.paymentDue?.paymentDate)
        return getMonthInSpanish(data?.paymentDue.paymentDate);
    }
  };

  const method = (data, index0, index1, param) => {
    if (
      [paymentType?.DIFERIDO, paymentType?.PENDING].includes(data?.paymentType)
    ) {
      return data?.payments[index1]?.[param];
    }

    if (data?.paymentType === paymentType?.FINANCIADO) {
      if (data?.paymentDues?.length > 0)
        return data?.paymentDues[index0]?.paymentDetails[index1]?.[param];
    }
  };

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table
          className="sales-afiliation-table table"
          onContextMenu={(e) => e.preventDefault()}
        >
          <tr
            style={{
              backgroundColor: '#fff',
            }}
          >
            {header?.map((h) => (
              <th style={{ fontSize: '13px' }} key={h?.name}>
                {h?.name}
              </th>
            ))}
          </tr>

          <tbody>
            {data?.data?.length > 0 &&
              !data?.isLoading &&
              data?.data?.map((d) => {
                return (
                  <tr key={d?._id}>
                    <td>{d?.membershipId}</td>
                    {/* <td>
                      {d?.seller
                        ? capitalize(
                          `${d?.seller?.firstName} ${d?.seller?.lastName}`
                        )
                        : ''}
                    </td> */}
                    <td>{capitalize(d?.customer)}</td>
                    <td>{capitalize(d?.code)}</td>
                    <td>{capitalize(d?.saleChannel)}</td>
                    <td>{capitalize(d?.affiliationType)}</td>
                    <td>
                      {d?.createdAt
                        ? moment(d?.createdAt).format('DD/MM/YYYY')
                        : ''}
                    </td>
                    <td>{capitalize(d?.paymentType)}</td>
                    <td>
                      {[paymentType?.CASHEA].includes(d?.paymentType)
                        ? moment(d?.duesLastDate).format('DD/MM/YYYY')
                        : d?.paymentDue
                          ? moment(d?.paymentDue?.dueDate).format('DD/MM/YYYY')
                          : ''}
                    </td>
                    <td>
                      {[paymentType?.CASHEA].includes(d?.paymentType)
                        ? d?.payments[0].totalAmount
                        : dollarsPayment(d)}
                    </td>
                    <td>
                      {[paymentType?.CASHEA].includes(d?.paymentType)
                        ? d?.payments[0].totalAmountInBsS
                        : bolivarsPayment(d)}
                    </td>
                    <td>
                      {[paymentType?.CASHEA].includes(d?.paymentType)
                        ? moment(d?.payments[0].createdAtAuto).format(
                          'DD/MM/YYYY'
                        )
                        : paymentDate(d)}
                    </td>
                    <td>
                      {[paymentType?.CASHEA].includes(d?.paymentType)
                        ? //formar date to show month in spanish
                        moment(d?.payments[0].createdAtAuto)
                          .locale('es')
                          .format('MMMM')
                        : month(d)}
                    </td>
                    <td>
                      {d?.payments?.[0]?.totalAmount
                        ? d?.payments[0]?.totalAmount
                        : ''}
                    </td>
                    <td>
                      {d?.payments?.[0]?.totalAmountInBsS
                        ? d?.payments[0]?.totalAmountInBsS.toFixed(2)
                        : ''}
                    </td>
                    <td>{capitalize(d?.payments[0]?.method?.method) || ''}</td>
                    <td>
                      {d?.payments?.[0]?.reference
                        ? d?.payments[0]?.reference
                        : ''}
                    </td>
                    <td>
                      {d?.payments?.[1]?.totalAmount
                        ? d?.payments[1]?.totalAmount
                        : ''}
                    </td>
                    <td>
                      {d?.payments?.[1]?.totalAmountInBsS
                        ? d?.payments[1]?.totalAmountInBsS.toFixed(2)
                        : ''}
                    </td>
                    <td>{capitalize(d?.payments[1]?.method?.method) || ''}</td>
                    <td>
                      {d?.payments?.[1]?.reference
                        ? d?.payments[1]?.reference
                        : ''}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const PendinForApprovalContentTable = (props) => {
  const { data, redirectToOrderDetail, print, header } = props;
  const showVerifiedDocuments = header?.some(
    (h) => h?.name === 'Documentos comprobados'
  );

  return (
    <>
      {data?.data?.length > 0 &&
        !data?.isLoading &&
        data?.data?.map((d) => {
          return (
            <tr
              key={d?._id}
            // style={{ backgroundColor: checkMissingVehicleFields(d) }}
            >
              {!print ? (
                <>
                  <td
                  // data-column="action"
                  >
                    <div className="table-buttons-conatiner">
                      {d?.membershipStatus !==
                        planStatus?.PENDING_FOR_APPROBAL && (
                          <TableActionButton
                            src={searchLogo}
                            action={() => redirectToOrderDetail(d)}
                          />
                        )}
                      <a
                        href={`${editURL}/${d?._id}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <div className="table-action-button">
                          <img target="_blank" src={editLogo} alt="editLogo" />
                        </div>
                      </a>
                      {d?.membershipStatus ===
                        planStatus?.PENDING_FOR_APPROBAL && (
                          <TableActionButton
                            src={copyLogo}
                            action={() => copyClipboard(d, 'pending')}
                          />
                        )}
                    </div>
                  </td>
                </>
              ) : (
                ''
              )}
              <td>{d?.membershipId}</td>
              <td>{capitalize(d?.affiliationType)}</td>
              <td>{capitalize(d?.seller)}</td>
              <td>{d?.saleChannel}</td>
              <td>{capitalize(d?.customerFullName)}</td>
              <td>{d?.customerIdentification}</td>
              <td>{d?.vehiclePlate}</td>
              <td>{d?.customerPhoneNumber}</td>
              {showVerifiedDocuments && <td>{d?.verifiedDocuments}</td>}
              <td>{capitalize(displayMembershipCode(d?.membershipCode))}</td>
              <td>{d?.verifiedPayment}</td>
              <td>{d?.paymentStatus}</td>
              <td>{d?.totalPaid.toFixed(2)}</td>
              <td>{d?.comment}</td>
              <td>{d?.createdAt}</td>
            </tr>
          );
        })}
    </>
  );
};

export const PendinForApprovalTable = (props) => {
  const {
    header,
    data,
    title,
    handlePageChange,
    redirectToEditOrder,
    redirectToOrderDetail,
  } = props;

  useEffect(() => {
    const cleanup = disableCopyAndContextMenu();

    return () => cleanup && cleanup();
  }, []);

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table
          className="sales-afiliation-table table"
          onContextMenu={(e) => handleContextMenu(e, ['action'])}
        >
          <tr
            style={{
              backgroundColor: '#fff',
            }}
          >
            {header?.map((h) => (
              <th
                key={`${h?.name}-pending`}
                style={{
                  padding: '2px 4px',
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignItems: 'center',
                  alignContent: 'center',
                  fontSize: '13px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignContent: 'center',
                  }}
                >
                  {h?.name}
                  {h?.sortable && (
                    <TableFilter
                      label={h.name}
                      options={h.filterOptions}
                      onSearch={h.filterSearch}
                    />
                  )}
                </div>
              </th>
            ))}
          </tr>

          <tbody>
            <PendinForApprovalContentTable
              data={data}
              header={header}
              redirectToOrderDetail={redirectToOrderDetail}
              redirectToEditOrder={redirectToEditOrder}
            />
          </tbody>
        </table>
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>

      {/* Table for printing */}
      <div style={{ display: 'none' }} className="table-container">
        <table className="sales-afiliation-table table">
          <tr>
            {header?.map((h) => {
              if (h?.hidePrint) {
                return null;
              } else {
                return <th key={h?.name}>{h?.name}</th>;
              }
            })}
          </tr>
          <tbody>
            <PendinForApprovalContentTable
              data={data}
              header={header}
              print={true}
              redirectToOrderDetail={redirectToOrderDetail}
              redirectToEditOrder={redirectToEditOrder}
            />
          </tbody>
        </table>
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
    </>
  );
};

export const LostContentTable = (props) => {
  const { data, redirectToOrderDetail, print } = props;
  return (
    <>
      {data?.data?.length > 0 &&
        !data?.isLoading &&
        data?.data?.map((d) => {
          return (
            <tr
              key={d?._id}
            // style={{ backgroundColor: checkMissingVehicleFields(d) }}
            >
              {!print ? (
                <td data-column="action">
                  <div className="table-buttons-conatiner">
                    {d?.membershipStatus !==
                      planStatus?.PENDING_FOR_APPROBAL && (
                        <TableActionButton
                          src={searchLogo}
                          action={() => redirectToOrderDetail(d)}
                        />
                      )}
                    <a href={`${editURL}/${d?._id}`}>
                      <div className="table-action-button">
                        <img target="_blank" src={editLogo} alt="editLogo" />
                      </div>
                    </a>
                  </div>
                </td>
              ) : null}
              <td>{d?.membershipId}</td>
              {/* <td>{capitalize(d?.membershipStatus)}</td> */}
              <td>{capitalize(d?.affiliationType)}</td>
              <td>{d?.assignedAdvisor}</td> <td>{d?.saleChannel}</td>
              <td>{d?.fleetName}</td>
              <td>{capitalize(d?.customerFullName)}</td>
              <td>{d?.customerIdentification}</td>
              <td>{d?.customerGender}</td>
              <td>{d?.vehiclePlate}</td>
              <td>{d?.customerPhoneNumber}</td>
              <td>{d?.customerEmail?.toLowerCase() || ''}</td>
              <td>{capitalize(displayMembershipCode(d?.membershipCode))}</td>
              <td>{d?.vehicleYear}</td>
              <td>{capitalize(d?.accidentRate)}</td>
              <td>{d?.totalPaid}</td>
              <td>{d?.endDate}</td>
              <td>{d?.rcvEndDate}</td>
              <td>{d?.contactInCampaign ? 'Contactar' : 'No Contactar'}</td>
            </tr>
          );
        })}
    </>
  );
};

export const LostTable = (props) => {
  const {
    header,
    data,
    title,
    handlePageChange,
    redirectToOrderDetail,

    dateFrom,
    dateTo,
  } = props;

  useEffect(() => {
    const cleanup = disableCopyAndContextMenu();

    return () => cleanup && cleanup();
  }, []);

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table
          className="sales-afiliation-table table"
          onContextMenu={(e) => handleContextMenu(e, ['action'])}
        >
          <tr
            style={{
              backgroundColor: '#fff',
            }}
          >
            {header?.map((h) => (
              <th style={{ fontSize: '13px' }} key={h?.name}>
                {h?.name}
              </th>
            ))}
          </tr>
          <tbody>
            <LostContentTable
              data={data}
              redirectToOrderDetail={redirectToOrderDetail}
            />
          </tbody>
        </table>
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
        <NoAvailableResults data={data} dateFrom={dateFrom} dateTo={dateTo} />
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>

      {/* Table for printing */}
      <div style={{ display: 'none' }} className="table-container">
        <table className="sales-afiliation-table table">
          <tr>
            {header?.map((h) => {
              if (h?.hidePrint) {
                return null;
              } else {
                return <th key={h?.name}>{h?.name}</th>;
              }
            })}
          </tr>
          <tbody>
            <LostContentTable
              data={data}
              print={true}
              redirectToOrderDetail={redirectToOrderDetail}
            />
          </tbody>
        </table>
      </div>
    </>
  );
};

export const FleetLoadDetailTable = (props) => {
  const {
    header,
    data,
    title,
    handlePageChange,
    redirectToEditOrder,

    selectAllGiftcards,
    selectGiftcard,
  } = props;

  const SelectAllCheckbox = (props) => {
    const { action, data } = props;

    let selectedCounter = 0;
    let src = '';

    for (let i = 0; i < data.length; i++) {
      if (data[i]?.selected) {
        selectedCounter = selectedCounter + 1;
      }
    }

    selectedCounter === data.length
      ? (src = grayCheckboxSelected)
      : (src = grayCheckboxUnselected);

    return (
      <img
        style={{ cursor: 'pointer' }}
        src={src}
        alt="grayCheckboxSelected"
        onClick={() => action()}
      />
    );
  };

  const RenewCheckbox = (props) => {
    const { giftcard, select, index, selectedType } = props;

    if (
      giftcard?.fleetRenewed ||
      ![
        planStatus?.EXPIRED,
        planStatus?.TO_BE_EXPIRED,
        planStatus?.TO_BE_RENEW,
      ]?.includes(giftcard?.status)
    ) {
      return null;
    }

    if (giftcard?.status === 'Canjeada') {
      return null;
    }

    if (giftcard?.status !== selectedType && selectedType) {
      return null;
    }

    if (giftcard.selected) {
      return (
        <img
          style={{ cursor: 'pointer' }}
          src={grayCheckboxSelected}
          alt="grayCheckboxSelected"
          onClick={() => select(giftcard, index)}
        />
      );
    }
    if (!giftcard.selected) {
      return (
        <img
          style={{ cursor: 'pointer' }}
          src={grayCheckboxUnselected}
          alt="grayCheckboxSelected"
          onClick={() => select(giftcard, index)}
        />
      );
    } else return null;
  };

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="sales-afiliation-table table">
          <tr>
            <td>
              <SelectAllCheckbox
                data={data?.data}
                action={selectAllGiftcards}
              />
            </td>
            {header?.map((h) => (
              <th key={h?.name}>{h?.name}</th>
            ))}
          </tr>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d, i) => {
              return (
                <tr key={d?._id}>
                  <td>
                    <RenewCheckbox
                      giftcard={d}
                      select={selectGiftcard}
                      index={i}
                      selectedType={data?.selectedType}
                    />
                  </td>
                  <td>{d?.membershipId}</td>
                  <td>{capitalize(d?.status)}</td>
                  <td>
                    {d?.createdAt
                      ? moment(d?.createdAt).format('DD/MM/YYYY')
                      : ''}
                  </td>
                  <td>{d?.firstName}</td>
                  <td>{d?.lastName}</td>
                  <td>
                    {d?.identificationType}-{d?.identification}
                  </td>
                  <td>
                    {d?.phonePrefix}-{d?.phoneNumber}
                  </td>
                  <td>{d?.email?.toLowerCase()}</td>
                  <td>{capitalize(d?.state)}</td>
                  <td>{capitalize(d?.plan)}</td>
                  <td>{capitalize(d?.vehicleBrand)}</td>
                  <td>{capitalize(d?.vehicleModel)}</td>
                  <td>{d?.vehicleYear}</td>
                  <td>{d?.vehicleColor}</td>
                  <td>{d?.vehiclePlate}</td>
                  <td>
                    {d?.beginDate
                      ? moment(d?.beginDate).format('DD/MM/YYYY')
                      : ''}
                  </td>{' '}
                  <td>
                    {d?.endDate ? moment(d?.endDate).format('DD/MM/YYYY') : ''}
                  </td>
                  <td>{d?.affiliationType}</td>
                  <td>{d?.rcv}</td>
                  <td>
                    {d?.rcvBeginDate
                      ? moment(d?.rcvBeginDate).format('DD/MM/YYYY')
                      : ''}
                  </td>{' '}
                  <td>
                    {d?.rcvEndDate
                      ? moment(d?.rcvEndDate).format('DD/MM/YYYY')
                      : ''}
                  </td>
                  <td>{d?.km}</td>
                  <td>{d?.hasExtendedTow ? 'Sí' : 'No'}</td>
                  <td>
                    <div className="table-buttons-conatiner">
                      <TableActionButton
                        src={editLogo}
                        action={() => redirectToEditOrder(d?._id)}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
        </table>
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const RenewalMembershipTable = (props) => {
  const {
    header,
    data,
    title,
    handlePageChange,
    actionOverMembership,
    handleCartModal,
    updateFromGrid,
    advisors,
    campaingActions,
    situationOptions,
  } = props;

  const isSalesCounter =
    authService?.getUserType() === salesRoles?.SALES_COUNTER;

  useEffect(() => {
    const cleanup = disableJustCopy();

    return () => cleanup && cleanup();
  }, []);

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-renewal-container" style={{}}>
        <div
          className="table-renewal-content"
          style={{
            minHeight: '320px',
          }}
        >
          <table
            className="sales-afiliation-table table"
            onContextMenu={(e) =>
              handleContextMenu(e, ['action', 'order', 'plate', 'model'])
            }
          >
            <thead
              style={{
                maxHeight: '72px',
              }}
            >
              <tr>
                {header?.map((h) => (
                  <th
                    key={`${h?.name}-renewal`}
                    style={{
                      padding: '4px 8px 4px 8px',
                      textAlign: 'center',
                      justifyContent: 'center',
                      alignItems: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: '7px',
                        width: '100%',
                        textAlign: 'center',
                        justifyContent: 'center',
                        alignItems: 'center',
                        alignContent: 'center',
                      }}
                    >
                      {h?.name}
                      {h?.sortable &&
                        (['Fecha fin plan', 'Fecha fin RCV'].includes(
                          h.name
                        ) ? (
                          <TableDateFilter onSearch={h.filterSearch} />
                        ) : (
                          <TableFilter
                            label={h.name}
                            options={h.filterOptions}
                            onSearch={h.filterSearch}
                          />
                        ))}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            {data?.data?.length > 0 &&
              !data?.isLoading &&
              data?.data?.map((d) => {
                return (
                  <tr
                    key={d?._id}
                    style={{
                      height: '72px',
                      backgroundColor: checkMissingVehicleFields(d),
                    }}
                  >
                    <td
                    // data-column="action"
                    >
                      <div className="table-buttons-conatiner">
                        <a
                          href={`${editURL}/${d?._id}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <div className="table-action-button">
                            <img
                              target="_blank"
                              src={editLogo}
                              alt="editLogo"
                            />
                          </div>
                        </a>
                        {!d?.isInRenewalCart && (
                          <TableActionButton
                            src={addToCart}
                            action={() => handleCartModal(d, 'add')}
                          />
                        )}
                        {d?.isInRenewalCart && (
                          <TableActionButton
                            src={removeFromCart}
                            action={() => handleCartModal(d, 'remove')}
                          />
                        )}
                        <TableActionButton
                          src={renewLogo}
                          action={() => actionOverMembership(d)}
                        />

                        <TableActionButton
                          src={copyLogo}
                          action={() => copyClipboard(d, 'renewal')}
                        />
                      </div>
                    </td>
                    <td
                    // data-column="order"
                    >
                      {d?.membershipId}
                    </td>
                    {/* <td>{moment(d?.createdAt).format('DD/MM/YYYY')}</td> */}
                    <td
                      style={{
                        minWidth: '200px',
                      }}
                    >
                      {isSalesCounter ? (
                        d?.advisor
                      ) : (
                        <ChangeAdvisorInput
                          cancelImg={
                            checkMissingVehicleFields(d) === null
                              ? cancel
                              : cancelWhite
                          }
                          list={advisors}
                          initialValue={d?.advisor}
                          seller={d?.sellerId}
                          sellerName={d?.sellerName}
                          placeholder={d?.advisor}
                          saveAction={updateFromGrid}
                          id={d?._id}
                        />
                      )}
                    </td>
                    <td>
                      <ChangeCampaingActionsInput
                        list={campaingActions}
                        initialValue={d?.campaignAction}
                        placeholder={d?.campaignAction}
                        saveAction={updateFromGrid}
                        id={d?._id}
                      />
                    </td>
                    <td>
                      <ChangeSituationInput
                        list={situationOptions}
                        initialValue={d?.situation}
                        placeholder={d?.situation}
                        saveAction={updateFromGrid}
                        id={d?._id}
                      />
                    </td>
                    {/* <td>{capitalize(d?.membershipStatus)}</td> */}
                    <td>
                      {capitalize(displayMembershipCode(d?.membershipCode))}
                    </td>
                    <td>{capitalize(d?.vehicle?.className)}</td>
                    <td>{d?.vehicle?.year}</td>
                    {/* <td>{d?.armored ? 'Si' : 'No'}</td> */}
                    <td>{capitalize(d?.accidentRate)}</td>
                    <td>{d?.towQuantity}</td>
                    <td>{d?.discountPercentage}</td>
                    <td>
                      <table
                        style={{
                          width: '100%',
                          backgroundColor: 'transparent',
                        }}
                      >
                        <tbody>
                          <ResumeFragment
                            factors={{
                              carYear: d?.vehicle?.year,
                              rcv: d?.rcv,
                              accidentRate: d?.accidentRate,
                              armored: d?.vehicle.armored,
                              km: d?.km,
                              unlimitedTow: d?.unlimitedTow,
                            }}
                          />
                        </tbody>
                      </table>
                    </td>
                    <td>{d?.renewalPrice}</td>
                    <td>
                      {capitalize(
                        d?.customer?.firstName + ' ' + d?.customer?.lastName
                      )}
                    </td>
                    <td
                    // data-column="plate"
                    >
                      {d?.vehicle?.plate}
                    </td>
                    <td>{capitalize(d?.vehicle?.brand)}</td>
                    <td
                    // data-column="model"
                    >
                      {capitalize(d?.vehicle?.model)}
                    </td>
                    <td>
                      {d?.customer?.identificationType}-
                      {d?.customer?.identification}
                    </td>
                    <td>
                      {d?.customer?.phonePrefix}-{d?.customer?.phoneNumber}
                    </td>
                    <td style={{ minWidth: '150px' }}>
                      {d?.customer?.optionalPhonePrefix
                        ? `${d?.customer?.optionalPhonePrefix}-${d?.customer?.optionalPhoneNumber}`
                        : ''}
                    </td>
                    <td>{d?.customer?.email?.toLowerCase()}</td>
                    <td>{d?.saleChannel}</td>
                    {/* <td>{d?.contractType}</td> */}
                    <td>{moment(d?.endDate).format('DD/MM/YYYY')}</td>
                    <td>{capitalize(d?.endMonth)}</td>
                    <td>{d?.affiliationType}</td>
                    <td>
                      {d?.rcvEndDate
                        ? moment(d?.rcvEndDate).format('DD/MM/YYYY')
                        : 'N/A'}
                    </td>
                    <td>
                      <EditAndSaveInput
                        initialValue={d?.observation}
                        placeholder="Agregar observación"
                        saveAction={updateFromGrid}
                        id={d?._id}
                      />
                    </td>
                  </tr>
                );
              })}
          </table>
          {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
        </div>
      </div>
      {data?.data.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: 'center', flexDirection: 'column' }}>
          No hay registros disponibles
        </h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const MultipleAffiliationTable = ({ table }) => {
  const { header, data, title, actions, options } = table;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-renewal-container" style={{}}>
        <div
          className="table-renewal-content"
          style={{
            minHeight: '320px',
          }}
        >
          <table className="sales-afiliation-table table">
            <thead
              style={{
                maxHeight: '72px',
              }}
            >
              <tr>
                {header?.map((h) => (
                  <th
                    key={h?.name}
                    style={{
                      padding: '4px 8px 4px 8px',
                      textAlign: 'center',
                      justifyContent: 'center',
                      alignItems: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: '7px',
                        width: '100%',
                        textAlign: 'center',
                        justifyContent: 'center',
                        alignItems: 'center',
                        alignContent: 'center',
                      }}
                    >
                      {h?.name}
                      {h?.sortable &&
                        (['Fecha fin plan', 'Fecha fin RCV'].includes(
                          h.name
                        ) ? (
                          <TableDateFilter onSearch={h.filterSearch} />
                        ) : (
                          <TableFilter
                            label={h.name}
                            options={h.filterOptions}
                            onSearch={h.filterSearch}
                          />
                        ))}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            {data?.data?.length > 0 &&
              data?.data?.map((d, i) => {
                return (
                  <tr
                    key={d?._id}
                    style={{
                      backgroundColor: validateRCVData(d.newMem)
                        ? ''
                        : '#ff0000b3',
                    }}
                  >
                    <td data-column="action">
                      <div className="table-buttons-conatiner">
                        <TableActionButton
                          src={removeFromCart}
                          action={() => actions.handleCartModal(d, 'remove')}
                        />
                      </div>
                    </td>
                    <td>{d?.newMem?.membershipId}</td>
                    <td>
                      <SelectTable
                        index={i}
                        name={'newPlan'}
                        value={d?.newMem?.code?._id}
                        options={d?.availableMemberships}
                        onChange={actions.handleSelect}
                      />
                    </td>
                    <td>
                      <SelectTable
                        index={i}
                        name={'km'}
                        value={d?.newMem?.km}
                        options={
                          [membershipCodes.GOLD, membershipCodes.GOLDM].includes(
                            d?.newMem?.code?.code
                          )
                            ? getKmServiceOptions(d?.newMem?.km)
                            : options?.KMOderOptions
                        }
                        onChange={actions.handleSelect}
                        disabled={
                          ![membershipCodes.GOLD, membershipCodes.GOLDM].includes(
                            d?.newMem?.code?.code
                          )
                        }
                      />
                    </td>
                    <td>
                      <CheckboxTable
                        disabled={!planAllowsUnlimitedTow(d?.newMem?.code?.code)}
                        value={d?.newMem?.hasExtendedTow}
                        action={actions.handleCheckbox}
                        name={'useExtendedTow'}
                        index={i}
                      />
                    </td>
                    <td>{d?.newMem?.vehicleData?.year}</td>
                    <td>{capitalize(d?.memToRenew?.accidentRate)}</td>
                    <td>{d?.memToRenew?.towServices?.length}</td>
                    <td>
                      <CheckboxTable
                        value={d?.newMem?.vehicleData?.isArmored}
                        action={actions.handleCheckbox}
                        name={'isArmored'}
                        index={i}
                      />
                    </td>
                    <td>
                      <CheckboxTable
                        value={d?.newMem?.hasRcvCard}
                        action={actions.handleCheckbox}
                        name={'hasRcvCard'}
                        index={i}
                        disabled={d?.newMem?.rcv === rcvEnum.NA ? true : false}
                      />
                    </td>
                    <td>
                      <CheckboxTable
                        disabled={[
                          paymentType.CASHEA,
                          paymentType.CASHEA_LINK,
                        ].includes(options?.currentPaymentType)}
                        value={d?.useRenewalDiscount}
                        action={actions.handleCheckbox}
                        name={'useRenewalDiscount'}
                        index={i}
                      />
                    </td>
                    <td>{`${d?.memToRenew?.renewalPercentModifier} %`}</td>
                    <td>
                      <SelectTable
                        index={i}
                        name={'rcv'}
                        value={
                          !['RCV Básico', rcvEnum?.RCV_BASIC].includes(
                            d?.newMem?.rcv
                          )
                            ? d?.newMem?.rcv
                            : 'N/A'
                        }
                        options={options?.rcvOptions}
                        backgroundColor={'#e0e1e1'}
                        onChange={actions.handleSelect}
                      />
                    </td>
                    <td>
                      <SelectTable
                        index={i}
                        name={'vehicleUsage'}
                        value={d?.newMem?.vehicleData?.vehicleUsage}
                        options={filterVehicleUse(
                          d,
                          options.vehicleClassesOptions
                        )}
                        backgroundColor={'#e0e1e1'}
                        onChange={actions.handleSelect}
                      />
                    </td>
                    <td>
                      <InputTable
                        index={i}
                        name="discountCode"
                        initialValue={
                          typeof d?.newMem?.discountCode === 'string'
                            ? d?.newMem?.discountCode
                            : d?.newMem?.discountCode?.code
                        }
                        placeholder="Código de descuento"
                        saveAction={actions.handleInput}
                      />
                    </td>
                    <td>{`${d?.newMem?.priceInfo?.finalPrice}`}</td>
                    <td>{`${d?.newMem?.priceInfo?.finalPriceInBsS}`}</td>
                    <td>
                      <SelectTable
                        index={i}
                        name={'channel'}
                        value={d?.newMem?.channel?._id}
                        options={options.salesChannelOptions}
                        backgroundColor={'#e0e1e1'}
                        onChange={actions.handleSelect}
                      />
                    </td>
                    <td>{`${d?.newMem?.customer?.firstName +
                      ' ' +
                      d?.newMem?.customer?.lastName
                      }`}</td>
                    <td>{d?.newMem?.vehicleData?.plate}</td>
                    <td>{capitalize(d?.newMem?.vehicleData?.brandName)}</td>
                    <td>{capitalize(d?.newMem?.vehicleData?.modelName)}</td>
                    <td>
                      {d?.newMem?.customer?.identificationType +
                        '-' +
                        d?.newMem?.customer?.identification}
                    </td>
                    <td>
                      {d?.newMem?.customer?.phonePrefix +
                        '-' +
                        d?.newMem?.customer?.phoneNumber}
                    </td>
                    <td>{d?.newMem?.customer?.email}</td>
                    <td>
                      {d?.memToRenew?.customer?.identityDocument ? (
                        <a
                          href={d?.memToRenew?.customer?.identityDocument}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Cedula
                        </a>
                      ) : (
                        ''
                      )}
                    </td>
                    <td>
                      {d?.memToRenew?.vehicle?.circulationCard ? (
                        <a
                          style={{ width: '200px' }}
                          href={d?.memToRenew?.vehicle?.circulationCard}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Carnet
                        </a>
                      ) : (
                        ''
                      )}
                    </td>

                    <td>
                      <p
                        style={{ color: 'blue', cursor: 'pointer' }}
                        onClick={() => actions.handleEditModal(d)}
                      >
                        Editar datos del cliente
                      </p>
                    </td>
                    <td>
                      {d?.newMem?.rcv !== rcvEnum.NA && (
                        <p
                          style={{ color: 'blue', cursor: 'pointer' }}
                          onClick={() => actions.handleEditRCVModal(d)}
                        >
                          Editar datos del RCV { }
                        </p>
                      )}
                    </td>
                  </tr>
                );
              })}
          </table>
        </div>
      </div>
      {data?.data.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: 'center', flexDirection: 'column' }}>
          No hay registros disponibles
        </h6>
      )}
    </>
  );
};
export const FleetsRegisterTable = (props) => {
  const {
    header,
    data,
    title,
    handlePageChange,
    openDetail,

    handleEditFleetForm,
  } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="table">
          <tr>
            {header?.map((h) => (
              <th key={h?.name}>{h?.name}</th>
            ))}
          </tr>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => {
              return (
                <tr key={d?._id}>
                  <td>{d?.fleetId}</td>
                  <td>{d?.name}</td>
                  <td>{d?.code}</td>
                  <td>
                    {d?.isActive ? (
                      <img style={{ height: '35px' }} src={checkStatus} />
                    ) : (
                      <img style={{ height: '40px' }} src={calendarGray} />
                    )}
                  </td>
                  <td>{d?.fleetLoads?.length}</td>
                  <td>{moment(d?.createdAt).format('DD/MM/YYYY')}</td>
                  <td>{moment(d?.updatedAt).format('DD/MM/YYYY')}</td>

                  <td>
                    <div className="table-buttons-conatiner">
                      <TableActionButton
                        src={searchLogo}
                        action={() => openDetail(d)}
                      />
                      <TableActionButton
                        src={editLogo}
                        action={() => handleEditFleetForm(d)}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
        </table>
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};


const formatAmount = (value) => {
  const num = parseFloat(value);
  if (Number.isNaN(num)) return '—';
  return num.toFixed(2);
};

const SaleTypeBadge = ({ type }) => {
  if (!type) return '—';
  const className =
    String(type).toLowerCase().includes('renov')
      ? 'intermediary-sale-badge intermediary-sale-badge-renov-interna'
      : 'intermediary-sale-badge intermediary-sale-badge-nuevo';
  return <span className={className}>{type}</span>;
};

export const IntermediaryComissionSummaryTable = (props) => {
  const { header, data, totals, onDownloadPdf, pdfLoadingId } = props;

  return (
    <div className="intermediary-comission-section">
      <div className="intermediary-comission-section-header">
        <h5>Totales por Intermediario</h5>
        <span>{data?.length || 0} intermediarios</span>
      </div>
      <div className="table-container">
        <table className="table sales-afiliation-table">
          <thead>
            <tr>
              {header?.map((h) => (
                <th
                  key={h?.name}
                  style={{
                    backgroundColor: h.color,
                    minWidth: h.color ? '100px' : '',
                  }}
                >
                  {h?.name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data?.map((row) => (
              <tr key={row?._id}>
                <td>{capitalize(row?.sellerFullName)}</td>
                <td>{row?.sold?.total ?? row?.sold?.plan ?? 0}</td>
                <td>{formatAmount(row?.amount?.plan)}</td>
                <td>{formatAmount(row?.amount?.rcv)}</td>
                <td>{formatAmount(row?.amount?.total)}</td>
                <td className="intermediary-comission-amount">
                  {formatAmount(row?.comm?.bsInUsd)}
                </td>
                <td className="intermediary-comission-amount">
                  {formatAmount(row?.comm?.usd ?? row?.comm?.total)}
                </td>
                <td>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <ActionButton
                      label={'Descargar'}
                      width={'80px'}
                      disabled={pdfLoadingId === row?.sellerId}
                      action={() => onDownloadPdf?.(row?.sellerId)}
                    />
                  </div>
                </td>
              </tr>
            ))}
            {data?.length > 0 && totals && (
              <tr className="intermediary-comission-totals-row">
                <td>
                  <strong>TOTAL GENERAL</strong>
                </td>
                <td>
                  <strong>{totals.totalSales}</strong>
                </td>
                <td>
                  <strong>{formatAmount(totals.totalPlan)}</strong>
                </td>
                <td>
                  <strong>{formatAmount(totals.totalRcv)}</strong>
                </td>
                <td>
                  <strong>{formatAmount(totals.totalNet)}</strong>
                </td>
                <td className="intermediary-comission-amount">
                  <strong>{formatAmount(totals.comissionBs)}</strong>
                </td>
                <td className="intermediary-comission-amount">
                  <strong>{formatAmount(totals.comissionUsd)}</strong>
                </td>
                <td />
              </tr>
            )}
          </tbody>
        </table>
        {data?.length <= 0 && (
          <h6 style={{ textAlign: 'center' }}>
            No hay registros disponibles para el periodo seleccionado
          </h6>
        )}
      </div>
    </div>
  );
};

export const IntermediaryComissionDetailTable = (props) => {
  const { header, data, totals, totalCount } = props;
  const recordCount = totalCount ?? data?.length ?? 0;

  return (
    <div className="intermediary-comission-section">
      <div className="intermediary-comission-section-header">
        <h5>Detalle por Membresía</h5>
        <span>{recordCount} registros</span>
      </div>
      <div className="table-container">
        <table className="table sales-afiliation-table">
          <thead>
            <tr>
              {header?.map((h) => (
                <th
                  key={h?.name}
                  style={{
                    backgroundColor: h.color,
                    minWidth: h.color ? '100px' : '',
                  }}
                >
                  {h?.name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data?.map((row) => (
              <tr key={row?._id}>
                <td className="intermediary-membership-id">{row?.membershipId}</td>
                <td>{capitalize(row?.sellerFullName)}</td>
                <td>{moment(row?.date).format('YYYY-MM-DD')}</td>
                <td>{capitalize(row?.planName)}</td>
                <td>
                  <SaleTypeBadge type={row?.affiliationType} />
                </td>
                <td>{row?.customerFullName}</td>
                <td>{formatAmount(row?.price?.plan)}</td>
                <td>{formatAmount(row?.price?.rcv)}</td>
                <td>{formatAmount(row?.price?.total)}</td>
                <td>{row?.percentComission}%</td>
                <td className="intermediary-comission-amount">
                  {formatAmount(row?.comission)}
                </td>
                <td>{row?.currency}</td>
              </tr>
            ))}
            {data?.length > 0 && totals && (
              <tr className="intermediary-comission-totals-row">
                <td colSpan={8}>
                  <strong>TOTALES</strong>
                </td>
                <td>
                  <strong>{formatAmount(totals.totalNet)}</strong>
                </td>
                <td />
                <td className="intermediary-comission-amount">
                  <strong>{formatAmount(totals.comission)}</strong>
                </td>
                <td />
              </tr>
            )}
          </tbody>
        </table>
        {data?.length <= 0 && (
          <h6 style={{ textAlign: 'center' }}>No hay registros de detalle</h6>
        )}
      </div>
    </div>
  );
};

export const ComissionTable = (props) => {
  const { header, data, redirectToAffiliations, ref } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div
        style={{
          backgroundColor: '#e2e2e2',
          padding: '10px',
          marginBottom: '12px',
        }}
      >
        <h5 style={{ margin: '0px' }}>{`${capitalize(data.items[0].seller)} (${data?.role
          })`}</h5>
      </div>
      <div className="table-container">
        <table className="table" ref={ref}>
          <tr>
            {header?.map((h) => (
              <th
                style={{
                  backgroundColor: h.color,
                  minWidth: h.color ? '100px' : '',
                }}
                key={h?.name}
              >
                {h?.name}
              </th>
            ))}
          </tr>
          {data?.items?.length > 0 &&
            !data?.isLoading &&
            data?.items?.map((d) => {
              return (
                <tr key={generateRandomKey(d?._id, d?.sellerId)}>
                  <td>
                    {filterOptionById(monthsComissionsOptions, d?.month)?.name}
                  </td>
                  <td style={{ minWidth: '100px' }}>
                    {parseFloat(d?.goal).toFixed(2)}
                  </td>
                  <td style={{ minWidth: '100px' }}>
                    {parseFloat(d?.config).toFixed(2)}
                  </td>
                  <td style={{ minWidth: '100px' }}>
                    {parseFloat(d?.soldPlan)}
                  </td>
                  <td style={{ minWidth: '100px' }}>
                    {parseFloat(d?.commExtraSell).toFixed(2)}
                  </td>
                  <td style={{ minWidth: '100px' }}>
                    {parseFloat(d?.commContinuous).toFixed(2)}
                  </td>
                  <td style={{ minWidth: '100px' }}>
                    {parseFloat(d?.soldGroup)}
                  </td>
                  <td style={{ minWidth: '100px' }}>
                    {parseFloat(d?.commGroup).toFixed(2)}
                  </td>
                  <td style={{ minWidth: '100px' }}>
                    {parseFloat(d?.soldRcv)}
                  </td>
                  <td style={{ minWidth: '100px' }}>{d?.amountPlan}</td>
                  <td style={{ minWidth: '100px' }}>{d?.amountBase}</td>
                  <td style={{ minWidth: '100px' }}>
                    {parseFloat(d?.commTotal).toFixed(2)}
                  </td>
                  <td style={{ minWidth: '100px' }}>{d?.amountMonth}</td>
                  <td style={{ minWidth: '100px' }}>{d?.amountPendingRaw}</td>
                  <td style={{ minWidth: '100px' }}>{d?.amountBasePending}</td>
                  <td style={{ minWidth: '100px' }}>{d?.amountPendingPaid}</td>
                  <td style={{ minWidth: '100px' }}>
                    {d?.soldGiftcard ? d?.soldGiftcard : 0}
                  </td>
                  <td>{d?.amountUpgrade}</td>
                  <td>{d?.amountUpgradeBase}</td>
                  <td>{d?.amountUpgradeComission}</td>
                  <td style={{ minWidth: '100px' }}>{d?.amountGiftcard}</td>
                  <td style={{ minWidth: '100px' }}>{d?.amountRcvComission}</td>
                  <td style={{ minWidth: '100px' }}>{d?.amountComission}</td>
                  <td>
                    <h6
                      style={{ color: 'blue', cursor: 'pointer' }}
                      onClick={() => redirectToAffiliations(d)}
                    >
                      Ver Afiliaciones
                    </h6>
                  </td>
                </tr>
              );
            })}
        </table>
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
        {data?.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
    </>
  );
};

export const DiscountCodesTable = (props) => {
  const {
    header,
    data,
    title,
    handlePageChange,

    handleEditCodeForm,
  } = props;

  const textFilterColumns = ['Código de descuento', 'Descuento'];

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="table">
          <tr>
            {header?.map((h) => (
              <th key={h?.name}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '7px',
                    alignContent: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    width: '100%',
                  }}
                >
                  <span>{h?.name}</span>
                  {h?.sortable &&
                    (textFilterColumns.includes(h.name) ? (
                      <TableTextFilter
                        label={h.name}
                        type={h.name === 'Descuento' ? 'number' : 'text'}
                        onSearch={h.filterSearch}
                      />
                    ) : (
                      <TableFilter
                        label={h.name}
                        options={h.filterOptions}
                        onSearch={h.filterSearch}
                      />
                    ))}
                </div>
              </th>
            ))}
          </tr>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => {
              return (
                <tr key={d?._id}>
                  <td>{moment(d?.createdAt).format('DD/MM/YYYY')}</td>
                  <td>{d?.code}</td>
                  <td>
                    {d?.discountNumber}{' '}
                    {d?.discountType === 'Porcentaje' ? '%' : '$'}
                  </td>
                  <td>
                    {d?.appliesToRenewal ? (
                      <img src={checkStatus} alt="checkStatus" />
                    ) : (
                      <img src={close} alt="close" />
                    )}
                  </td>
                  <td>
                    {d?.appliesToNew ? (
                      <img src={checkStatus} alt="checkStatus" />
                    ) : (
                      <img src={close} alt="close" />
                    )}
                  </td>
                  <td>
                    {d?.appliesToRcv ? (
                      <img src={checkStatus} alt="checkStatus" />
                    ) : (
                      <img src={close} alt="close" />
                    )}
                  </td>
                  <td style={{ fontSize: '12px' }}>
                    {d?.appliesToMemberships?.map(
                      (a) => capitalize(a?.code) + ' '
                    )}
                  </td>
                  <td>
                    {d?.validFrom
                      ? moment(d?.validFrom).format('DD/MM/YYYY h:mm a')
                      : ''}
                  </td>
                  <td>
                    {d?.validTo
                      ? moment(d?.validTo).format('DD/MM/YYYY h:mm a')
                      : ''}
                  </td>
                  <td>{d?.channel?.shortName}</td>
                  <td>{d?.campaign?.name}</td>
                  <td

                  >
                    <b style={{
                      color: d?.status === 'Activo' ? 'green' : '#ff0000',
                    }}>{d?.status}</b>
                  </td>
                  <td>{d?.quantity}</td>
                  <td>{d?.usedByMemberships?.length}</td>
                  <td>
                    <TableActionButton
                      src={editLogo}
                      action={() => handleEditCodeForm(d)}
                    />
                  </td>
                </tr>
              );
            })}
        </table>
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const GiftcardTables = (props) => {
  const {
    header,
    data,
    title,
    handlePageChange,

    handleEditCodeForm,
    handleDeleteGiftcardModal,
  } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="table">
          <tr>
            {header?.map((h) => (
              <th key={h?.name}>{h?.name}</th>
            ))}
          </tr>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => {
              return (
                <tr key={d?._id}>
                  <td>
                    {d?.saleDate
                      ? moment(d?.saleDate).format('DD/MM/YYYY')
                      : d?.saleDate}
                  </td>
                  <td>{capitalize(d?.membership?.code)}</td>
                  <td>{d?.channel?.shortName}</td>
                  <td>{d?.planAmount}</td>
                  <td>{d?.saleQuantity}</td>
                  <td>{d?.saleQuantity * d?.planAmount}</td>
                  <td>
                    {d?.createdAt
                      ? moment(d?.createdAt).format('DD/MM/YYYY')
                      : ''}
                  </td>
                  <td>
                    {d?.updatedAt
                      ? moment(d?.updatedAt).format('DD/MM/YYYY')
                      : ''}
                  </td>
                  <td>
                    <div className="table-buttons-conatiner">
                      <TableActionButton
                        src={editLogo}
                        action={() => handleEditCodeForm(d)}
                      />{' '}
                      <TableActionButton
                        src={trash}
                        action={() => handleDeleteGiftcardModal(d)}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
        </table>
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const GiftcardParticularTables = (props) => {
  const {
    header,
    data,
    title,
    handlePageChange,
    handleEditCodeForm,
    handleDeleteGiftcardModal,
    handleVerifyPaymentModal,
  } = props;

  const checkIfValidate = (d) => {
    let allValidated = true;

    for (let i = 0; i < d?.payments?.length; i++) {
      if (!d?.payments[i]?.validated) {
        allValidated = false;
      }
    }
    return allValidated;
  };

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="table">
          <tr>
            {header?.map((h) => (
              <th style={{ minWidth: '130px' }} key={h?.name}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '7px',
                    alignContent: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    width: '100%',
                  }}
                >
                  <span>{h?.name}</span>
                  {h?.sortable && (
                    <>
                      <TableFilter
                        label={h.name}
                        options={h.filterOptions}
                        onSearch={h.filterSearch}
                      />
                    </>
                  )}
                </div>
              </th>
            ))}
          </tr>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => {
              return (
                <tr key={d?._id}>
                  <td>
                    <div className="table-buttons-conatiner">
                      {d?.giftCardSold > 0 ? (
                        <TableActionButton
                          src={editLogo}
                          action={() => handleEditCodeForm(d?._id)}
                        />
                      ) : (
                        <div style={{ width: '45px' }}></div>
                      )}
                      {[salesRoles?.SALES_ADMIN]?.includes(
                        authService?.getUserType()
                      ) && (
                          <TableActionButton
                            src={trash}
                            action={() => handleDeleteGiftcardModal(d)}
                          />
                        )}
                      {!checkIfValidate(d) &&
                        d?.giftCardSold > 0 &&
                        !d?.isSecondarySale && (
                          <ActionButton
                            label="Comprobar Pagos"
                            action={() => handleVerifyPaymentModal(d)}
                          />
                        )}
                    </div>
                  </td>

                  <td>
                    {d?.saleDate
                      ? moment(d?.saleDate).format('DD/MM/YYYY')
                      : d?.saleDate}
                  </td>
                  <td>{capitalize(d?.membership?.code)}</td>
                  <td>{d?.channel?.shortName}</td>
                  <td>{d?.giftCardSold}</td>
                  <td>{d?.giftCard?.salePrice}</td>
                  <td>{d?.discount}</td>
                  <td>{d?.publicCode}</td>
                  <td>{d?.saleType}</td>
                  <td>
                    {d?.customer?.firstName} {d?.customer?.lastName}
                  </td>
                  <td>
                    +{d?.customer?.phonePrefix}
                    {d?.customer?.phoneNumber}
                  </td>
                  <td>{d?.customer?.email}</td>
                  <td>{capitalize(d?.sellerNames)}</td>
                  {Array.from({
                    length: MAX_PAYMENT_METHODS,
                  }).map((_, i) => {
                    const n = i + 1;
                    const amount = d?.[`pay${n}Amount`] ?? '';
                    const amountBs = d?.[`pay${n}AmountBs`] ?? '';
                    const method = d?.[`pay${n}Method`]
                      ? capitalize(d?.[`pay${n}Method`])
                      : '';
                    const reference =
                      d?.[`pay${n}Reference`] ?? d?.[`pay${n}Ref`] ?? '';
                    const cashReceiver = d?.[`pay${n}CashReceiver`] ?? '';
                    return (
                      <React.Fragment key={`payment-${n}`}>
                        <td>{amount}</td>
                        <td>{amountBs}</td>
                        <td>{method}</td>
                        <td>{reference}</td>
                        <td>{cashReceiver}</td>
                        <td
                          style={{
                            display: 'flex',
                            textAlign: 'center',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          {d?.payments && d?.payments[i]?.referenceImg ? (
                            <a
                              style={{
                                color: '#F27730',
                                cursor: 'pointer',
                                textDecoration: 'underline',
                                fontSize: '12px',
                                textAlign: 'center',
                              }}
                              target="_blank"
                              rel="noreferrer"
                              href={d?.payments?.[i]?.referenceImg}
                            >
                              Ver Comprobante
                            </a>
                          ) : (
                            ''
                          )}
                        </td>
                        {d?.payments[i] ? (
                          <td>
                            {d?.payments[i]?.validated
                              ? 'Validado'
                              : 'No Validado'}
                          </td>
                        ) : (
                          <td></td>
                        )}
                      </React.Fragment>
                    );
                  })}
                  <td>{capitalize(d?.vehicleClass)}</td>
                  <td>{d?.vehicleYear}</td>
                  <td>{d?.vehicleIsArmored}</td>
                  <td>{d?.planKm}</td>
                  <td>{d?.unlimitedKm ? 'Si' : 'No'}</td>
                  <td>{d?.rcvType}</td>
                  <td>{d?.vehicleYear}</td>
                  <td>{d?.totalChange}</td>
                  {Array.from({
                    length: 3,
                  }).map((_, i) => {
                    const n = i + 1;
                    const amount = d?.[`change${n}Amount`] ?? '';
                    const amountBs = d?.[`change${n}AmountBs`] ?? '';
                    const method = d?.[`change${n}Method`]
                      ? capitalize(d?.[`change${n}Method`])
                      : '';
                    const reference =
                      d?.[`change${n}Reference`] ?? d?.[`change${n}Ref`] ?? '';
                    return (
                      <React.Fragment key={`payment-${n}`}>
                        <td>{amount}</td>
                        <td>{amountBs}</td>
                        <td>{method}</td>
                        <td>{reference}</td>
                        <td
                          style={{
                            display: 'flex',
                            textAlign: 'center',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          {d?.paymentChanges &&
                            d?.paymentChanges[i]?.referenceImg ? (
                            <a
                              style={{
                                color: '#F27730',
                                cursor: 'pointer',
                                textDecoration: 'underline',
                                fontSize: '12px',
                                textAlign: 'center',
                              }}
                              target="_blank"
                              rel="noreferrer"
                              href={d?.paymentChanges?.[i]?.referenceImg}
                            >
                              Ver Comprobante
                            </a>
                          ) : (
                            ''
                          )}
                        </td>
                      </React.Fragment>
                    );
                  })}
                </tr>
              );
            })}
        </table>
        {data?.data?.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const FleetLoadPaymentStatus = (props) => {
  const { payment, handleReportPaymentPlanModal, index } = props;

  if (
    [fleetLoadPaymentStatus?.PENDING, fleetLoadPaymentStatus?.EXPIRED].includes(
      payment?.status
    )
  ) {
    return (
      <span
        onClick={() => handleReportPaymentPlanModal(payment, index)}
        className="link-look-alike"
        style={{ color: '#FF722C' }}
      >
        Registrar pago
      </span>
    );
  } else {
    return null;
  }
};

export const PaymentPlanTable = (props) => {
  const { header, data, handleReportPaymentPlanModal, paymentForm } = props;
  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component"></div>
      <div className="table-container">
        <table className="table">
          <tr>
            {header?.map((h) => (
              <th key={h?.name}>{h?.name}</th>
            ))}
          </tr>
          {data?.length > 0 &&
            data?.map((d, index) => {
              return (
                <tr key={d?._id}>
                  <td>{d?.number}</td>
                  <td>
                    {d?.dueDate ? moment(d?.dueDate).format('DD/MM/YYYY') : ''}
                  </td>
                  <td>{d?.amount}</td>
                  <td>{d?.status}</td>
                  <td>
                    <FleetLoadPaymentStatus
                      payment={d}
                      index={index}
                      handleReportPaymentPlanModal={
                        handleReportPaymentPlanModal
                      }
                    />
                  </td>
                </tr>
              );
            })}
        </table>
      </div>
    </>
  );
};

export const GiftCardCheckbox = (props) => {
  const { giftcard, select, index, selectedType } = props;

  if (giftcard?.status === 'Canjeada') {
    return null;
  }

  if (giftcard?.status !== selectedType && selectedType) {
    return null;
  }

  if (giftcard.selected) {
    return (
      <img
        style={{ cursor: 'pointer' }}
        src={grayCheckboxSelected}
        alt="grayCheckboxSelected"
        onClick={() => select(giftcard, index)}
      />
    );
  }
  if (!giftcard.selected) {
    return (
      <img
        style={{ cursor: 'pointer' }}
        src={grayCheckboxUnselected}
        alt="grayCheckboxSelected"
        onClick={() => select(giftcard, index)}
      />
    );
  } else return null;
};

export const SelectAllCheckbox = (props) => {
  const { data, action } = props;

  let selected = false;
  let [card] = data?.data?.filter((d) => d?.selected === true);
  let status = card?.status;
  let selectedCounter = data?.data?.filter(
    (d) =>
      d?.status === card?.status &&
      d?.selected === true &&
      d?.status !== 'Canjeada'
  );
  let providerNameCounter = 0;
  for (let i = 0; i < data?.data?.length; i++) {
    if (
      data?.data[i]?.status === card?.status &&
      data?.data[i]?.status !== 'Canjeada'
    ) {
      providerNameCounter = providerNameCounter + 1;
    }

    if (data?.data[i]?.selected) {
      selected = true;
    }
  }
  if (!selected) return null;
  if (selected && selectedCounter?.length === providerNameCounter) {
    return (
      <img
        style={{ cursor: 'pointer' }}
        src={grayCheckboxSelected}
        alt="grayCheckboxSelected"
        onClick={() => action(false, status)}
      />
    );
  } else {
    return (
      <img
        style={{ cursor: 'pointer' }}
        src={grayCheckboxUnselected}
        alt="grayCheckboxSelected"
        onClick={() => action(true, status)}
      />
    );
  }
};

export const GiftcardCodesTables = (props) => {
  const {
    header,
    data,
    title,
    handlePageChange,

    selectGiftcard,
    handleActivateGiftcardForm,
    handleBlockGiftcardForm,
    selectAllGiftcards,
  } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="table">
          <tr>
            <th>
              {data?.data?.filter((d) => d?.selected)?.length > 0 && (
                <SelectAllCheckbox data={data} action={selectAllGiftcards} />
              )}
            </th>

            {header?.map((h) => (
              <th key={h?.name}>{h?.name}</th>
            ))}
          </tr>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d, i) => {
              return (
                <tr key={d?._id}>
                  <td>
                    <GiftCardCheckbox
                      giftcard={d}
                      select={selectGiftcard}
                      index={i}
                      selectedType={data?.selectedType}
                    />
                  </td>
                  <td>{d?.publicCode}</td>
                  <td>{d?.privateCode}</td>
                  <td>{capitalize(d?.appliesToMembership?.code)}</td>
                  <td>{d?.rcvFromCreate ? 'Si' : 'No'}</td>
                  <td>
                    {d?.status === 'Inactiva' ? '' : d?.channel?.shortName}
                  </td>
                  <td>
                    {d?.status === 'Activa' && (
                      <img src={checkStatus} alt="checkStatus" />
                    )}
                    {d?.status === 'Inactiva' && (
                      <img src={close} alt="close" />
                    )}
                    {!['Activa', 'Inactiva'].includes(d?.status) && d?.status}
                  </td>
                  <td>
                    {d?.status === 'Activa' && (
                      <AltButton
                        label={'Bloquear'}
                        action={() => handleBlockGiftcardForm(d)}
                      />
                    )}
                    {d?.status === 'Inactiva' && (
                      <ActionButton
                        label={'Activar'}
                        action={() => handleActivateGiftcardForm(d)}
                      />
                    )}{' '}
                  </td>
                </tr>
              );
            })}
        </table>
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const SalesUserTable = (props) => {
  const {
    header,
    data,
    title,
    handlePageChange,
    openDetail,

    handleEditFleetForm,
  } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="table">
          <tr>
            {header?.map((h) => (
              <th key={h?.name}>{h?.name}</th>
            ))}
          </tr>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => {
              return (
                <tr key={d?._id}>
                  <td>
                    {d?.firstName} {d?.lastName}
                  </td>
                  <td>{d?.email}</td>
                  <td>{transcriptRoles(d?.role)} {d?.role === salesRoles?.SALES_COUNTER ? exists(d?.type) : ''}</td>
                  <td>{capitalize(d?.saleChannel?.channel)}</td>
                  <td>{d?.status}</td>
                  <td>{moment(d?.createdAt).format('DD/MM/YYYY')}</td>
                  <td>{moment(d?.updatedAt).format('DD/MM/YYYY')}</td>

                  <td>
                    <div className="table-buttons-conatiner">
                      <TableActionButton
                        src={editLogo}
                        action={() => handleEditFleetForm(d)}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
        </table>
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const SalesChannelsTable = (props) => {
  const { header, data, title, handlePageChange } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="table">
          <tr>
            {header?.map((h) => (
              <th key={h?.name}>{h?.name}</th>
            ))}
          </tr>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => {
              return (
                <tr key={d?._id}>
                  <td>{d?.name}</td>
                  <td>{d?.qrId}</td>
                  <td>
                    <CopyToClipboard
                      text={
                        // window.location.origin +
                        d?.f2Link
                      }
                    >
                      <div className="copy-payment-data-image-button-container">
                        <h6>Copiar</h6>
                      </div>
                    </CopyToClipboard>
                  </td>
                  <td>
                    <CopyToClipboard
                      text={
                        // window.location.origin +
                        d?.f4Link
                      }
                    >
                      <div className="copy-payment-data-image-button-container">
                        <h6>Copiar</h6>
                      </div>
                    </CopyToClipboard>
                  </td>
                  <td>
                    <CopyToClipboard
                      text={
                        // window.location.origin +
                        d?.retailLink
                      }
                    >
                      <div className="copy-payment-data-image-button-container">
                        <h6>Copiar</h6>
                      </div>
                    </CopyToClipboard>
                  </td>
                  <td>
                    <a target="_blank" href={d?.qrCodeF2} rel="noreferrer">
                      Código
                    </a>
                  </td>
                  <td>
                    <a target="_blank" href={d?.qrCode} rel="noreferrer">
                      Código
                    </a>
                  </td>
                  <td>
                    <a target="_blank" href={d?.qrCodePlusF4} rel="noreferrer">
                      Código
                    </a>
                  </td>
                  <td>{d?.isActive ? 'Activo' : 'Inactivo'}</td>
                </tr>
              );
            })}
        </table>
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const FleetsDetailTable = (props) => {
  const {
    header,
    data,
    title,
    handlePageChange,
    handleCancelFleetLoadForm,
    handleDeleteFleetLoadForm,
    handleActivateFleetLoadForm,
    handleStatusModal,
    handlePaymentPlanModal,
    redirectToAffiliationLink,
    redirectToLoadDetail,
  } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="table">
          <tr>
            {header?.map((h) => (
              <th key={h?.name}>{h?.name}</th>
            ))}
          </tr>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => {
              return (
                <tr key={d?._id}>
                  <td>{d?.fleetLoadId}</td>
                  <td>{d?.type}</td>
                  <td>{d?.contractPrice}</td>
                  <td>
                    <span
                      onClick={() => handlePaymentPlanModal(d)}
                      className="link-look-alike"
                    >
                      {capitalize(d?.paymentMethod) + ' '}
                      {capitalize(d?.financingTerm)}
                    </span>
                  </td>
                  <td>
                    {d?.planStartDate
                      ? moment(d?.planStartDate).format('DD/MM/YYYY')
                      : ''}
                  </td>
                  <td>
                    {d?.planEndDate
                      ? moment(d?.planEndDate).format('DD/MM/YYYY')
                      : ''}
                  </td>
                  <td>{d?.memberships?.length}</td>
                  <td>
                    {d?.loadStrategy === 'Link' && (
                      <span
                        onClick={() => redirectToAffiliationLink(d?.linkToken)}
                        className="link-look-alike"
                      >
                        Link
                      </span>
                    )}
                  </td>
                  <td>
                    <span
                      onClick={() => handleStatusModal(d)}
                      className="link-look-alike"
                    >
                      {d?.status}
                    </span>
                  </td>
                  <td>
                    {d?._id && (
                      <span
                        onClick={() => redirectToLoadDetail(d?._id)}
                        className="link-look-alike"
                      >
                        Detalles
                      </span>
                    )}
                  </td>
                  <td>
                    <div className="table-buttons-conatiner">
                      {!['Cancelada', 'Anulada', 'Eliminada'].includes(
                        d?.status
                      ) && (
                          <TableActionButton
                            src={offLogo}
                            action={() => handleCancelFleetLoadForm(d)}
                          />
                        )}
                      {['Cancelada', 'Anulada'].includes(d?.status) && (
                        <TableActionButton
                          src={onLogo}
                          action={() => handleActivateFleetLoadForm(d)}
                        />
                      )}
                      {!['Eliminada'].includes(d?.status) && (
                        <TableActionButton
                          src={trash}
                          action={() => handleDeleteFleetLoadForm(d)}
                        />
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
        </table>
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const PricesTable = (props) => {
  const { header, data, title } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="prices-table table">
          <tr>
            {header?.map((h) => (
              <th key={h?.name}>{h?.name}</th>
            ))}
          </tr>
          {data?.map((d, i) => {
            return (
              <>
                <tr
                  className={`fila-` + (i % 2 == 0 ? 'par' : 'impar')}
                  key={d?._id}
                >
                  <td className="precentage precentage-up">
                    <b>
                      {d?.percentage === 0
                        ? 'Precio Full'
                        : d?.percentage + '% OFF'}{' '}
                    </b>
                  </td>
                  <td>{d?.plans?.classic?.usd} $</td>
                  <td>{d?.plans?.plus?.usd} $</td>
                  <td>{d?.plans?.gold?.usd} $</td>
                  <td>{d?.plans?.motorider?.usd} $</td>
                </tr>
                <tr className={`fila-` + (i % 2 == 0 ? 'par' : 'impar')}>
                  <td className="precentage precentage-down"></td>
                  <td>{d?.plans?.classic?.bss} BsS</td>
                  <td>{d?.plans?.plus?.bss} BsS</td>
                  <td>{d?.plans?.gold?.bss} BsS</td>{' '}
                  <td>{d?.plans?.motorider?.bss} BsS</td>{' '}
                </tr>
              </>
            );
          })}
        </table>
      </div>
    </>
  );
};

export const VehiclesMembershipTable = (props) => {
  const { header, data, title, redirectToEdit, handleHistoryModal } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="vehicles-table table">
          <tr>
            {header?.map((h) => (
              <th key={h?.name}>{h?.name}</th>
            ))}
          </tr>
          {data?.length > 0 &&
            data?.map((d) => {
              return (
                <tr key={d?._id}>
                  <td>
                    <TableActionButton
                      src={editLogo}
                      action={() => redirectToEdit(d?._id)}
                    />
                  </td>
                  <td>{d?.saleChannel}</td>
                  <td>{d?.membershipId}</td>
                  <td>{d?.code}</td>
                  <td>{capitalize(d?.status)}</td>
                  <td>{d?.towServices.length}</td>
                  <td>{capitalize(d?.accidentRate)}</td>
                  <td>{d?.affiliationType}</td>
                  <td>{capitalize(d?.seller)}</td>
                  <td>
                    {d?.rcvEndDate
                      ? moment(d?.rcvEndDate).format('DD/MM/YYYY')
                      : ''}
                  </td>
                  <td>
                    {d?.endDate ? moment(d?.endDate).format('DD/MM/YYYY') : ''}
                  </td>
                  <td>{capitalize(d?.rcv)}</td>
                  <td>
                    <img
                      style={{ cursor: 'pointer' }}
                      src={eye}
                      onClick={() => handleHistoryModal(d)}
                    />
                  </td>
                </tr>
              );
            })}
        </table>
      </div>
    </>
  );
};

export const VehiclesPAPMembershipTable = (props) => {
  const { header, data, title, redirectToEdit, client } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="vehicles-table table">
          <tr>
            {header?.map((h) => (
              <th key={h?.name}>{h?.name}</th>
            ))}
          </tr>
          {data?.length > 0 &&
            data?.map((d) => {
              return (
                <tr key={d?._id}>
                  <td>
                    <TableActionButton
                      src={editLogo}
                      action={() => redirectToEdit(d)}
                    />
                  </td>
                  <td>{d?.code}</td>
                  <td>{d?.saleChannel?.shortName}</td>
                  <td>{d?.createdAt}</td>
                  <td>{d?.startDate}</td>
                  <td>{d?.endDate}</td>
                  <td>{d?.status}</td>
                  <td>{client?.gotMembership ? 'Sí' : 'No'}</td>
                  <td>{d?.numServices}</td>{' '}
                </tr>
              );
            })}
        </table>
      </div>
    </>
  );
};

// Reportes: solo se muestra el km cuando difiere de la cobertura base vigente
// (Gold = 400 km). Se mantiene visible el km heredado de 300 en membresías existentes.
// La política depende de la fecha de creación de cada fila (createdAt puede venir
// como DD/MM/YYYY o ISO).
const extraKmLabel = (km, createdAt) => {
  const value = Number(km);
  const parsed = createdAt
    ? moment(createdAt, ['DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY', moment.ISO_8601])
    : null;
  const rulesDate = parsed?.isValid() ? parsed.format('YYYY-MM-DD') : undefined;
  if (!isNewPlanRulesActive(rulesDate)) return km && km > 200 ? km : '';
  return value === 300 || value > 400 ? value : '';
};

const Service = (props) => {
  const { service } = props;

  return <span>{capitalize(service?.product)}</span>;
};

export const MembershipHistoryTable = (props) => {
  const { header, data } = props;

  return (
    <>
      <div className="table-container">
        <table className="table">
          <tr>
            {header?.map((h) => (
              <th key={h?.value}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: 'pointer' }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>
          {data?.services?.length > 0 &&
            data?.services?.map((d) => (
              <tr key={d?._id}>
                <td>
                  {d?.createdAt
                    ? moment(d?.createdAt).format('DD/MM/YYYY')
                    : ''}
                </td>
                <td>{capitalize(d?.fault)}</td>
                <td>{capitalize(d?.product)}</td>
                <td>{d?.km ? d?.km + ' Km' : 'N/A'}</td>
              </tr>
            ))}
        </table>
        {data.length <= 0 && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
    </>
  );
};

const ResumeFragment = (props) => {
  const { factors } = props;

  return (
    <>
      {factors.carYear >= 2000 && factors.carYear <= 2005 && (
        <tr
          style={{
            border: 'none',
            textAlign: 'center',
            width: '100%',
            padding: 0,
            backgroundColor: 'transparent',
          }}
        >
          <td
            style={{
              width: '100%',
              padding: 0,
              backgroundColor: 'transparent',
            }}
          >
            Nuevo Precio
          </td>
        </tr>
      )}
      {factors.carYear >= 1990 && factors.carYear <= 1999 && (
        <tr
          style={{
            border: 'none',
            textAlign: 'center',
            width: '100%',
            padding: 0,
            backgroundColor: 'transparent',
          }}
        >
          <td
            style={{
              width: '100%',
              padding: 0,
              backgroundColor: 'transparent',
            }}
          >
            90's
          </td>
        </tr>
      )}
      {factors.rcv === 'N/A' && (
        <tr
          style={{
            border: 'none',
            textAlign: 'center',
            width: '100%',
            padding: 0,
            backgroundColor: 'transparent',
          }}
        >
          <td
            style={{
              width: '100%',
              padding: 0,
              backgroundColor: 'transparent',
            }}
          >
            Sin RCV
          </td>
        </tr>
      )}
      {factors.rcv === 'RCV INTERVIAL BÁSICO' && (
        <tr
          style={{
            border: 'none',
            textAlign: 'center',
            width: '100%',
            padding: 0,
            backgroundColor: 'transparent',
          }}
        >
          <td
            style={{
              width: '100%',
              padding: 0,
              backgroundColor: 'transparent',
            }}
          >
            RCV Élite
          </td>
        </tr>
      )}
      {factors.rcv === rcvEnum.RCV_BASIC && (
        <tr
          style={{
            border: 'none',
            textAlign: 'center',
            width: '100%',
            padding: 0,
            backgroundColor: 'transparent',
          }}
        >
          <td
            style={{
              width: '100%',
              padding: 0,
              backgroundColor: 'transparent',
            }}
          >
            RCV Básico
          </td>
        </tr>
      )}
      {factors.rcv === rcvEnum.RCV_STANDARD && (
        <tr
          style={{
            border: 'none',
            textAlign: 'center',
            width: '100%',
            padding: 0,
            backgroundColor: 'transparent',
          }}
        >
          <td
            style={{
              width: '100%',
              padding: 0,
              backgroundColor: 'transparent',
            }}
          >
            RCV Standard
          </td>
        </tr>
      )}
      {factors.rcv === rcvEnum.RCV_PREMIUM && (
        <tr
          style={{
            border: 'none',
            textAlign: 'center',
            width: '100%',
            padding: 0,
            backgroundColor: 'transparent',
          }}
        >
          <td
            style={{
              width: '100%',
              padding: 0,
              backgroundColor: 'transparent',
            }}
          >
            RCV Premium
          </td>
        </tr>
      )}
      {factors.km === 300 && (
        <tr
          style={{
            border: 'none',
            textAlign: 'center',
            width: '100%',
            padding: 0,
            backgroundColor: 'transparent',
          }}
        >
          <td
            style={{
              width: '100%',
              padding: 0,
              backgroundColor: 'transparent',
            }}
          >
            300KM
          </td>
        </tr>
      )}
      {factors.accidentRate === 'ORO' && factors.unlimitedTow && (
        <tr
          style={{
            border: 'none',
            textAlign: 'center',
            width: '100%',
            padding: 0,
            backgroundColor: 'transparent',
          }}
        >
          <td
            style={{
              width: '100%',
              padding: 0,
              backgroundColor: 'transparent',
            }}
          >
            KM ilimitado
          </td>
        </tr>
      )}
      {(factors.accidentRate === 'TALLER4' ||
        factors.accidentRate === 'TALLER+') && (
          <tr
            style={{
              border: 'none',
              textAlign: 'center',
              width: '100%',
              padding: 0,
              backgroundColor: 'transparent',
            }}
          >
            <td
              style={{
                width: '100%',
                padding: 0,
                backgroundColor: 'transparent',
              }}
            >
              Siniestralidad
            </td>
          </tr>
        )}
      {factors.armored && (
        <tr
          style={{
            border: 'none',
            textAlign: 'center',
            width: '100%',
            padding: 0,
            backgroundColor: 'transparent',
          }}
        >
          <td
            style={{
              width: '100%',
              padding: 0,
              backgroundColor: 'transparent',
            }}
          >
            Blindaje
          </td>
        </tr>
      )}
    </>
  );
};

export const MultiplePaymentsTable = ({ table }) => {
  const {
    fileUploaded,
    onChange,
    header,
    dollarRate,
    watch,
    register,
    errors,
    options,
    action,
    validation,
    responsive,
  } = table;

  if (
    [
      paymentType?.PENDING,
      paymentType?.DIFERIDO,
      paymentType?.COURTESY,
    ].includes(watch('paymentType'))
  ) {
    return null;
  }

  if ([paymentType?.COURTESY].includes(watch('paymentTypeFake'))) {
    return null;
  }

  if (!watch('paymentMethodsQuantity') || !watch('billAmount')) {
    return null;
  }

  // If no quota plan is set dont show the table
  if (
    [paymentType?.CASHEA].includes(watch('paymentType')) &&
    !watch('referenceCashea')
  ) {
    return null;
  }

  return (
    <>
      <div
        className={
          responsive ? `mutiple-table-container` : 'mutiple-table-container'
        }
      >
        {table.label && <h5 style={{ marginTop: '12px' }}>Pagos Realizados</h5>}
        <table
          className={
            responsive
              ? `table multiple-payments-table`
              : `table multiple-payments-table`
          }
        >
          <tr>
            {header?.map((h, i) => {
              if (h?.name === 'Observacion' && !authService.getUser()) {
                return null;
              }
              return (
                <th
                  key={h?.name + i}
                  style={{ display: h?.hide ? 'none' : '' }}
                >
                  {h?.name}
                </th>
              );
            })}
          </tr>

          {Array.from({
            length: parseFloat(watch('paymentMethodsQuantity')),
          }).map((_, i) => (
            <tr key={i}>
              <td>
                <Input
                  width={'150px'}
                  label={''}
                  type={'select'}
                  name={`method${i}`}
                  register={register}
                  options={options?.paymemtMethodOptions}
                  placeholder={''}
                  onChange={() => onChange.handleMethodChange(i)}
                  // disabled={table?.fileUploaded[0]?.name || watch(`reference0`)}
                  disabled={
                    filterOptionById(
                      options?.paymemtMethodOptions,
                      watch(`method${i}`)
                    )?.name === paymentMethods.TDC &&
                    (table?.fileUploaded[i]?.name || watch(`reference${i}`))
                  }
                  errors={errors?.[`method${i}`]?.message}
                />
              </td>
              <td>
                <div className="center-payment-amount-input">
                  <Input
                    width={'100px'}
                    label={''}
                    type={'number'}
                    name={`amount${i}`}
                    register={register}
                    options={[]}
                    placeholder={''}
                    onChange={() => onChange.handleAmountChange(i)}
                    disabled={
                      parseFloat(watch('paymentMethodsQuantity')) === 1 ||
                      table?.fileUploaded[0]?.name ||
                      watch(`reference0`)
                    }
                    errors={errors?.[`amount${i}`]?.message}
                  />
                </div>
              </td>
              <td>
                {authService.getUserType() ? (
                  <Input
                    width={'100px'}
                    label={''}
                    type={'number'}
                    name={`amountBsS${i}`}
                    register={register}
                    options={[]}
                    placeholder={''}
                    onChange={() => onChange.handleAmountChangeBs(i)}
                    errors={errors?.[`amountBsS${i}`]?.message}
                  />
                ) : (
                  watch(`amountBsS${i}`)
                )}
              </td>
              <td>
                <Input
                  width={'100px'}
                  label={''}
                  type={'number'}
                  name={`IGTF${i}`}
                  register={register}
                  options={[]}
                  placeholder={''}
                  onChange={() => onChange.handleIGTFChange(i)}
                  disabled={
                    authService.getUserType() ||
                    table?.fileUploaded[0]?.name ||
                    watch(`reference0`)
                  }
                  errors={errors?.[`IGTF${i}`]?.message}
                />
              </td>
              <td>{watch(`finalAmount${i}`)}</td>
              <td>{watch(`finalAmountBsS${i}`)}</td>
              <td>{watch(`reference${i}`)}</td>
              <td>{watch(`transactionBatch${i}`)}</td>
              <td>
                <p style={{ fontSize: '10px' }}>{fileUploaded[i]?.name}</p>
              </td>
              {authService.getUserType() && (
                <td>
                  <Input
                    width={'100px'}
                    label={''}
                    type={'textarea'}
                    name={`observation${i}`}
                    register={register}
                    placeholder={''}
                    errors={errors?.[`observation${i}`]?.message}
                  />
                </td>
              )}
              <td>
                {validation.validateIfCanPay(i) && (
                  <>
                    {table?.fileUploaded[i] ||
                      watch(`reference${i}` || watch('otp')) ? (
                      <div className="buttons-container">
                        <ActionButton
                          label={'Editar'}
                          action={() => action?.handlePaymentModal(i)}
                          disabled={
                            filterOptionById(
                              options?.paymemtMethodOptions,
                              watch(`method${i}`)
                            )?.name === paymentMethods.TDC &&
                            (table?.fileUploaded[i]?.name ||
                              watch(`reference${i}`))
                          }
                        />
                      </div>
                    ) : (
                      <ActionButton
                        label={watch(`otp${i}`) ? 'Editar' : 'Pagar'}
                        action={() => action?.handlePaymentModal(i)}
                      />
                    )}
                  </>
                )}
              </td>
            </tr>
          ))}

          <tr>
            <td style={{ padding: '12px' }}>
              <b style={{ fontSize: '14px' }}>Total</b>
            </td>
            <td>
              {parseFloat(watch('amount0')) > 0 &&
                sumTotal(watch, 'amount', watch('paymentMethodsQuantity')) !==
                parseFloat(watch('billAmount')) ? (
                <>
                  {sumTotal(watch, 'amount', watch('paymentMethodsQuantity'))}
                  <br />{' '}
                  <p style={{ color: 'red' }}>
                    {authService.getUser()
                      ? amountValdiationMessage(
                        sumTotal(
                          watch,
                          'amount',
                          watch('paymentMethodsQuantity')
                        ),
                        watch('billAmount')
                      )
                      : 'a'}
                    {!authService.getUser()
                      ? 'La suma de los montos debe ser igual al monto facturado'
                      : null}
                    <br />
                    {watch('billAmount')} $
                  </p>
                </>
              ) : (
                <>
                  {sumTotal(watch, 'amount', watch('paymentMethodsQuantity'))}
                </>
              )}
            </td>
            <td>
              <>
                {sumTotal(watch, 'amountBsS', watch('paymentMethodsQuantity'))}
              </>
            </td>
            <td>
              {parseFloat(watch('amount0')) > 0 &&
                sumTotal(watch, 'IGTF', watch('paymentMethodsQuantity')) !==
                NaNtoNumber(parseFloat(watch('totalIGTF'))) ? (
                <>
                  {sumTotal(watch, 'IGTF', watch('paymentMethodsQuantity'))}
                  <br />{' '}
                  <p style={{ color: 'red' }}>
                    La suma de los montos debe ser igual al total de IGTF{' '}
                    {watch('totalIGTF')}$
                  </p>
                </>
              ) : (
                <>{sumTotal(watch, 'IGTF', watch('paymentMethodsQuantity'))}</>
              )}
            </td>
            <td>
              <b style={{ fontSize: '18px' }}>
                {NaNtoNumber(
                  parseFloat(
                    sumTotal(watch, 'amount', watch('paymentMethodsQuantity'))
                  ) + parseFloat(watch('totalIGTF'))
                )}
              </b>
            </td>
            <td>
              <b style={{ fontSize: '18px' }}>
                {authService.getUserType()
                  ? sumTotal(
                    watch,
                    'amountBsS',
                    watch('paymentMethodsQuantity')
                  )
                  : NaNtoNumber(
                    (parseFloat(
                      sumTotal(
                        watch,
                        'amount',
                        watch('paymentMethodsQuantity')
                      )
                    ) +
                      parseFloat(watch('totalIGTF'))) *
                    dollarRate
                  ).toFixed(2)}
              </b>
            </td>
            <td></td>
            <td></td>
            <td></td>
            {authService.getUserType() && <td></td>}
            <td></td>
          </tr>
        </table>
      </div>
    </>
  );
};

export const NextQuotasTable = ({ table }) => {
  const { header, watch, options, paymentDate } = table;

  if (
    ![paymentType?.CASHEA, paymentType?.FINANCIADO].includes(
      watch('paymentType')
    )
  ) {
    return null;
  }

  if (!watch('paymentMethodsQuantity') || !watch('billAmount')) {
    return null;
  }

  // If no quota plan is set dont show the table
  if (
    [paymentType?.CASHEA].includes(watch('paymentType')) &&
    (!watch('numCasheaDues') || !watch('referenceCashea'))
  ) {
    return null;
  }

  const handleTime = () => {
    if ([paymentType?.FINANCIADO].includes(watch('paymentType'))) {
      return options?.secondQuotaTime;
    }
    if ([paymentType?.CASHEA].includes(watch('paymentType'))) {
      return options?.casheaQuotaTime;
    } else return 0;
  };

  return (
    <>
      {table.label && <h5 style={{ marginTop: '12px' }}>Fechas de pago</h5>}
      <table className="table cashea-payments-table">
        <tr>
          {header?.map((h, i) => {
            if (
              [paymentType?.CASHEA].includes(watch('paymentType')) &&
              h?.name === 'Monto Bs'
            ) {
              return;
            }

            return (
              <th key={h?.name + i} style={{ display: h?.hide ? 'none' : '' }}>
                {h?.name}
              </th>
            );
          })}
        </tr>

        {Array.from({
          length: [paymentType?.CASHEA].includes(watch('paymentType'))
            ? parseFloat(watch('numCasheaDues'))
            : 1,
        }).map((_, i) => (
          <tr key={i}>
            <td>Cuota {i + 1}</td>
            <td>
              {moment(
                new Date(paymentDate || '').setMonth(
                  new Date(paymentDate || '').getMonth() + 1
                )
              ).format('DD/MM/YYYY')}
            </td>
            <td>{watch(`financialAmount${i}`)}</td>

            {![paymentType?.CASHEA].includes(watch('paymentType')) && (
              <td>{watch(`financialAmountBsS${i}`)}</td>
            )}
          </tr>
        ))}

        <tr>
          <td style={{ padding: '12px' }}>
            <b style={{ fontSize: '14px' }}>Total</b>
          </td>
          <td></td>
          <td>
            <b>
              {sumTotal(
                watch,
                'financialAmount',
                [paymentType?.CASHEA].includes(watch('paymentType'))
                  ? parseFloat(watch('numCasheaDues'))
                  : 1
              )}
            </b>
          </td>
          {![paymentType?.CASHEA].includes(watch('paymentType')) && (
            <td>
              <b>
                {sumTotal(
                  watch,
                  'financialAmountBsS',
                  [paymentType?.CASHEA].includes(watch('paymentType'))
                    ? parseFloat(watch('numCasheaDues'))
                    : 1
                )}
              </b>
            </td>
          )}
        </tr>
      </table>
    </>
  );
};
export const ValitatePaymentsTable = (props) => {
  const { header, data, title, handlePageChange, action } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="sales-afiliation-table table">
          <tr
            style={{
              backgroundColor: '#fff',
            }}
          >
            {header?.map((h) => (
              <th style={{ fontSize: '13px' }} key={h?.name || h?.value}>
                {h?.name}
              </th>
            ))}
          </tr>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => {
              return (
                <tr key={d?._id}>
                  <td data-column="action">
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                      }}
                    >
                      <a
                        href={`${editURL}/${d?.membership?._id}`}
                        rel="noreferrer"
                        target="_blank"
                      >
                        <div className="table-action-button">
                          <img target="_blank" src={editLogo} alt="editLogo" />
                        </div>
                      </a>
                    </div>
                  </td>
                  <td>{d?.membershipId}</td>
                  <td>
                    {d?.createdAt
                      ? moment(d?.createdAt).format('DD/MM/YYYY')
                      : ''}
                  </td>
                  <td>
                    {!['Upgrade'].includes(d?.concept)
                      ? `${capitalize(d?.user?.firstName)} ${capitalize(
                        d?.user?.lastName
                      )}`
                      : `${capitalize(
                        d?.membership?.seller?.[0]?.firstName
                      )} ${capitalize(d?.membership?.seller?.[0]?.lastName)}`}
                  </td>
                  <td>{d?.membership?.priceInfo?.finalPrice}</td>
                  <td>{d?.membership?.paymentType}</td>
                  <td>{d?.amount}</td>
                  <td>{d?.totalAmountInBsS}</td>
                  <td>{d?.method}</td>
                  <td>{d?.reference}</td>
                  <td>{d?.transactionBatch || ''}</td>
                  <td>
                    {d?.accHolder && d?.accHolder !== 'undefined'
                      ? d?.accHolder
                      : ''}
                  </td>
                  <td>{d?.observation}</td>
                  <td>
                    <a href={d?.referenceImg} rel="noreferrer" target="_blank">
                      Ver comprobante
                    </a>
                  </td>
                  <td>{d?.concept}</td>
                  <td>
                    {d?.status}
                    {d?.statusDetail ? ` - ${d?.statusDetail}` : ''}
                  </td>
                  <td>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                        height: '100%',
                      }}
                    >
                      <div
                        style={{
                          cursor: 'pointer',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          textAlign: 'center',
                          backgroundColor: '#F27730',
                          color: '#fff',
                          borderRadius: '100px',
                          padding: '2px 10px',
                          fontSize: '12px',
                          fontWeight: 'bold',
                          verticalAlign: 'middle',
                        }}
                        onClick={() => action(d)}
                      >
                        <p style={{ margin: 0 }}>Validar pago</p>
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })}
        </table>
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const CasheaLinkDeletedOrdersTable = (props) => {
  const { header, data, title, handlePageChange } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="sales-afiliation-table table">
          <tr
            style={{
              backgroundColor: '#fff',
            }}
          >
            {header?.map((h) => (
              <th style={{ fontSize: '13px' }} key={h?.name || h?.value}>
                {h?.name}
              </th>
            ))}
          </tr>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => {
              return (
                <tr key={d?._id}>
                  <td>{d?.membershipId}</td>
                  <td>{d?.statusDescription}</td>
                  <td>{d?.firstName}</td>
                  <td>{d?.lastName}</td>
                  <td>{d?.plate}</td>
                  <td>{d?.casheaRef}</td>
                  <td>{d?.casheaStatus}</td>
                </tr>
              );
            })}
        </table>
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      </div>
      {/* <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div> */}
    </>
  );
};

export const AdvancedPaymentsTable = (props) => {
  const { header, data, title, handlePageChange, action, user, userRole } =
    props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="sales-afiliation-table table">
          <tr
            style={{
              backgroundColor: '#fff',
            }}
          >
            {header?.map((h) => (
              <th
                style={{ fontSize: '13px', minWidth: '150px' }}
                key={h?.name || h?.value}
              >
                {h?.name}
              </th>
            ))}
          </tr>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => {
              return (
                <tr key={d?._id}>
                  <td>{d?.membershipIdNumber}</td>
                  <td>{d?.loadDateStr}</td>
                  <td>{d?.paymentDateStr}</td>
                  <td>
                    {d?.responsibleAdvisorFullName
                      ? capitalize(d?.responsibleAdvisorFullName)
                      : ''}
                  </td>
                  <td>{d?.amount}</td>
                  <td>{d?.amountBsS}</td>
                  <td>{d?.paymentMethodName}</td>
                  <td>{d?.reference}</td>
                  <td>
                    <a href={d?.referenceImg} rel="noreferrer" target="_blank">
                      Ver comprobante
                    </a>
                  </td>
                  <td>{d?.paymentType}</td>
                  <td>{d?.casheaRef}</td>
                  <td>{d?.paymentStatus}</td>
                  <td>{d?.createdAtStr}</td>
                  <td>{d?.customerName}</td>
                  <td>{d?.customerIdentification}</td>
                  <td>{d?.phoneNumber}</td>

                  <td>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                        height: '100%',
                        flexDirection: 'column',
                      }}
                    >
                      <div
                        style={{
                          cursor: 'pointer',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          textAlign: 'center',
                          backgroundColor: '#F27730',
                          color: '#fff',
                          borderRadius: '100px',
                          padding: '2px 10px',
                          fontSize: '12px',
                          fontWeight: 'bold',
                          verticalAlign: 'middle',
                          marginBottom: '5px',
                        }}
                        onClick={() => action.edit(d)}
                      >
                        <p style={{ margin: 0 }}>Editar pago</p>
                      </div>

                      {d?.paymentStatus === 'Pendiente' &&
                        [
                          salesRoles?.SALES_ADMIN,
                          salesRoles?.SALES_ADMIN_AUX,
                          salesRoles?.SALES_DEVELOPER,
                        ].includes(userRole) && (
                          <div
                            style={{
                              cursor: 'pointer',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              textAlign: 'center',
                              backgroundColor: '#F27730',
                              color: '#fff',
                              borderRadius: '100px',
                              padding: '2px 10px',
                              fontSize: '12px',
                              fontWeight: 'bold',
                              verticalAlign: 'middle',
                            }}
                            onClick={() => action.validate(d?._id)}
                          >
                            <p style={{ margin: 0 }}>Validar pago</p>
                          </div>
                        )}
                    </div>
                  </td>
                </tr>
              );
            })}
        </table>
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const PaymentsChangesTable = (props) => {
  const { header, data, title, handlePageChange, action } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="sales-afiliation-table table">
          <tr
            style={{
              backgroundColor: '#fff',
            }}
          >
            {header?.map((h) => (
              <th style={{ fontSize: '13px' }} key={h?.name || h?.value}>
                {h?.name}
              </th>
            ))}
          </tr>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => {
              return (
                <tr key={d?._id}>
                  <td>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                      }}
                    >
                      <a
                        href={`${editURL}/${d?.membership}`}
                        rel="noreferrer"
                        target="_blank"
                      >
                        <div className="table-action-button">
                          <img target="_blank" src={editLogo} alt="editLogo" />
                        </div>
                      </a>
                    </div>
                  </td>
                  <td>{d?.membershipId}</td>
                  <td>
                    {d?.paymentDate
                      ? moment(d?.paymentDate).format('DD/MM/YYYY')
                      : ''}
                  </td>
                  <td>{capitalize(d?.sellerName)}</td>
                  <td>{d?.invoicedAmount}</td>
                  <td>{d?.paidAmount}</td>
                  <td>{d?.changeAmount}</td>
                  <td>{d?.changeAmountBs}</td>
                  <td>{d?.methodName}</td>
                  <td>
                    {d?.bank ? (
                      <div>
                        <h6 style={{ fontSize: '12px' }}>
                          <b>Banco:</b>{' '}
                          {
                            banksOptions?.find(
                              (option) => option._id === d?.bank
                            )?.name
                          }
                        </h6>
                        <h6 style={{ fontSize: '12px' }}>
                          <b>Telefono:</b> {d?.phone}
                        </h6>
                        <h6 style={{ fontSize: '12px' }}>
                          <b>CI/RIF:</b>{' '}
                          {d?.identificationType + '-' + d?.identification}
                        </h6>
                      </div>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>{d?.changeType}</td>
                  <td>{d?.description}</td>
                  <td>{d?.observation}</td>
                  <td>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                        height: '100%',
                      }}
                    >
                      <div
                        style={{
                          cursor: 'pointer',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          textAlign: 'center',
                          backgroundColor: '#F27730',
                          color: '#fff',
                          borderRadius: '100px',
                          padding: '2px 10px',
                          fontSize: '12px',
                          fontWeight: 'bold',
                          verticalAlign: 'middle',
                        }}
                        onClick={() => action(d)}
                      >
                        <p style={{ margin: 0 }}>Editar vuelto</p>
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })}
        </table>
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const GoalsTables = (props) => {
  const { header, data, createAction, editAction } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div
        style={{
          backgroundColor: '#e2e2e2',
          padding: '10px',
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <h5 style={{ margin: '0px' }}>
          {capitalize(`Metas ${transcriptRoles(data?.roleName)}`)}
        </h5>
        <AltButton label={'Nueva Meta'} action={createAction} />
      </div>
      <div className="table-container">
        <table
          className="table"
          style={{
            borderCollapse: 'collapse',
            marginBottom: '20px',
            textAlign: 'left',
          }}
        >
          <tr
            style={{
              backgroundColor: '#fff',
              borderBottom: '1px solid #000',
            }}
          >
            {header?.map((h) => (
              <th style={{ width: '1%' }} key={h?.name}>
                {h?.name}
              </th>
            ))}
          </tr>
          {data?.items?.length > 0 &&
            !data?.isLoading &&
            data?.items?.map((d) => {
              return (
                <tr key={d?._id}>
                  <td>{parseFloat(d?.year)}</td>
                  <td>
                    {filterOptionById(monthsComissionsOptions, d?.month)?.name}
                  </td>
                  <td>{parseFloat(d?.groupGoal).toFixed(2)}</td>
                  <td
                    style={{
                      textAlign: 'center',
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    {
                      <ActionButton
                        bootstrap={'col-12 col-md-2 center'}
                        label={'Ver Listado de Asesores'}
                        color={'#fff'}
                        action={() => editAction(d)}
                      />
                    }
                  </td>
                </tr>
              );
            })}
        </table>
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
        {data?.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
        )}
      </div>
    </>
  );
};

const geographicPageCount = (data) =>
  Math.max(1, Math.ceil((data?.count || 0) / (data?.limit || 1)));

/** Contador + registros por página (Parámetros); omitir props para ocultar. */
const ParametersTableFooter = ({
  count,
  limit,
  itemsPerPageOptions,
  onPerPageChange,
  inactiveCount = 0,
}) => {
  if (!itemsPerPageOptions || !onPerPageChange) return null;
  const total = Number(count) || 0;
  const inactive = inactiveCount ?? 0;
  const activeCount = Math.max(0, total - inactive);
  return (
    <div className="geographic-table__footer geographic-table__footer--split">
      <span>
        {total} {total === 1 ? 'registro' : 'registros'}
        {activeCount > 0 &&
          ` — ${activeCount} activo${activeCount === 1 ? '' : 's'}`}
        {inactive > 0 && ` — ${inactive} inactivo${inactive === 1 ? '' : 's'}`}
      </span>
      <SelectPerPage
        label="Registros por página"
        options={itemsPerPageOptions}
        value={limit}
        onChange={onPerPageChange}
      />
    </div>
  );
};

export const GeographicStatesTable = (props) => {
  const {
    header,
    data,
    handlePageChange,
    childLabel,
    onToggleActive,
    onEdit,
    itemsPerPageOptions,
    onPerPageChange,
    inactiveCount,
  } = props;

  return (
    <>
      <table className="table">
        <thead>
          <tr>
            {header?.map((h) => (
              <th key={h?.value || h?.name}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignContent: 'center',
                  }}
                >
                  {h?.name}
                  {h?.sortable && (
                    <TableFilter
                      label={h.name}
                      options={h.filterOptions}
                      onSearch={h.filterSearch}
                    />
                  )}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => (
              <tr key={d?._id}>
                <td>{capitalize(d?.name)}</td>
                <TableCellChildRecordsBadge
                  count={d?.citiesCount}
                  childLabel={childLabel}
                />
                <TableCellActiveStatus isActive={d?.isActive} />
                <td>
                  <div className="buttons-center-container mb-0">
                    <TableActionButton
                      src={editLogo}
                      action={() => onEdit(d)}
                    />
                    <Switch
                      checked={Boolean(d?.isActive)}
                      onChange={() => onToggleActive(d)}
                      color="primary"
                    />
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      {data?.data?.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={geographicPageCount(data)}
          variant="outlined"
          shape="rounded"
          page={data?.page || 1}
          onChange={handlePageChange}
        />
      </div>
      <ParametersTableFooter
        count={data?.count ?? 0}
        limit={data?.limit}
        itemsPerPageOptions={itemsPerPageOptions}
        onPerPageChange={onPerPageChange}
        inactiveCount={inactiveCount}
      />
    </>
  );
};

export const GeographicCitiesTable = (props) => {
  const {
    header,
    data,
    handlePageChange,
    childLabel,
    onToggleActive,
    onEdit,
    itemsPerPageOptions,
    onPerPageChange,
    inactiveCount,
  } = props;

  return (
    <>
      <table className="table">
        <thead>
          <tr>
            {header?.map((h) => (
              <th key={h?.value || h?.name}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignContent: 'center',
                  }}
                >
                  {h?.name}
                  {h?.sortable && (
                    <TableFilter
                      label={h.name}
                      options={h.filterOptions}
                      onSearch={h.filterSearch}
                    />
                  )}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => (
              <tr key={d?._id}>
                <td>{capitalize(d?.name)}</td>
                <td>{capitalize(d?.state?.name)}</td>
                <TableCellChildRecordsBadge
                  count={d?.municipalitiesCount}
                  childLabel={childLabel}
                />
                <TableCellActiveStatus isActive={d?.isActive} />
                <td>
                  <div className="buttons-center-container mb-0">
                    <TableActionButton
                      src={editLogo}
                      action={() => onEdit(d)}
                    />
                    <Switch
                      checked={Boolean(d?.isActive)}
                      onChange={() => onToggleActive(d)}
                      color="primary"
                    />
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      {data?.data?.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={geographicPageCount(data)}
          variant="outlined"
          shape="rounded"
          page={data?.page || 1}
          onChange={handlePageChange}
        />
      </div>
      <ParametersTableFooter
        count={data?.count ?? 0}
        limit={data?.limit}
        itemsPerPageOptions={itemsPerPageOptions}
        onPerPageChange={onPerPageChange}
        inactiveCount={inactiveCount}
      />
    </>
  );
};

export const GeographicMunicipalitiesTable = (props) => {
  const {
    header,
    data,
    handlePageChange,
    onToggleActive,
    onEdit,
    itemsPerPageOptions,
    onPerPageChange,
    inactiveCount,
  } = props;

  return (
    <>
      <table className="table">
        <thead>
          <tr>
            {header?.map((h) => (
              <th key={h?.value || h?.name}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignContent: 'center',
                  }}
                >
                  {h?.name}
                  {h?.sortable && (
                    <TableFilter
                      label={h.name}
                      options={h.filterOptions}
                      onSearch={h.filterSearch}
                    />
                  )}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => (
              <tr key={d?._id}>
                <td>{capitalize(d?.name)}</td>
                <td>{d?.city?.name}</td>
                <td>
                  {capitalize(
                    d?.city?.state?.name ??
                    (typeof d?.city?.state === 'string'
                      ? d?.city?.state
                      : '') ??
                    d?.city?.stateName ??
                    d?.state?.name ??
                    ''
                  )}
                </td>
                <TableCellActiveStatus isActive={d?.isActive} />
                <td>
                  <div className="buttons-center-container mb-0">
                    <TableActionButton
                      src={editLogo}
                      action={() => onEdit(d)}
                    />
                    <Switch
                      checked={Boolean(d?.isActive)}
                      onChange={() => onToggleActive(d)}
                      color="primary"
                    />
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      {data?.data?.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={geographicPageCount(data)}
          variant="outlined"
          shape="rounded"
          page={data?.page || 1}
          onChange={handlePageChange}
        />
      </div>
      <ParametersTableFooter
        count={data?.count ?? 0}
        limit={data?.limit}
        itemsPerPageOptions={itemsPerPageOptions}
        onPerPageChange={onPerPageChange}
        inactiveCount={inactiveCount}
      />
    </>
  );
};

export const VehicularTypesTable = (props) => {
  const {
    header,
    data,
    handlePageChange,
    onToggleActive,
    onEdit,
    itemsPerPageOptions,
    onPerPageChange,
    inactiveCount,
  } = props;

  return (
    <>
      <table className="table">
        <thead>
          <tr>
            {header?.map((h) => (
              <th key={h?.value || h?.name}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignContent: 'center',
                  }}
                >
                  {h?.name}
                  {h?.sortable && (
                    <TableFilter
                      label={h.name}
                      options={h.filterOptions}
                      onSearch={h.filterSearch}
                    />
                  )}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => (
              <tr key={d?._id}>
                <td>{capitalize(d?.type)}</td>
                <TableCellVehicularClassBadge
                  label={d?.vehicleClassName}
                  variant={d?.vehicleClassVariant || 'default'}
                />
                <TableCellActiveStatus isActive={d?.isActive} />
                <td>
                  <div className="buttons-center-container mb-0">
                    <TableActionButton
                      src={editLogo}
                      action={() => onEdit(d)}
                    />
                    <Switch
                      checked={Boolean(d?.isActive)}
                      onChange={() => onToggleActive(d)}
                      color="primary"
                    />
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      {data?.data?.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={geographicPageCount(data)}
          variant="outlined"
          shape="rounded"
          page={data?.page || 1}
          onChange={handlePageChange}
        />
      </div>
      <ParametersTableFooter
        count={data?.count ?? 0}
        limit={data?.limit}
        itemsPerPageOptions={itemsPerPageOptions}
        onPerPageChange={onPerPageChange}
        inactiveCount={inactiveCount}
      />
    </>
  );
};

export const VehicularBrandsTable = (props) => {
  const {
    header,
    data,
    handlePageChange,
    childLabel,
    onToggleActive,
    onEdit,
    itemsPerPageOptions,
    onPerPageChange,
    inactiveCount,
  } = props;
  return (
    <>
      <table className="table">
        <thead>
          <tr>
            {header?.map((h) => (
              <th key={h?.value || h?.name}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignContent: 'center',
                  }}
                >
                  {h?.name}
                  {h?.sortable && (
                    <TableFilter
                      label={h.name}
                      options={h.filterOptions}
                      onSearch={h.filterSearch}
                    />
                  )}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => (
              <tr key={d?._id}>
                <td>{capitalize(d?.brand)}</td>
                <TableCellChildRecordsBadge
                  count={d?.childrenModelsCount}
                  childLabel={childLabel}
                />
                <TableCellActiveStatus isActive={d?.isActive} />
                <td>
                  <div className="buttons-center-container mb-0">
                    <TableActionButton
                      src={editLogo}
                      action={() => onEdit(d)}
                    />
                    <Switch
                      checked={Boolean(d?.isActive)}
                      onChange={() => onToggleActive(d)}
                      color="primary"
                    />
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      {data?.data?.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={geographicPageCount(data)}
          variant="outlined"
          shape="rounded"
          page={data?.page || 1}
          onChange={handlePageChange}
        />
      </div>
      <ParametersTableFooter
        count={data?.count ?? 0}
        limit={data?.limit}
        itemsPerPageOptions={itemsPerPageOptions}
        onPerPageChange={onPerPageChange}
        inactiveCount={inactiveCount}
      />
    </>
  );
};

export const VehicularModelsTable = (props) => {
  const {
    header,
    data,
    handlePageChange,
    onToggleActive,
    onEdit,
    itemsPerPageOptions,
    onPerPageChange,
    inactiveCount,
  } = props;

  return (
    <>
      <table className="table">
        <thead>
          <tr>
            {header?.map((h) => (
              <th key={h?.value || h?.name}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignContent: 'center',
                  }}
                >
                  {h?.name}
                  {h?.sortable && (
                    <TableFilter
                      label={h.name}
                      options={h.filterOptions}
                      onSearch={h.filterSearch}
                    />
                  )}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => (
              <tr key={d?._id}>
                <td>{capitalize(d?.name ?? d?.model ?? '')}</td>
                <td>
                  {capitalize(
                    d?.brandName ??
                    (typeof d?.brandId === 'object' && d?.brandId
                      ? (d?.brandId?.brand ?? d?.brandId?.name ?? '')
                      : '')
                  )}
                </td>
                <TableCellActiveStatus isActive={d?.isActive} />
                <td>
                  <div className="buttons-center-container mb-0">
                    <TableActionButton
                      src={editLogo}
                      action={() => onEdit(d)}
                    />
                    <Switch
                      checked={Boolean(d?.isActive)}
                      onChange={() => onToggleActive(d)}
                      color="primary"
                    />
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      {data?.data?.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={geographicPageCount(data)}
          variant="outlined"
          shape="rounded"
          page={data?.page || 1}
          onChange={handlePageChange}
        />
      </div>
      <ParametersTableFooter
        count={data?.count ?? 0}
        limit={data?.limit}
        itemsPerPageOptions={itemsPerPageOptions}
        onPerPageChange={onPerPageChange}
        inactiveCount={inactiveCount}
      />
    </>
  );
};

export const CommercialTable = (props) => {
  const {
    header,
    data,
    handlePageChange,
    onToggleActive,
    onEdit,
    itemsPerPageOptions,
    onPerPageChange,
    inactiveCount,
  } = props;

  return (
    <>
      <table className="table">
        <thead>
          <tr>
            {header?.map((h) => (
              <th key={h?.value || h?.name}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignContent: 'center',
                  }}
                >
                  {h?.name}
                  {h?.sortable && (
                    <TableFilter
                      label={h.name}
                      options={h.filterOptions}
                      onSearch={h.filterSearch}
                    />
                  )}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => (
              <tr key={d?._id}>
                <td>{capitalize(d?.name ?? '')}</td>
                <td>{capitalize(d?.shortName ?? '')}</td>
                <td>{d?.qrId?.toUpperCase() ?? ''}</td>
                <td>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      columnGap: '8px',
                    }}
                  >
                    {d.links.length > 0 &&
                      d.links.map((link, index) => (
                        <TableSalesChannelLinksClassBadge
                          key={index}
                          label={link?.label}
                          link={link?.link}
                          variant="moto"
                        />
                      ))}
                  </div>
                </td>
                <td>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      columnGap: '8px',
                    }}
                  >
                    {d.qrCodes.length > 0 &&
                      d.qrCodes.map((qrCode, index) => (
                        <TableSalesChannelLinksClassBadge
                          key={index}
                          label={qrCode?.label}
                          link={qrCode?.link}
                          variant="qrcode"
                        />
                      ))}
                  </div>
                </td>
                <TableCellActiveStatus isActive={d?.isActive} />
                <td>
                  <div className="buttons-center-container mb-0">
                    <TableActionButton
                      src={editLogo}
                      action={() => onEdit(d)}
                    />
                    <Switch
                      checked={Boolean(d?.isActive)}
                      onChange={() => onToggleActive(d)}
                      color="primary"
                    />
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      {data?.data?.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
      <ParametersTableFooter
        count={data?.count ?? 0}
        limit={data?.limit}
        itemsPerPageOptions={itemsPerPageOptions}
        onPerPageChange={onPerPageChange}
        inactiveCount={inactiveCount}
      />
    </>
  );
};

export const SurchargesTable = (props) => {
  const {
    header,
    data,
    handlePageChange,
    onToggleActive,
    onEdit,
    itemsPerPageOptions,
    onPerPageChange,
    inactiveCount,
  } = props;

  return (
    <>
      <table className="table">
        <thead>
          <tr>
            {header?.map((h) => (
              <th key={h?.value || h?.name}>{h?.name}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => (
              <tr key={d?._id}>
                <td>{capitalize(d?.saleChannel?.channel ?? '')}</td>
                <td>
                  {d.contractTypes.length > 0 &&
                    d.contractTypes.map((contractType, index) => (
                      <TableSalesChannelLinksClassBadge
                        key={index}
                        label={contractType}
                        link={null}
                        variant={
                          contractType === 'Particular'
                            ? 'moto'
                            : contractType === 'Flota Técnica'
                              ? 'qrcode'
                              : 'default'
                        }
                      />
                    ))}
                </td>
                <TableCellStatusIcon isActive={d?.useRenewSurcharge ?? false} />
                <TableCellStatusIcon isActive={d?.useRenewDiscount ?? false} />
                <td style={{ textAlign: 'center' }}>{d?.description ?? ''}</td>
                <TableCellActiveStatus isActive={d?.isActive} />

                <td>
                  <div className="buttons-center-container mb-0">
                    <TableActionButton
                      src={editLogo}
                      action={() => onEdit(d)}
                    />
                    <Switch
                      checked={Boolean(d?.isActive)}
                      onChange={() => onToggleActive(d)}
                      color="primary"
                    />
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      {data?.data?.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={geographicPageCount(data)}
          variant="outlined"
          shape="rounded"
          page={data?.page || 1}
          onChange={handlePageChange}
        />
      </div>
      <ParametersTableFooter
        count={data?.count ?? 0}
        limit={data?.limit}
        itemsPerPageOptions={itemsPerPageOptions}
        onPerPageChange={onPerPageChange}
        inactiveCount={inactiveCount}
      />
    </>
  );
};


export const CampaignTable = (props) => {
  const {
    header,
    data,
    handlePageChange,
    onToggleActive,
    onEdit,
    itemsPerPageOptions,
    onPerPageChange,
    inactiveCount,
  } = props;

  return (
    <>
      <table className="table">
        <thead>
          <tr>
            {header?.map((h) => (
              <th key={h?.value || h?.name}>{h?.name}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => (
              <tr key={d?._id}>
                <td>{capitalize(d?.campaignName ?? '')}</td>
                <td style={{ textAlign: 'center' }}>
                  {d?.delay ?? ''}
                </td>
                <td style={{ textAlign: 'center' }}>
                  {`${d?.dateSince ? moment(d?.dateSince).format('DD/MM/YYYY') : ''} - ${d?.dateUntil ? moment(d?.dateUntil).format('DD/MM/YYYY') : ''}`}
                </td>
                <TableCellActiveStatusCampaign isActive={d?.status} />
                <td style={{ textAlign: 'center' }}>
                  {d?.note ?? ''}
                </td>
                <td>
                  <div className="buttons-center-container mb-0">

                    {(d?.status !== 'eliminada') && (
                      <TableActionButton
                        src={editLogo}
                        action={() => onEdit(d)}
                      />
                    )}
                    {(d?.status !== 'vencida' && d?.status !== 'eliminada') && (
                      <DeleteButton
                        action={() => onToggleActive(d)}
                      />
                    )}
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      {data?.data?.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={geographicPageCount(data)}
          variant="outlined"
          shape="rounded"
          page={data?.page || 1}
          onChange={handlePageChange}
        />
      </div>
      <ParametersTableFooter
        count={data?.count ?? 0}
        limit={data?.limit}
        itemsPerPageOptions={itemsPerPageOptions}
        onPerPageChange={onPerPageChange}
        inactiveCount={inactiveCount}
      />
    </>
  );
};

export const LandingDiiscountTable = (props) => {
  const {
    header,
    data,
    handlePageChange,
    onToggleActive,
    onEdit,
    itemsPerPageOptions,
    onPerPageChange,
    inactiveCount,
  } = props;

  const DISCOUNT_LANDING = {
    PUBLIC: 'Publica',
    INTERNAL: 'Privada',
    RENEWAL: 'Renewal',
    SELF_RENEWAL: 'selfRenewal',
  };

  const landingOptions = [
    { value: DISCOUNT_LANDING.PUBLIC, label: 'Afil. nueva - Web' },
    { value: DISCOUNT_LANDING.RENEWAL, label: 'Renov. - L. interno' },
    { value: DISCOUNT_LANDING.INTERNAL, label: 'Afil. nueva - L. interno' },
    { value: DISCOUNT_LANDING.SELF_RENEWAL, label: 'Renov. - Web' },
  ];

  const LANDING_DISCOUNT_CAMPAIGN_STATUS = {
    CREADA: 'Creada',
    ACTIVO: 'Activo',
    VENCIDO: 'Vencido',
    INACTIVO: 'Inactivo',
  };

  return (
    <>
      <table className="table">
        <thead>
          <tr>
            {header?.map((h) => (
              <th key={h?.value || h?.name}>{h?.name}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => (
              <tr key={d?._id}>
                <td>{d?.discountCode?.code ?? ''}</td>
                <td>{capitalize(d?.description ?? '')}</td>
                <td>
                  {`
                      ${d?.startDate
                      ? moment(d?.startDate).format('DD/MM/YYYY')
                      : ''
                    } - 
                    ${d?.expirationDate
                      ? moment(d?.expirationDate).format('DD/MM/YYYY')
                      : ''
                    }
                    `}
                </td>
                <td>
                  {d.landings.length > 0 &&
                    d.landings.map((landing, index) => (
                      <TableCellVehicularClassBadge
                        key={index}
                        label={
                          landingOptions.find(
                            (option) => option.value === landing
                          )?.label || landing
                        }
                        link={null}
                        variant="landing"
                      />
                    ))}
                </td>
                <TableCellActiveStatusDiscount
                  isActive={
                    LANDING_DISCOUNT_CAMPAIGN_STATUS[
                    d?.status.toUpperCase()
                    ] === 'Activo'
                  }
                  label={
                    LANDING_DISCOUNT_CAMPAIGN_STATUS[d?.status.toUpperCase()]
                  }
                />

                <td>
                  <div className="buttons-center-container mb-0">
                    <TableActionButton
                      src={editLogo}
                      action={() => onEdit(d)}
                    />
                    {LANDING_DISCOUNT_CAMPAIGN_STATUS[
                      d?.status.toUpperCase()
                    ] !== 'Inactivo' &&
                      LANDING_DISCOUNT_CAMPAIGN_STATUS[
                      d?.status.toUpperCase()
                      ] !== 'Vencido' && (
                        <Switch
                          checked={Boolean(d?.status === 'Activo')}
                          onChange={() => onToggleActive(d)}
                          color="primary"
                        />
                      )}
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      {data?.data?.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={geographicPageCount(data)}
          variant="outlined"
          shape="rounded"
          page={data?.page || 1}
          onChange={handlePageChange}
        />
      </div>
      <ParametersTableFooter
        count={data?.count ?? 0}
        limit={data?.limit}
        itemsPerPageOptions={itemsPerPageOptions}
        onPerPageChange={onPerPageChange}
        inactiveCount={inactiveCount}
      />
    </>
  );
};
